/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
// This file is auto-generated. Do not edit manually.

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeOffset: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Milliseconds: { input: any; output: any; }
  Seconds: { input: any; output: any; }
};

/** Provides fields to query or updates entities with address properties. */
export type AddressInput = {
  /** The suburb/city component of the address, such as New York. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The country component of the address, such as USA. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The geographic position associated with the address. */
  position?: InputMaybe<InputPositionType>;
  /** The postcode/zip code component of the address, such as 10001. */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** The state component of the address, such as NY. */
  state?: InputMaybe<Scalars['String']['input']>;
  /** The primary street address details, such as 20 West 34th Street. */
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  /** The secondary street address details, such as 86th floor. */
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an address in the world, such as where a device is located, or a person lives or works */
export type AddressType = {
  __typename?: 'AddressType';
  /** The suburb/city component of the address, such as New York. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country component of the address, such as USA */
  country?: Maybe<Scalars['String']['output']>;
  /** The geographic position associated with the address */
  position?: Maybe<PositionType>;
  /** The postcode/zip code component of the address, such as 10001 */
  postcode?: Maybe<Scalars['String']['output']>;
  /** The state component of the address, such as NY */
  state?: Maybe<Scalars['String']['output']>;
  /** The primary street address details, such as 20 West 34th Street. */
  streetAddress?: Maybe<Scalars['String']['output']>;
  /** The secondary street address details, such as 86th floor. */
  streetAddress2?: Maybe<Scalars['String']['output']>;
};

/** An average the percentage of passenger loads per aircraft.This data will be reflected in the emissions per pessagenger and per passenger kilometer travelled. */
export type AilineLoadFactors = {
  __typename?: 'AilineLoadFactors';
  /** The type of the flight's aircraft, typically an ICAO code associated with a aircraft load factors. */
  aircraftType: Scalars['String']['output'];
  /** The airline. */
  airline: Scalars['String']['output'];
  /** Day of week, to which the given load factor will be applied. */
  dayOfWeek: Scalars['String']['output'];
  /** The destination airport. */
  destination: Scalars['String']['output'];
  /** The end time, that determines end of the time range that the LoadFactor applies for. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** Mapped enroute aircraft of a AirlineMapping. */
  id: Scalars['Int']['output'];
  /** The percentage of the seats that are occupied in a flight. */
  loadFactor: Scalars['Float']['output'];
  /** The origin airport. */
  origin: Scalars['String']['output'];
  /** Id of a scenario, a unique airquality configuration. */
  scenarioId: Scalars['Int']['output'];
  /** The start time, that determines start of the time range that the LoadFactor applies for. */
  startTime: Scalars['DateTimeOffset']['output'];
};

/** An individual record that summarizes the aircraft types and engines for flights showing the associated Air Quality LTO and Enroute aircraft/engine types, and the number of flights that fall within the Aircraft Type and Engine Model grouping. */
export type AirQualityAircraftMappingSummary = {
  __typename?: 'AirQualityAircraftMappingSummary';
  /** The Aircraft Type of the summary record. */
  aircraftType: Scalars['String']['output'];
  /** The Engine Model of the summary record. */
  engineModel: Scalars['String']['output'];
  /** The en-route aircraft and engine model mapped to the Aircraft Type and Engine Model. */
  mappedEnrouteAircraftEngine: Scalars['String']['output'];
  /** The Landing and Take-off (LTO) aircraft and engine model mapped to the Aircraft Type and Engine Model. */
  mappedLTOAircraftEngine: Scalars['String']['output'];
  /** The number of flights that have the same Aircraft Type and Engine Model within the queried time range that generated the model. */
  numberOfFlights: Scalars['Int']['output'];
  /** The source of the mapping (i.e. System, User) */
  source?: Maybe<AirQualityMappingSource>;
  /** The system defined en-route aircraft and engine model mapped to the Aircraft Type and Engine Model. */
  systemMappedEnrouteAircraftEngine: Scalars['String']['output'];
  /** The system defined Landing and Take-off (LTO) aircraft and engine model mapped to the Aircraft Type and Engine Model. */
  systemMappedLTOAircraftEngine: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `AirQualityAircraftMappingSummary`. */
export type AirQualityAircraftMappingSummaryConnection = {
  __typename?: 'AirQualityAircraftMappingSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AirQualityAircraftMappingSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<AirQualityAircraftMappingSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `AirQualityAircraftMappingSummary`. */
export type AirQualityAircraftMappingSummaryEdge = {
  __typename?: 'AirQualityAircraftMappingSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AirQualityAircraftMappingSummary>;
};

/** A set of query options that can be used for retrieving AirQualityAircraftMappingSummary data model objects. */
export type AirQualityAircraftMappingSummaryFilter = {
  /** A list of aircraft types to use in the filter. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of airlines to use in the filter. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of engine models to use when filtering operation data. */
  engineModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of En-route emission aircraft and engine models to use in the filter. */
  enrouteAircraftEngines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of Landing TakeOff (LTO) emission aircraft and engine models to use in the filter. */
  lTOAircraftEngines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of operation types to use when filtering operation data. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
};

/** A set of AirQualityFilters */
export type AirQualityFilters = {
  /** The list of aircrafts to filter the emission data. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The list of airlines to filter the emission data. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The breakdown to group emission data by. */
  breakdown?: InputMaybe<Breakdown>;
  /** The list of emission types to filter the emission data. */
  emissions?: InputMaybe<Array<InputMaybe<EmissionEnum>>>;
  /** Maximum number of columns that will be returned in emission data. A null value indicates there is maximum number of columns to returned is not set and predefined number of columns will be returned specific to each breakdown. In addition 'Others' and 'Totals' columns are also returned when applied. */
  maxColumns?: InputMaybe<Scalars['Int']['input']>;
  /** Metrics used to calculate emission data totals. */
  metric?: InputMaybe<Metric>;
  /** The list of operation types to filter the emission data. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** The list of phases to filter the emission data. */
  phases?: InputMaybe<Array<InputMaybe<Phase>>>;
  /** The list of regions to filter the emission data. */
  regions?: InputMaybe<Array<InputMaybe<Region>>>;
  /** Unique id which defines a scenario of calculating the emission data based on time range and other related paramenters. */
  scenarioId?: InputMaybe<Scalars['Int']['input']>;
};

/** Enumerates the sources of data that Aircraft and Airline Mappings can come from. */
export enum AirQualityMappingSource {
  /** Indicates that the data is part of the System supplied source. */
  System = 'System',
  /** Indicates that the data is a User-supplied override. */
  User = 'User'
}

export type Aircraft = {
  __typename?: 'Aircraft';
  /** The AEDT aircraft id assigned to the aircraft, which is used when modeling contours in the AEDT modeling software. */
  aedtModelingAircraftId?: Maybe<Scalars['String']['output']>;
  /** The noise classification for the aircraft from the German AZB specification. */
  azbNoiseClassification?: Maybe<Scalars['String']['output']>;
  /** The noise classification for the aircraft from the ICAO aircraft noise specification, from Volume I of Annex 16. */
  icaoNoiseClassification?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the aircraft. */
  id: Scalars['Int']['output'];
  /** The INM aircraft id assigned to the aircraft, which is used when modeling contours in the INM modeling software. */
  inmModelingAircraftId?: Maybe<Scalars['String']['output']>;
  /** The the the maximum weight at which the aircraft is permitted to land, in kilograms. */
  maximumLandingWeight?: Maybe<Scalars['Float']['output']>;
  /** The maximum allowable weight of the aircraft while attempting take-off, in kilograms. */
  maximumTakeoffWeight?: Maybe<Scalars['Float']['output']>;
};

export enum AircraftCategory {
  /** Blimp (dirigible). */
  Blimp = 'Blimp',
  /** Business jet. */
  BusinessJet = 'BusinessJet',
  /** Cargo plane. */
  Cargo = 'Cargo',
  /** Commercial jet. */
  CommercialJet = 'CommercialJet',
  /** A helicopter. */
  Helicopter = 'Helicopter',
  /** A military aircraft (potentially also one of the other types in this list but operated by the military). */
  Military = 'Military',
  /** Propeller driven plane with a piston engine */
  Piston = 'Piston',
  /** Regional jet. */
  RegionalJet = 'RegionalJet',
  /** Propeller driven plane with a turboprop engine */
  Turboprop = 'Turboprop',
  /** Unknown plane type. */
  Unknown = 'Unknown'
}

/** An aircraft complaint that has been submitted to the system. */
export type AircraftComplaint = Complaint & {
  __typename?: 'AircraftComplaint';
  /** The comments made about the complaint when it was submitted. */
  comments?: Maybe<Scalars['String']['output']>;
  /** The id of the complainer who submitted the complaint. */
  complainerId: Scalars['Int']['output'];
  /**
   * The method used to submit the complaint.
   * @deprecated Use EnquiryMethod property instead; ContactMethod will always return NotSet.
   */
  contactMethod?: Maybe<ContactMethod>;
  /** A list of the types of disturbance being reported. */
  disturbanceTypes: Array<Scalars['String']['output']>;
  /** A list of activities that were disturbed by the event. */
  disturbedActivities: Array<Scalars['String']['output']>;
  /** The method used to submit the complaint. */
  enquiryMethod: Scalars['String']['output'];
  /** Indicates the type of submission. */
  enquiryType?: Maybe<ComplaintEnquiryType>;
  /** The unique id of the complaint. */
  id: Scalars['Int']['output'];
  /** A set of notes that have been made about the complaint */
  notes?: Maybe<Array<Maybe<Comment>>>;
  /** The id of the operation that is linked to the complaint, or null if there is no linked operation. */
  operationId?: Maybe<Scalars['Int']['output']>;
  /** The id of the privacy agreement that was in effect at the time the complaint was lodged. */
  privacyAgreementId?: Maybe<Scalars['Int']['output']>;
  /** The id of the complainer from which the complaint was originally lodged. */
  reportedComplainerId?: Maybe<Scalars['Int']['output']>;
  /** The time when the complaint was reported. */
  reportedTime: Scalars['DateTimeOffset']['output'];
  /** Whether the complainant asked for a response to the complaint. */
  responseRequired: Scalars['Boolean']['output'];
  /** The current status of the complaint. */
  status: Scalars['String']['output'];
  /** The time of the event that the complaint is about. */
  time: Scalars['DateTimeOffset']['output'];
};

/** A connection from an object to a list of objects of type `AircraftComplaint`. */
export type AircraftComplaintConnection = {
  __typename?: 'AircraftComplaintConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AircraftComplaintEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<AircraftComplaint>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Details of the link to be made between an aircraft complaint and an operation. */
export type AircraftComplaintCorrelationDetails = {
  /** The id of the operation to correlate to the complaint, or null to decorrelate the complaint from any operation. */
  operationId?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection from an object to another object of type `AircraftComplaint`. */
export type AircraftComplaintEdge = {
  __typename?: 'AircraftComplaintEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AircraftComplaint>;
};

/** Provides fields for updating a single aircraft complaint record. Only specify values that should be modified. */
export type AircraftComplaintInput = {
  /** The comments made about the complaint when it was submitted. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** The complainer submitting the aircraft complaint. */
  complainerId?: InputMaybe<Scalars['Int']['input']>;
  /** A List of reasons for the aircraft complaint, i.e Too Loud, To Low. */
  disturbanceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The id of the aircraft complaint. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The accepted privacy statement. */
  privacyAgreementId?: InputMaybe<Scalars['Int']['input']>;
  /** The time when the aircraft complaint was made. */
  reportedTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  /** A Value indicating whether the complainer expects a response. */
  responseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** The new status of the aircraft complaint. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** The time when the event occured. */
  time?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};

/** The aircraft and engine associated with the Enroute/LTO(Landing and Take-off Cycle) phases of a flight. */
export type AircraftEngineMapping = {
  __typename?: 'AircraftEngineMapping';
  /** Type of the flight's aircraft, typically an ICAO code associated Enroute/LTO(Landing and Take-off Cycle) of a flight. */
  aircraftType: Scalars['String']['output'];
  /** Engine associated with the Enroute/LTO(Landing and Take-off Cycle) aircraft of an flight. */
  engine: Scalars['String']['output'];
};

/** The number of flights asscoiated with an aircraft. */
export type AircraftFlights = {
  __typename?: 'AircraftFlights';
  /** The type of the flight's aircraft, typically an ICAO code. */
  aircraftType: Scalars['String']['output'];
  /** Airline associated with the flight. */
  airline: Scalars['String']['output'];
  /** Engine associated with the flight's aircraft. */
  engine: Scalars['String']['output'];
  /** The number of flights associated with the specific airline and aircraft. */
  numberOfFlights: Scalars['Int']['output'];
};

/** Different CO2(carbon-dioxide) emission factors for different fuel types. */
export type AircraftFuelMapping = {
  __typename?: 'AircraftFuelMapping';
  /** The type of the flight's aircraft, typically an ICAO code associated with a aircraft mapping. */
  aircraftType: Scalars['String']['output'];
  /** The airline. */
  airline: Scalars['String']['output'];
  /** Comment. */
  comment: Scalars['String']['output'];
  /** The engine. */
  engine: Scalars['String']['output'];
  /** The CO2 emission factor, which will be mutliplied by the amount of the fuel consumed to get the amount of CO2 generated. */
  factorCO2: Scalars['Float']['output'];
  /** Mapped enroute aircraft of a aircraftFuelMapping. */
  id: Scalars['Int']['output'];
  /** The percentage of flights. */
  percentage: Scalars['Float']['output'];
  /** Aircraft of a aircraftFuelMapping. */
  scenarioId: Scalars['Int']['output'];
};

/** AircraftFuelMapping Input, different CO2(carbon-dioxide) emission factors for different fuel types. */
export type AircraftFuelMappingInput = {
  /** The type of the flight's aircraft, typically an ICAO code associated with a aircraft mapping. */
  aircraftType?: InputMaybe<Scalars['String']['input']>;
  /** The airline. */
  airline?: InputMaybe<Scalars['String']['input']>;
  /** Comment. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The engine. */
  engine?: InputMaybe<Scalars['String']['input']>;
  /** CO2 emission factor, which will be mutliplied by the amount of the fuel consumed to get the amount of CO2 generated of a aircraftFuelMapping. */
  factorCO2?: InputMaybe<Scalars['Float']['input']>;
  /** Id of an aircraftFuelMapping. */
  id: Scalars['Int']['input'];
  /** The percentage of flights. */
  percentage?: InputMaybe<Scalars['Float']['input']>;
  /** Id of a scenario, a unique airquality configuration. */
  scenarioId: Scalars['Int']['input'];
};

/** Aircraft mappings, which maps aircraft to its associated LTO(Landing and Take-off Cycle) and Enroute aircrafts and engines to calculate emissions by airframe and engine type. */
export type AircraftMapping = {
  __typename?: 'AircraftMapping';
  /** The type of the flight's aircraft, typically an ICAO code associated with a aircraft mapping. */
  aircraftType: Scalars['String']['output'];
  /**
   * The default engine associated with a aircraft mapping.
   * @deprecated use engineModel instead.
   */
  engine?: Maybe<Scalars['String']['output']>;
  /** The default engine associated with a aircraft mapping. */
  engineModel: Scalars['String']['output'];
  /**
   * The id associated with a aircraft mapping.
   * @deprecated Id has been replaced by ScenarioId-Aircraft-EngineModel. Don't use this anymore
   */
  id?: Maybe<Scalars['ID']['output']>;
  /** The enroute aircraft mapped to the default aircraft. */
  mappedEnrouteAircraft?: Maybe<Scalars['String']['output']>;
  /** The enroute engine mapped to the default aircraft. */
  mappedEnrouteEngine?: Maybe<Scalars['String']['output']>;
  /** The lto(Landing and Take-off Cycle) aircraft mapped to the default aircraft. */
  mappedLTOAircraft?: Maybe<Scalars['String']['output']>;
  /** The lto(Landing and Take-off Cycle) engine mapped to the default aircraft. */
  mappedLTOEngine?: Maybe<Scalars['String']['output']>;
  /** Id of a scenario, a unique airquality configuration. */
  scenarioId: Scalars['Int']['output'];
  /** The source of the aircraft mapping. */
  source?: Maybe<AirQualityMappingSource>;
};

/** Aircraft mappings input, which maps aircraft to its associated LTO(Landing and Take-off Cycle) and Enroute aircrafts and engines to calculate emissions by airframe and engine type input. */
export type AircraftMappingInput = {
  /** The type of the flight's aircraft, typically an ICAO code associated with a aircraft mapping. */
  aircraftType: Scalars['String']['input'];
  /** The default engine associated with a aircraft mapping. */
  engine?: InputMaybe<Scalars['String']['input']>;
  /** The default engine associated with a aircraft mapping. */
  engineModel?: InputMaybe<Scalars['String']['input']>;
  /** The id associated with a aircraft mapping. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The enroute aircraft mapped to the default aircraft. */
  mappedEnrouteAircraft?: InputMaybe<Scalars['String']['input']>;
  /** The enroute engine mapped to the default aircraft. */
  mappedEnrouteEngine?: InputMaybe<Scalars['String']['input']>;
  /** The lto(Landing and Take-off Cycle) aircraft mapped to the default aircraft. */
  mappedLTOAircraft?: InputMaybe<Scalars['String']['input']>;
  /** The lto(Landing and Take-off Cycle) engine mapped to the default aircraft. */
  mappedLTOEngine?: InputMaybe<Scalars['String']['input']>;
  /** Id of a scenario, a unique airquality configuration. */
  scenarioId: Scalars['Int']['input'];
};

/**
 * Represents the output of noise modeling activity of flights at an airport.
 *
 *  A noise contour has a series of geographic bands that indicate the average noise characteristics that are experienced within each band's area.
 */
export type AircraftNoiseContour = {
  __typename?: 'AircraftNoiseContour';
  /** The bands that make up the contour. */
  bands?: Maybe<Array<Maybe<AircraftNoiseContourBand>>>;
  /** The time at which the contour was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The user who created the contour. */
  createdBy: Scalars['String']['output'];
  /** The description of the contour. */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the group to which the contour belongs. */
  groupName: Scalars['String']['output'];
  /** The unique id of the contour. */
  id: Scalars['Int']['output'];
  /** The time at which the contour was last updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The increment between each of the levels in the contour's bands. */
  levelIncrement: Scalars['Float']['output'];
  /** The maximum level that is recorded in the contour's bands. */
  maximumLevel: Scalars['Float']['output'];
  /** The metric that the contour was generated for, which indicates what types of values are stored in the contour's band levels. */
  metric: Scalars['String']['output'];
  /** The metric type that the metric was generated for. */
  metricType?: Maybe<AircraftNoiseContourMetricType>;
  /** The minimum level that is recorded in the contour's bands. */
  minimumLevel: Scalars['Float']['output'];
  /** The name of the contour. */
  name: Scalars['String']['output'];
  /** The noise model type that the contour has been created for (e.g. INM, AEDT). */
  noiseModelType?: Maybe<AircraftNoiseModelType>;
};

/**
 * A band within an aircraft noise contour, representing a contour level and one or more polygons that show the outer boundary the band's geometry.
 *
 * The band's level will be in dB values if the contour has been generated using a noise metric, or a different meaning if a different metric is used
 * (such as **NANL** which is used in Australia's N65 contours, which represent the number of noise events above 65 dB on an average day).
 *
 */
export type AircraftNoiseContourBand = {
  __typename?: 'AircraftNoiseContourBand';
  /** The level represented by the contour band. */
  level: Scalars['Float']['output'];
  /**
   * The list of polygons that describe the area covered by the band.
   *
   * Generally there is only one polygon per band, however some contours contain multiple islands for the same dB level. More than one polygon is stored for this case.
   */
  polygons?: Maybe<Array<Maybe<AircraftNoiseContourBandPolygon>>>;
};

/** A polygon within an aircraft noise contour. */
export type AircraftNoiseContourBandPolygon = {
  __typename?: 'AircraftNoiseContourBandPolygon';
  /** The points that make up the exterior edge of the polygon (in a clockwise winding direction). */
  exterior?: Maybe<AircraftNoiseContourBandRing>;
  /** A list of holes that exist within the polygon. */
  holes?: Maybe<Array<Maybe<AircraftNoiseContourBandRing>>>;
};

/** A ring within an aircraft noise contour band polygon, as either the external edge or a hole within the polygon. */
export type AircraftNoiseContourBandRing = {
  __typename?: 'AircraftNoiseContourBandRing';
  /** The points that make up the ring. */
  points?: Maybe<Array<Maybe<PositionType>>>;
};

/** Provides filters for the retrieval of noise contours. */
export type AircraftNoiseContourFilter = {
  /** A list of noise model types to use in the filter (e.g. INM or AEDT). */
  noiseModelTypes?: InputMaybe<Array<InputMaybe<AircraftNoiseModelType>>>;
};

/**
 * An enumeration with the various noise metrics types that can be used to generate a metric.
 *
 * This list is largely taken from the noise metrics that AEDT is able to generate, of which the metrics INM can generate is a subset.
 *
 * Metrics type are either noise-level based (whose values are in dB), time-based (whose values are in minutes or expressed as a percentage of
 * time within a day), or as an event count (that indicates how many aircraft events occur within a day).
 *
 */
export enum AircraftNoiseContourMetricType {
  /** A noise level based metric type whose values are in dB. */
  Exposure = 'Exposure',
  /** The maximum noise level. */
  MaximumLevel = 'MaximumLevel',
  /** Time Above a Sound Level Threshold. */
  TimeAbove = 'TimeAbove',
  /** Amount of time (in minutes) aircraft is audible above given ambient file. */
  TimeAudible = 'TimeAudible',
  /** Percentage of time aircraft is audible above given ambient file. */
  TimeAudiblePercentage = 'TimeAudiblePercentage',
  /**
   * T Time-Audible Percent with Overlapping Events Method (Statistical
   * Compression) (noise metric).
   */
  TimeAudiblePercentageStatisticalCompression = 'TimeAudiblePercentageStatisticalCompression',
  /** Time Above Noise Level Statistical Compression. */
  TimeAudibleStatisticalCompression = 'TimeAudibleStatisticalCompression'
}

/** Provides the status of an upload for an aircraft noise contour, and the id of the contour when the contour has finished processing. */
export type AircraftNoiseContourUploadResult = {
  __typename?: 'AircraftNoiseContourUploadResult';
  /** The id of the contour that was generated as a result of the processing; only set when the processing is completed successfully. */
  contourId?: Maybe<Scalars['Int']['output']>;
  /** The unique job id that was associated with the original file upload. */
  jobId?: Maybe<Scalars['ID']['output']>;
  /** The status of the contour processing, which will either be Processing, Completed or Error. */
  status: Scalars['String']['output'];
};

export enum AircraftNoiseModelType {
  /** Refers to the Aviation Environmental Design Tool (AEDT) noise modeling software. */
  Aedt = 'AEDT',
  /** Refers to the Integrated Noise Model (INM) noise modeling software. */
  Inm = 'INM'
}

/** A route used in modeling noise impacts of aircraft, containing multiple 'sub-paths' that represent a dispersion of traffic that travel along the route. */
export type AircraftNoiseModelingRoute = {
  __typename?: 'AircraftNoiseModelingRoute';
  /** The airport id for which the route is modeling data. */
  airportId: Scalars['String']['output'];
  /** The name of the group to which the modeling route belongs (similar routes belong to the same group). */
  groupName: Scalars['String']['output'];
  /** The unique id of this aircraft noise modeling type. */
  id: Scalars['Int']['output'];
  /** The name of the modeling route. */
  name: Scalars['String']['output'];
  /** The type of operation for which the route is modeling data. */
  operationType?: Maybe<OperationType>;
  /** The name of the path (i.e. SID or STAR) of the flights that will be assigned to this route during noise modeling. */
  pathName?: Maybe<Scalars['String']['output']>;
  /** The list of sub-paths whose geometry makes up the modeling route. */
  paths?: Maybe<Array<Maybe<AircraftNoiseModelingRoute>>>;
  /** The arrival or departure runway for which the route is modeling data. */
  runwayName: Scalars['String']['output'];
};

/** A scenario that models noise impacts of aircraft at an airport. */
export type AircraftNoiseModelingScenario = {
  __typename?: 'AircraftNoiseModelingScenario';
  /** The time at which the scenario was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The user who created the scenario. */
  createdBy: Scalars['String']['output'];
  /** The number of flights that operated during the Day period (typically 07:00 to 19:00) for the scenario. */
  dayCount: Scalars['Float']['output'];
  /** The end time for the scenario. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** The number of flights that operated during the Evening period (typically 19:00 to 22:00) for the scenario. */
  eveningCount: Scalars['Float']['output'];
  /** The unique id of the scenario */
  id?: Maybe<Scalars['ID']['output']>;
  /** The time at which the scenario was last updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The start times for the day, evening and night periods that the scenario has been generated for. */
  measurementDayPeriod?: Maybe<MeasurementDayPeriod>;
  /** The user-defined name of the scenario. */
  name?: Maybe<Scalars['String']['output']>;
  /** The number of flights that operated during the Night period (typically 22:00 to 07:00) for the scenario. */
  nightCount: Scalars['Float']['output'];
  /** The noise model type that the scenario has been created for (e.g. INM, AEDT). */
  noiseModelType?: Maybe<AircraftNoiseModelType>;
  /** The start time for the scenario. */
  startTime: Scalars['DateTimeOffset']['output'];
  /** The status of the scenario generation, from New, InProgress, Completed or Error. */
  status: Scalars['String']['output'];
  /** The total number of flights that operated during the scenario. */
  totalCount: Scalars['Float']['output'];
};

/** An individual record within a aircraft noise modeling scenario, providing a count of flights for a distinct aircraft type, stage length and noise modeling route. */
export type AircraftNoiseModelingScenarioRecord = {
  __typename?: 'AircraftNoiseModelingScenarioRecord';
  /** The number of flights that operated during the Day period (typically 07:00 to 19:00) for the record. */
  dayCount: Scalars['Float']['output'];
  /** The number of flights that operated during the Evening period (typically 19:00 to 23:00) for the record. */
  eveningCount: Scalars['Float']['output'];
  /** The unique id of the record. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The modeling aircraft id for the record, which defines the aircraft type used by the noise modeling software (i.e. INM or AEDT). */
  modelingAircraftId: Scalars['String']['output'];
  /** The id of the modeling route associated with the record. */
  modelingRouteId: Scalars['Int']['output'];
  /** The number of flights that operated during the Night period (typically 23:00 to 07:00) for the record. */
  nightCount: Scalars['Float']['output'];
  /** The id of the scenario to which the record belongs. */
  scenarioId?: Maybe<Scalars['ID']['output']>;
  /** The stage length for the record, indicating how far the flights for this record have travelled. */
  stageLength: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `AircraftNoiseModelingScenarioRecord`. */
export type AircraftNoiseModelingScenarioRecordConnection = {
  __typename?: 'AircraftNoiseModelingScenarioRecordConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AircraftNoiseModelingScenarioRecordEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<AircraftNoiseModelingScenarioRecord>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `AircraftNoiseModelingScenarioRecord`. */
export type AircraftNoiseModelingScenarioRecordEdge = {
  __typename?: 'AircraftNoiseModelingScenarioRecordEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AircraftNoiseModelingScenarioRecord>;
};

/** An individual record within a aircraft noise modeling scenario, providing a count of flights for a distinct aircraft type, stage length and noise modeling route. */
export type AircraftNoiseModelingScenarioRecordSummary = {
  __typename?: 'AircraftNoiseModelingScenarioRecordSummary';
  /** The airport id associated with the modeling route for this record. */
  airportId: Scalars['String']['output'];
  /** The number of flights that operated during the Day period (typically 07:00 to 19:00) for the record. */
  dayCount: Scalars['Int']['output'];
  /** The number of flights that operated during the Evening period (typically 19:00 to 23:00) for the record. */
  eveningCount: Scalars['Int']['output'];
  /** The unique id of the summary record. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The modeling aircraft id for the record, which defines the aircraft type used by the noise modeling software (i.e. INM or AEDT). */
  modelingAircraftId: Scalars['String']['output'];
  /** The modeling aircraft name for the record. */
  modelingAircraftName: Scalars['String']['output'];
  /** The id of the modeling route associated with the record. */
  modelingRouteId: Scalars['Int']['output'];
  /** The name of the modeling route assoicated with the record. */
  modelingRouteName: Scalars['String']['output'];
  /** The number of flights that operated during the Night period (typically 23:00 to 07:00) for the record. */
  nightCount: Scalars['Int']['output'];
  /** The operation type associated with the modeling route for this record. */
  operationType?: Maybe<OperationType>;
  /** The runway name associated with the modeling route for this record. */
  runwayName: Scalars['String']['output'];
  /** The stage length for the record, indicating how far the flights for this record have travelled. */
  stageLength: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `AircraftNoiseModelingScenarioRecordSummary`. */
export type AircraftNoiseModelingScenarioRecordSummaryConnection = {
  __typename?: 'AircraftNoiseModelingScenarioRecordSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AircraftNoiseModelingScenarioRecordSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<AircraftNoiseModelingScenarioRecordSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `AircraftNoiseModelingScenarioRecordSummary`. */
export type AircraftNoiseModelingScenarioRecordSummaryEdge = {
  __typename?: 'AircraftNoiseModelingScenarioRecordSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AircraftNoiseModelingScenarioRecordSummary>;
};

/** A set of query options that can be used for retrieving AircraftNoiseModelingScenarioRecordSummary data model objects. */
export type AircraftNoiseModelingScenarioRecordSummaryFilter = {
  /** A list of airport ids to use when filtering data. */
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The set of modeling aircraft ids to include in the filter (i.e. the aircraft ids which the noise modeling software such as AEDT or INM know about). */
  modelingAircraftIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The set of modeling aircraft names to include in the filter (i.e. the aircraft names which the noise modeling software such as AEDT or INM know about). */
  modelingAircraftNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of modeling route ids to use when filtering data. */
  modelingRouteIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of modeling route names to use when filtering data. */
  modelingRouteNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of operation types to use when filtering data. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** A list of runway names to use when filtering data. */
  runwayNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of stage lengths to use when filtering data. */
  stageLengths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Maps the operation fields AircraftType, Airline and EngineModel to NoiseModelingAircraftType data models. */
export type AircraftToNoiseModelingTypeMap = {
  __typename?: 'AircraftToNoiseModelingTypeMap';
  /** The aircraft type that is part of the mapping. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The airline that is part of the mapping, as either an actual airline or a "*" if it applies to all airlines.  Only ever set to an actual airline if EngineModel is not known. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The engine model that is part of the mapping, as either an actual engine model or null if not known. */
  engineModel?: Maybe<Scalars['String']['output']>;
  /** The unique id of this aircraft noise modeling type. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The type of noise model this aircraft noise modeling type belongs to. */
  noiseModelType?: Maybe<AircraftNoiseModelType>;
  /** Gets the NoiseModelingAircraftType associated with the map. */
  noiseModelingAircraftType?: Maybe<NoiseModelingAircraftType>;
  /** The id of the referenced NoiseModelingAircraftType entry. */
  noiseModelingAircraftTypeId?: Maybe<Scalars['ID']['output']>;
  /** Whether this mapping is part of the System definitions, or comes from a User override. */
  source?: Maybe<NoiseModelingTypeMapSource>;
};

/**
 * Summarizes the aircraft types, airlines and engines for operations for data that fits within a queried time range, showing the
 *  associated noise modeling aircraft types and the number of flights that fall within the Aircraft Type, Airline and Engine Model grouping.
 */
export type AircraftToNoiseModelingTypeSummary = {
  __typename?: 'AircraftToNoiseModelingTypeSummary';
  /** The aircraft type for the summary record, as derived from the associated aircraft registration or, if not available, from the operation itself. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The airline for the summary record, which is set to "*" when the engine model is known, or the operation's airline when the engine model is not known. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The engine model for the summary record, as derived from the operation's associated aircraft registration, or null if the engine model is not known. */
  engineModel?: Maybe<Scalars['String']['output']>;
  /** The id of the associated modeling aircraft (see NoiseModelingAircraftType.AircraftId). */
  modelingAircraftId?: Maybe<Scalars['String']['output']>;
  /** The name of the associated modeling aircraft, which is the value of the associated (see NoiseModelingAircraftType.AircraftName). */
  modelingAircraftName?: Maybe<Scalars['String']['output']>;
  /** The type of noise model this aircraft noise modeling type belongs to. */
  noiseModelType?: Maybe<AircraftNoiseModelType>;
  /** The number of flights that have the same Aircraft Type, Airline and Engine Model within the queried time range that generated the model. */
  numberOfFlights: Scalars['Int']['output'];
  /** The source (either User or System) that the mapping between aircraft/airline/engine and modeling aircraft type came from. */
  source?: Maybe<NoiseModelingTypeMapSource>;
  /** The System defined modeling aircraft name, which is null when there is no User override for the mapping */
  systemModelingAircraftName?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `AircraftToNoiseModelingTypeSummary`. */
export type AircraftToNoiseModelingTypeSummaryConnection = {
  __typename?: 'AircraftToNoiseModelingTypeSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AircraftToNoiseModelingTypeSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<AircraftToNoiseModelingTypeSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `AircraftToNoiseModelingTypeSummary`. */
export type AircraftToNoiseModelingTypeSummaryEdge = {
  __typename?: 'AircraftToNoiseModelingTypeSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AircraftToNoiseModelingTypeSummary>;
};

/** A set of query options that can be used for retrieving AircraftToNoiseModelingTypeSummary data model objects. */
export type AircraftToNoiseModelingTypeSummaryFilter = {
  /** A list of aircraft types to use in the filter. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of airlines to use when filtering operation data (note: supports a '*' airline). */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of airport ids to use when filtering operation data. */
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of engine models to use when filtering operation data. */
  engineModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of noise modeling aircraft names to use in the filter. */
  modelingAircraftNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of noise model types to use in the filter (e.g. INM, AEDT). */
  noiseModelTypes?: InputMaybe<Array<InputMaybe<AircraftNoiseModelType>>>;
  /** A list of operation types to use when filtering operation data. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
};

/** AirlineLoadFactorsInput, of average percentage of passenger loads per aircraft input.This data will be reflected in the emissions per pessagenger and per passenger kilometer travelled. */
export type AirlineLoadFactorsInput = {
  /** The type of the flight's aircraft, typically an ICAO code associated with a aircraft load factors. */
  aircraftType?: InputMaybe<Scalars['String']['input']>;
  /** The airline. */
  airline?: InputMaybe<Scalars['String']['input']>;
  /** Day of week, to which the given load factor will be applied. */
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  /** The destination airport. */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** The end time, that determines end of the time range that the LoadFactor applies for. */
  endTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  /** Unique id of a loadFactors. */
  id: Scalars['Int']['input'];
  /** The percentage of the seats that are occupied in a flight. */
  loadFactor?: InputMaybe<Scalars['Float']['input']>;
  /** The origin airport */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Id of a scenario, a unique airquality configuration. */
  scenarioId: Scalars['Int']['input'];
  /** The start time, that determines start of the time range that the LoadFactor applies for. */
  startTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};

/** The airline mapping, allocates the appropriate emission model for flight records with an unkonown engine but known airline. */
export type AirlineMapping = {
  __typename?: 'AirlineMapping';
  /** The default aircraft type associated with the fleet. */
  aircraftType: Scalars['String']['output'];
  /** The default airline associated with the fleet. */
  airline: Scalars['String']['output'];
  /**
   * The id associated with a airline mapping.
   * @deprecated Id has been replaced by ScenarioId-Aircraft-EngineModel. Don't use this anymore
   */
  id?: Maybe<Scalars['ID']['output']>;
  /** The enroute aircraft mapped to the airline  in the fleet. */
  mappedEnrouteAircraft?: Maybe<Scalars['String']['output']>;
  /** The enroute engine mapped to the airline  in the fleet. */
  mappedEnrouteEngine?: Maybe<Scalars['String']['output']>;
  /** The lto(Landing and Take-off Cycle) aircraft mapped to the airline in the fleet. */
  mappedLTOAircraft?: Maybe<Scalars['String']['output']>;
  /** The lto(Landing and Take-off Cycle) engine mapped to the airline  in the fleet. */
  mappedLTOEngine?: Maybe<Scalars['String']['output']>;
  /** The number of the aircraft in the fleet. */
  numberOfAircraft: Scalars['Int']['output'];
  /** Id of a scenario, a unique airquality configuration. */
  scenarioId: Scalars['Int']['output'];
  /** Whether this mapping is part of the System definitions, or comes from a User override. */
  source?: Maybe<AirQualityMappingSource>;
};

/** A airline mapping input, allocating the appropriate emission model for flight records with an unkonown engine but known airline. */
export type AirlineMappingInput = {
  /** Aircraft of a AirlineMapping. */
  aircraftType?: InputMaybe<Scalars['String']['input']>;
  /** The default airline associated with the fleet. */
  airline: Scalars['String']['input'];
  /** The id associated with a airline mapping. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The enroute aircraft mapped to the airline  in the fleet. */
  mappedEnrouteAircraft?: InputMaybe<Scalars['String']['input']>;
  /** The enroute engine mapped to the airline  in the fleet. */
  mappedEnrouteEngine?: InputMaybe<Scalars['String']['input']>;
  /** The lto(Landing and Take-off Cycle) aircraft mapped to the airline in the fleet. */
  mappedLTOAircraft?: InputMaybe<Scalars['String']['input']>;
  /** The lto(Landing and Take-off Cycle) engine mapped to the airline  in the fleet. */
  mappedLTOEngine?: InputMaybe<Scalars['String']['input']>;
  /** The number of the aircraft in the fleet. */
  numberOfAircraft?: InputMaybe<Scalars['Int']['input']>;
  /** Id of a scenario, a unique airquality configuration. */
  scenarioId: Scalars['Int']['input'];
  /** Whether this mapping is part of the System definitions, or comes from a User override. */
  source?: InputMaybe<AirQualityMappingSource>;
};

export type AirportRunwayIdSetType = {
  __typename?: 'AirportRunwayIdSetType';
  airportId: Scalars['String']['output'];
  runwayNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AirportType = {
  __typename?: 'AirportType';
  airportReferencePoint?: Maybe<PositionType>;
  iataCode: Scalars['String']['output'];
  icaoCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  runways?: Maybe<Array<Maybe<RunwayType>>>;
};

export enum AuditLogEntryRevertable {
  /** Indicates that an Audit Log entry can be reverted. */
  CanRevert = 'CanRevert',
  /** Indicate that the record associated with an Audit Log entry has been deleted, and therefore cannot be reverted. */
  RecordDeleted = 'RecordDeleted',
  /** Indicates that the change type associated with an Audit Log entry is not supported for reverting its data. */
  UnsupportedChangeType = 'UnsupportedChangeType',
  /** Indicates that the data type associated with an Audit Log entry is not supported for reverting its data. */
  UnsupportedDataType = 'UnsupportedDataType'
}

export type AuditLogEntrySummary = {
  __typename?: 'AuditLogEntrySummary';
  /** The type of the change, such as "DataInsert", "DataUpdate" or "DataDelete". */
  changeType: Scalars['String']['output'];
  /**
   * The id of the data object that has changed.
   * Even though data ids may be types other than strings, this value is always represented as a string as it's the "lowest common denominator".
   */
  dataId: Scalars['String']['output'];
  /** The name the data model that has changed. */
  dataType: Scalars['String']['output'];
  /** The name of the field that was changed. */
  fieldName: Scalars['String']['output'];
  /** The unique id of the audit log entry. */
  id: Scalars['Int']['output'];
  /**
   * The value of the field after the change.
   * Even though field values may be types other than strings, this value is always represented as a string as it's the "lowest common denominator"
   */
  newValue?: Maybe<Scalars['String']['output']>;
  /**
   * The value of the field prior to the change.
   * Even though field values may be types other than strings, this value is always represented as a string as it's the "lowest common denominator".
   */
  oldValue?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the entry can be reverted using the "revertAuditLogEntry" mutation. */
  revertable?: Maybe<AuditLogEntryRevertable>;
  /** The time at which the audit log entry was recorded. */
  time: Scalars['DateTimeOffset']['output'];
  /** The name of the user who made the change. */
  userName: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `AuditLogEntrySummary`. */
export type AuditLogEntrySummaryConnection = {
  __typename?: 'AuditLogEntrySummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<AuditLogEntrySummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<AuditLogEntrySummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `AuditLogEntrySummary`. */
export type AuditLogEntrySummaryEdge = {
  __typename?: 'AuditLogEntrySummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<AuditLogEntrySummary>;
};

/** A set of query options that can be used for retrieving AuditLogEntrySummary data model objects. */
export type AuditLogEntrySummaryFilter = {
  /** The list of change types to retrieve as part of the filter. */
  changeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The list of data model ids to retrieve as part of the filter. */
  dataIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The list of data types, which are the names of the associated data models, to retrieve as part of the filter. */
  dataTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The list of field names to retrieve as part of the filter. */
  fieldNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The list of user names to retrieve as part of the filter. */
  userNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum AuthenticationScheme {
  /** An Azure Shared Access Signature (SAS) Token is built into the URI associated with a resource. */
  AzureSasToken = 'AzureSasToken',
  /** No authentication is required to access a resource. */
  None = 'None',
  /** Requires bearer token authentication to access a resource. */
  OAuth20 = 'OAuth20',
  /** An AWS signed url is built into the URI associated with a resource. */
  SignedAwsUrl = 'SignedAwsUrl'
}

/** Specifies the way in which a emission data is broke down. */
export enum Breakdown {
  /** This breaks down the emission data into top ten aircrafts. */
  Aircraft = 'Aircraft',
  /** This breaks down the emission data into top ten airlines. */
  Airline = 'Airline',
  /** This breaks down the emission data into domestic or international flights. */
  DomesticOrInternational = 'DomesticOrInternational',
  /** No break down is applied on the emissiona data. */
  None = 'None',
  /** This breaks down the emission data into specific phases of a flight. */
  Phase = 'Phase',
  /** This breaks down the emission data into specific greenhouse gases(CO2, H2O, NOX). */
  Pollutant = 'Pollutant'
}

/** Provides the ability to insert, update or delete a record as part of a bulk operation on Aircraft Fuel Mappings. */
export type BulkAircraftFuelMappingChangeInput = {
  /** Represents the mode of the mutation operation associated with the Aircraft Fuel Mapping record. */
  mode: Scalars['String']['input'];
  /** Represents the record, which holds a Aircraft Fuel Mapping details. */
  record?: InputMaybe<AircraftFuelMappingInput>;
};

/** Provides the ability to insert, update or delete a record as part of a bulk operation on Aircraft Mapping. */
export type BulkAircraftMappingChangeInput = {
  /** Represents the mode of the mutation operation associated with the Aircraft Mapping record. */
  mode: Scalars['String']['input'];
  /** Represents the record, which holds a Aircraft Mapping details. */
  record?: InputMaybe<AircraftMappingInput>;
};

/** Provides the ability to insert, update or delete a record as part of a bulk operation on Airline Load Factors. */
export type BulkAirlineLoadFactorsChangeInput = {
  /** Represents the mode of the mutation operation associated with the Airline Load Factor record. */
  mode: Scalars['String']['input'];
  /** Represents the record, which holds a Airline Load Factor details. */
  record?: InputMaybe<AirlineLoadFactorsInput>;
};

/** Provides the ability to insert, update or delete a record as part of a bulk operation on Airline Mappings. */
export type BulkAirlineMappingChangeInput = {
  /** Represents the mode of the mutation operation associated with the Airline Mapping record. */
  mode: Scalars['String']['input'];
  /** Represents the record, which holds a Airline Mapping details. */
  record?: InputMaybe<AirlineMappingInput>;
};

/** Provides the ability to insert, update or delete a record as part of a bulk operation on Phase Defaults. */
export type BulkPhaseDefaultChangeInput = {
  /** Represents the mode of the mutation operation associated with the Phase Default record. */
  mode: Scalars['String']['input'];
  /** Represents the record, which holds a Phase Default details. */
  record?: InputMaybe<PhaseDefaultInput>;
};

/** Provides the ability to insert, update or delete a record as part of a bulk operation on Scenario and Scenario configuration. */
export type BulkScenarioChangeInput = {
  /** Represents the mode of the mutation operation associated with the Scenario and Scenario configuration record. */
  mode: Scalars['String']['input'];
  /** Represents the record, which holds a Scenario and Scenario configuration details. */
  record?: InputMaybe<ScenarioInput>;
};

export type CcoInfringement = Infringement & {
  __typename?: 'CcoInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Array<Maybe<TrackSegment>>>;
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
  topOfAscentPosition?: Maybe<PositionType>;
  topOfAscentTime?: Maybe<Scalars['DateTimeOffset']['output']>;
};

export type CcoInfringementRule = InfringementRule & {
  __typename?: 'CcoInfringementRule';
  autoInfringementSegmentLength: Scalars['Float']['output'];
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  ceilingAltitude: Scalars['Float']['output'];
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  floorAltitude: Scalars['Float']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  maxAltitudeVariation: Scalars['Float']['output'];
  maxLevelSegments: Scalars['Int']['output'];
  minLevelSegmentLength: Scalars['Float']['output'];
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  noDescentDuringSegment: Scalars['Boolean']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

export type CdoInfringement = Infringement & {
  __typename?: 'CdoInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Array<Maybe<TrackSegment>>>;
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
  topOfDescentPosition?: Maybe<PositionType>;
  topOfDescentTime?: Maybe<Scalars['DateTimeOffset']['output']>;
};

export type CdoInfringementRule = InfringementRule & {
  __typename?: 'CdoInfringementRule';
  autoInfringementSegmentLength: Scalars['Float']['output'];
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  ceilingAltitude: Scalars['Float']['output'];
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  floorAltitude: Scalars['Float']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  maxAltitudeVariation: Scalars['Float']['output'];
  maxLevelSegments: Scalars['Int']['output'];
  minLevelSegmentLength: Scalars['Float']['output'];
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  noAscentDuringSegment: Scalars['Boolean']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

/** Represents an ARGB (alpha, red, green, blue) color. */
export type Color = {
  __typename?: 'Color';
  /** The alpha (transparency) component of the color, between 0 and 255 */
  alpha?: Maybe<Scalars['Int']['output']>;
  /** The blue component of the color, between 0 and 255 */
  blue?: Maybe<Scalars['Int']['output']>;
  /** The green component of the color, between 0 and 255 */
  green?: Maybe<Scalars['Int']['output']>;
  /** The hex value of the color, such as "0xffab1245". */
  hex?: Maybe<Scalars['String']['output']>;
  /** If the color is a known color then this will be its name (e.g. "Beige"), otherwise it will be the hex value for the color */
  name: Scalars['String']['output'];
  /** The red component of the color, between 0 and 255 */
  red?: Maybe<Scalars['Int']['output']>;
};

/** Represents each column of summarized data */
export type Column = {
  __typename?: 'Column';
  /** The name of the column. */
  name: Scalars['String']['output'];
  /** The row values for the column per measure. */
  rows?: Maybe<Array<Maybe<RowValueCollection>>>;
};

/** A comment that is attached to a data model. */
export type Comment = {
  __typename?: 'Comment';
  /** The core text of the comment. */
  body?: Maybe<Scalars['String']['output']>;
  /** The name of the person who made the comment. */
  createdBy: Scalars['String']['output'];
  /** The unique id of the comment. */
  id: Scalars['Int']['output'];
  /** The time at which the comment was made. */
  time: Scalars['DateTimeOffset']['output'];
};

/** Details of a person who lodges a complaint. */
export type Complainer = {
  __typename?: 'Complainer';
  /** The address at which the complainer lives or can be contacted. */
  address?: Maybe<AddressType>;
  /** The comments associated with the complainer. */
  comments?: Maybe<Scalars['String']['output']>;
  /** The email address of the complainer. */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of the complainer. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The unique id of the complainer. */
  id: Scalars['Int']['output'];
  /** The last name of the complainer. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The mailing address at which the complainer can be contacted. */
  mailingAddress?: Maybe<AddressType>;
  /** The middle name of the complainer. */
  middleName?: Maybe<Scalars['String']['output']>;
  /** The list of phone numbers the complainer can be contacted on. */
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  /** The complainer's preferred method of receiving responses to their complaints. */
  preferredResponseMethod?: Maybe<ResponseMethod>;
  /** The suffix of the complainer. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The title of the complainer. */
  title?: Maybe<Scalars['String']['output']>;
};

/** A connection from an object to a list of objects of type `Complainer`. */
export type ComplainerConnection = {
  __typename?: 'ComplainerConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ComplainerEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<Complainer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Complainer`. */
export type ComplainerEdge = {
  __typename?: 'ComplainerEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Complainer>;
};

/** Provides fields for updating a single complainer record. Only specify values that should be modified. */
export type ComplainerInput = {
  /** The address at which the complainer lives or can be contacted. */
  address?: InputMaybe<AddressInput>;
  /** The comments associated with the complainer. */
  comments?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the complainer. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the complainer. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The unique id of the complainer. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The last name of the complainer. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The mailing address at which the complainer can be contacted. */
  mailingAddress?: InputMaybe<AddressInput>;
  /** The middle name of the complainer. */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** The list of phone numbers the complainer can be contacted on. */
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  /** The complainer's preferred method of receiving responses to their complaints. */
  preferredResponseMethod?: InputMaybe<ResponseMethod>;
  /** The suffix of the complainer. */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The title of the complainer. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A complaint that has been submitted to the system. */
export type Complaint = {
  /** The comments made about the complaint when it was submitted. */
  comments?: Maybe<Scalars['String']['output']>;
  /** The id of the complainer who submitted the complaint. */
  complainerId: Scalars['Int']['output'];
  /**
   * The method used to submit the complaint.
   * @deprecated Use EnquiryMethod property instead; ContactMethod will always return NotSet.
   */
  contactMethod?: Maybe<ContactMethod>;
  /** A list of the types of disturbance being reported. */
  disturbanceTypes: Array<Scalars['String']['output']>;
  /** A list of activities that were disturbed by the event. */
  disturbedActivities: Array<Scalars['String']['output']>;
  /** The method used to submit the complaint. */
  enquiryMethod: Scalars['String']['output'];
  /** Indicates the type of submission. */
  enquiryType?: Maybe<ComplaintEnquiryType>;
  /** The unique id of the complaint. */
  id: Scalars['Int']['output'];
  /** A set of notes that have been made about the complaint */
  notes?: Maybe<Array<Maybe<Comment>>>;
  /** The id of the privacy agreement that was in effect at the time the complaint was lodged. */
  privacyAgreementId?: Maybe<Scalars['Int']['output']>;
  /** The id of the complainer from which the complaint was originally lodged. */
  reportedComplainerId?: Maybe<Scalars['Int']['output']>;
  /** The time when the complaint was reported. */
  reportedTime: Scalars['DateTimeOffset']['output'];
  /** Whether the complainant asked for a response to the complaint. */
  responseRequired: Scalars['Boolean']['output'];
  /** The current status of the complaint. */
  status: Scalars['String']['output'];
  /** The time of the event that the complaint is about. */
  time: Scalars['DateTimeOffset']['output'];
};

/** Specifies the type of submission. */
export enum ComplaintEnquiryType {
  /** Indicates that the submission was a complaint. */
  Complaint = 'Complaint',
  /** Indicates that the submission was an Enquiry. */
  Enquiry = 'Enquiry'
}

/** A connection from an object to a list of objects of type `ComplaintSummary`. */
export type ComplaintSummaryConnection = {
  __typename?: 'ComplaintSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ComplaintSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ComplaintSummaryType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ComplaintSummary`. */
export type ComplaintSummaryEdge = {
  __typename?: 'ComplaintSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ComplaintSummaryType>;
};

/** A set of query options that can be used for retrieving ComplaintSummary data model objects */
export type ComplaintSummaryFilter = {
  /** A list of correlated operation aircraft categories that will be used to filter the results. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** A list of correlated operation aircraft types that will be used to filter the results. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of correlated operation airlines that will be used to filter the results. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of complainer ids that will be used to filter the results. */
  complainerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of contact methods that will be used to filter the results. */
  contactMethods?: InputMaybe<Array<InputMaybe<ContactMethod>>>;
  /** A list of disturbance types that will be used to filter the results. */
  disturbanceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Allows complaints that are (or are not) correlated to an operation to be retrieved. */
  hasOperation?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of complaint ids that will be used to filter the results. */
  limitToIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of correlated operation ids that will be used to filter the results. */
  operationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of correlated operation types that will be used to filter the results. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** A list of flight operator categories that will be used to filter the results. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** A list of status values that will be used to filter the results. */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The time period used as part of the filter (i.e. daily start and end times). */
  timePeriod?: InputMaybe<InputTimePeriod>;
};

export type ComplaintSummaryType = {
  __typename?: 'ComplaintSummaryType';
  /** The aircraft identifier (ACID) of the operation correlated to the complaint, if any. */
  acid?: Maybe<Scalars['String']['output']>;
  /** The aircraft category of the operation correlated to the complaint, if any. */
  aircraftCategory?: Maybe<AircraftCategory>;
  /** The aircraft type of the operation correlated to the complaint, if any. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The airline of the operation correlated to the complaint, if any. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The local airport that the correlated  operation landed at or took off from, as either IATA or ICAO. */
  airportId?: Maybe<Scalars['String']['output']>;
  /** The person who raised the complaint. */
  complainer?: Maybe<Complainer>;
  /** The id of the complainer that raised the complaint. */
  complainerId: Scalars['Int']['output'];
  /** The complete name of the complainer, as a join between the first and last names. */
  complainerName?: Maybe<Scalars['String']['output']>;
  /** The position of the associated complainer's address. */
  complainerPosition?: Maybe<PositionType>;
  /** The postcode/zip code component of the associated complainer's address, such as 10001. */
  complainerPostcode?: Maybe<Scalars['String']['output']>;
  /** The method used to submit the complaint. */
  contactMethod?: Maybe<ContactMethod>;
  /** The correlation id of the complaint. */
  correlationId?: Maybe<Scalars['Int']['output']>;
  /** A list of types of disturbance being reported, such as Loud Noise, Excessive Vibration, etc. */
  disturbanceTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The unique id of the complaint. */
  id: Scalars['Int']['output'];
  /** The unique id of the operation correlated to the complaint, if any. */
  operationId?: Maybe<Scalars['Int']['output']>;
  /** The operation type of the operation correlated to the complaint, if any. */
  operationType?: Maybe<OperationType>;
  /** The category of the operator for the correlated operation. */
  operatorCategory?: Maybe<OperatorCategory>;
  /** The remote airport of the correlated operation, as either IATA or ICAO. */
  remoteAirportId?: Maybe<Scalars['String']['output']>;
  /** The name runway that the correlated operation landed at or took off from. */
  runwayName?: Maybe<Scalars['String']['output']>;
  /** The current status of the complaint. */
  status: Scalars['String']['output'];
  /** The time of the event about which the complaint is reported. */
  time: Scalars['DateTimeOffset']['output'];
};

/** Specifies the way in which a complaint can be submitted. */
export enum ContactMethod {
  /** Contact method via a separate application */
  AnsweringMachine = 'AnsweringMachine',
  /** Contact method via a separate application */
  App = 'App',
  /** Contact method by email */
  Email = 'Email',
  /** Contact method via a separate application */
  Fax = 'Fax',
  /** Contact method using face-to-face communication */
  InPerson = 'InPerson',
  /** Contact method by physical letter */
  Letter = 'Letter',
  /** The value is not set */
  NotSet = 'NotSet',
  /** Contact method via a separate application */
  Other = 'Other',
  /** Contact method by telephone */
  Phone = 'Phone',
  /** Contact method via a separate application */
  PlaneNoise = 'PlaneNoise',
  /** Contact method via a social media platform */
  SocialMedia = 'SocialMedia',
  /** Contact method via a separate application */
  Viewpoint = 'Viewpoint',
  /** Contact method via web page */
  WebPage = 'WebPage',
  /** Contact method via a separate application */
  WebTrak = 'WebTrak'
}

export type ContinuousNoiseSampleCollection = {
  __typename?: 'ContinuousNoiseSampleCollection';
  deviceId: Scalars['Int']['output'];
  duration: Scalars['Float']['output'];
  endTime: Scalars['DateTimeOffset']['output'];
  frequencyWeighting?: Maybe<FrequencyWeighting>;
  locationId: Scalars['Int']['output'];
  noiseMeasurementType?: Maybe<NoiseMeasurementType>;
  sampleResolution: Scalars['Float']['output'];
  sampleType?: Maybe<SampleType>;
  samples?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  startTime: Scalars['DateTimeOffset']['output'];
  timeWeighting?: Maybe<TimeWeighting>;
};

export type ContinuousNoiseSampleCollectionFilter = {
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  frequencyWeightings?: InputMaybe<Array<InputMaybe<FrequencyWeighting>>>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sampleTypes?: InputMaybe<Array<InputMaybe<SampleType>>>;
  timeWeightings?: InputMaybe<Array<InputMaybe<TimeWeighting>>>;
};

export type CorridorInfringement = Infringement & {
  __typename?: 'CorridorInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  corridorId: Scalars['Int']['output'];
  detectedPassage?: Maybe<CorridorPassage>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
};

export type CorridorInfringementRule = InfringementRule & {
  __typename?: 'CorridorInfringementRule';
  allowedPassage?: Maybe<Array<Maybe<CorridorPassage>>>;
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  ceilingAltitude: Scalars['Float']['output'];
  corridorId: Scalars['Int']['output'];
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  pathName: Scalars['String']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

export enum CorridorPassage {
  /** Indicates an intersection with the ceiling of the corridor. */
  Ceiling = 'Ceiling',
  /** Indicates an intersection with the end (last gate) of the corridor. */
  End = 'End',
  /** Indicates an intersection with the floor of the corridor. */
  Floor = 'Floor',
  /** Indicates an intersection with the left side of the corridor. */
  Left = 'Left',
  /** Indicates no intersection at all with the sides of the corridor. */
  NoIntersection = 'NoIntersection',
  /** Indicates an intersection with the right side of the corridor. */
  Right = 'Right',
  /** Indicates an intersection with the start (first gate) of the corridor. */
  Start = 'Start'
}

export type CorridorType = {
  __typename?: 'CorridorType';
  /** The time the corridor was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** A filter for the corridor, which is used to determine which operations will be assessed by the corridor. */
  filter?: Maybe<GateFilter>;
  /** The geometry for the corridor. */
  geometry?: Maybe<Array<Maybe<GateGeometryType>>>;
  /** The group name for the corridor. */
  groupName: Scalars['String']['output'];
  /** The id of the corridor. */
  id: Scalars['Int']['output'];
  /** A value indicating whether this corridor is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the corridor was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the corridor. */
  name: Scalars['String']['output'];
};

export type CurfewInfringement = Infringement & {
  __typename?: 'CurfewInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
};

export type CurfewInfringementRule = InfringementRule & {
  __typename?: 'CurfewInfringementRule';
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  /** Id of the Dashboard */
  id: Scalars['ID']['output'];
  /** Specifies the type of device the dashboard can be shown on */
  mode: DashboardMode;
  /** Name of the Dashboard */
  name: Scalars['String']['output'];
};

/** Contains necessary data to Embed a Power BI report into the application. */
export type DashboardAccessInfo = {
  __typename?: 'DashboardAccessInfo';
  /** Id of the Power BI Report */
  embedReportId: Scalars['ID']['output'];
  /** Access Token to embed the Power BI Report */
  embedToken?: Maybe<Scalars['String']['output']>;
  /** Url to embed the Power BI Report */
  embedUrl?: Maybe<Scalars['String']['output']>;
  /** A value indicating when the Access Token expires and becomes invalid. */
  expiration?: Maybe<Scalars['DateTime']['output']>;
};

/** An enumeration specifying the device where the dashboard can be displayed on. */
export enum DashboardMode {
  /** The dashboard can be displayed in any device */
  Any = 'Any',
  /** The dashboard can be displayed in full display devices only */
  Desktop = 'Desktop',
  /** The dashboard can be displayed in mobile devices only. */
  Mobile = 'Mobile'
}

/** A data file upload job, which allows a client application to push files to a location in Blob storage (such as S3 or Minio) using pre-signed URLs. */
export type DataFileUploadJob = {
  __typename?: 'DataFileUploadJob';
  /** The a list of file resources that are part of the upload job, each containing a pre-signed URL to which a file can be uploaded. */
  files?: Maybe<Array<Maybe<DataFileUploadResource>>>;
  /** The unique id of the data file upload job. */
  id?: Maybe<Scalars['ID']['output']>;
};

/** An individual file that belongs to a **DataFileUploadJob**. */
export type DataFileUploadResource = {
  __typename?: 'DataFileUploadResource';
  /** The value of the content-type header to use when uploading a file to the upload uri using HTTP PUT. You must use this value for the header, otherwise your upload will fail. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The name of the file that will appear the remote resource once the file has been created. Does not include path information. */
  fileName: Scalars['String']['output'];
  /** The type of file within a multi-file upload job, for example a DBF file within an ESRI Shape file upload. */
  fileSubType?: Maybe<Scalars['String']['output']>;
  /** The URI to which will be used to upload files to using an HTTP PUT operation. */
  uploadUri?: Maybe<UriResource>;
};

/** An enumeration specifying the day of the week. */
export enum DayOfWeek {
  /** Indicates Friday. */
  Friday = 'Friday',
  /** Indicates Monday. */
  Monday = 'Monday',
  /** Indicates Saturday. */
  Saturday = 'Saturday',
  /** Indicates Sunday. */
  Sunday = 'Sunday',
  /** Indicates Thursday. */
  Thursday = 'Thursday',
  /** Indicates Tuesday. */
  Tuesday = 'Tuesday',
  /** Indicates Wednesday. */
  Wednesday = 'Wednesday'
}

/** The different emissions that are calculated for Aircraft Carbon Emissions. */
export enum EmissionEnum {
  /** Methane (CH₄) emissions. */
  Ch4 = 'CH4',
  /** CO₂ equivalent for Methane (CH₄) emissions. */
  Ch4e = 'CH4e',
  /** Carbon Dioxide (CO₂) emissions. */
  Co2 = 'CO2',
  /** Total fuel burn. */
  Fuel = 'Fuel',
  /** Total CO₂ equivalent for all emissions. */
  GhGt = 'GHGt',
  /** Water (H₂O) emissions. */
  H2O = 'H2O',
  /** Nitrous Oxides (N₂O) emissions. */
  N2O = 'N2O',
  /** CO₂ equivalent for Nitrous Oxides (N₂O) emissions. */
  N2Oe = 'N2Oe',
  /** Nitrogen Oxides (NOₓ) emissions. */
  Nox = 'NOX',
  /** CO₂ equivalent for Nitrogen Oxides (NOₓ) emissions. */
  NoXe = 'NOXe'
}

export type ExclusionInfringement = Infringement & {
  __typename?: 'ExclusionInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  selectionZoneId: Scalars['Int']['output'];
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
};

export type ExclusionInfringementRule = InfringementRule & {
  __typename?: 'ExclusionInfringementRule';
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  selectionZoneId: Scalars['Int']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

/** Provides a way to specify which data to export. */
export type ExportFilterType = {
  /** The list of complaint ids to include in the export. */
  complaintIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The list of infringement ids to include in the export. */
  infringementIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The list of noise event ids to include in the export. */
  noiseEventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** The list of operation ids to include in the export. */
  operationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** The format in which to export data. */
export enum ExportFormat {
  /** Indicates an export targets the Microsoft Excel spreadsheet (.xlsx) format. */
  Excel = 'Excel',
  /** Indicates an export targets the Integrated Noise Model (CSV) format. */
  Inm = 'INM',
  /** Indicates an export targets Google's Keyhole Markup Language (KML) format. */
  Kml = 'KML',
  /** Indicates an export targets the Microsoft Word (.doc) format. */
  Word = 'Word'
}

/** Provides details about an export of data. */
export type ExportResultType = {
  __typename?: 'ExportResultType';
  /** When the export is complete, contains the location from which the exported results can be fetched. */
  downloadResource?: Maybe<UriResource>;
  /** The unique key of the export. */
  key?: Maybe<Scalars['ID']['output']>;
  /** The current status of the export. */
  status: Scalars['String']['output'];
};

export enum FlightRules {
  /** Instrument Flight Rules, a set of regulations used when flying by outside visual reference is not safe. */
  Ifr = 'IFR',
  /** Visual Flight Rules, a set of regulations under which a pilot can operate an aircraft by visual reference. */
  Vfr = 'VFR'
}

export enum FrequencyWeighting {
  /** A-weighting filters cover the full audio range, 20 Hz to 20 kHz, but the filter 'shape' is similar to the response of the human ear at lower sound levels. */
  AWeighted = 'AWeighted',
  /** C-weighting is commonly used for high level measurements and peak sound pressure levels.  It correlates better with human response at high sound levels. */
  CWeighted = 'CWeighted',
  /** The type of frequency weighting is unknown. */
  Unknown = 'Unknown',
  /** Z-weighting, the Z is for 'zero' frequency weighting, implying no weighting across the audio spectrum. In reality the range is 10 Hz to 20 kHz ±1.5 dB. */
  ZWeighted = 'ZWeighted'
}

export type GateCriteria = {
  __typename?: 'GateCriteria';
  altitudeRange?: Maybe<RangeOfFloat>;
  gateDirections?: Maybe<Array<Maybe<GateDirection>>>;
  gateId: Scalars['Int']['output'];
  intersectionMode?: Maybe<GateIntersectionMode>;
  speedRange?: Maybe<RangeOfFloat>;
};

export enum GateDirection {
  /** The direction taken is 'into' the gate. */
  In = 'In',
  /** The direction taken is 'out of' the gate. */
  Out = 'Out'
}

/** Describes the filter for a gate or corridor, which controls which operations are assessed by geometric processing. */
export type GateFilter = {
  __typename?: 'GateFilter';
  /** A list of operation types that are checked when processing the gate or corridor. */
  operationTypes?: Maybe<Array<Maybe<OperationType>>>;
  /** A list of runways that are used in the filter when processing the gate or corridor. */
  runways?: Maybe<Array<Maybe<GateFilterRunway>>>;
};

/** Describes a runway filter for a gate or corridor. */
export type GateFilterRunway = {
  __typename?: 'GateFilterRunway';
  /** The key of the airport being used in the filter, as either IATA or ICAO. */
  airportId: Scalars['String']['output'];
  /** The name of the runway being used in the filter. */
  runwayName: Scalars['String']['output'];
};

export type GateGeometryType = {
  __typename?: 'GateGeometryType';
  /** The anchor position of the gate. */
  anchorPosition?: Maybe<PositionType>;
  /** The ceiling altitude of the gate in feet above MSL. */
  ceilingAltitude: Scalars['Float']['output'];
  /** The floor altitude of the gate in feet above MSL. */
  floorAltitude: Scalars['Float']['output'];
  /** The left position of the gate. */
  leftPosition?: Maybe<PositionType>;
  /** The right position of the gate. */
  rightPosition?: Maybe<PositionType>;
};

export type GateInfringement = Infringement & {
  __typename?: 'GateInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  gateDirection?: Maybe<GateDirection>;
  gateId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  reason?: Maybe<GateInfringementReason>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  speed?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
};

export enum GateInfringementReason {
  /** The flight went through the gate in a direction it was not allowed to. */
  InvalidDirection = 'InvalidDirection',
  /** The flight missed the gate when it should have gone through it. */
  MissedGate = 'MissedGate',
  /** The flight went through a gate it was not allowed to. */
  RestrictedGate = 'RestrictedGate',
  /** The flight went through the gate above the required speed range. */
  TooFast = 'TooFast',
  /** The flight went through the gate above the required altitude range. */
  TooHigh = 'TooHigh',
  /** The flight went through the gate below the required altitude range. */
  TooLow = 'TooLow',
  /** The flight went through the gate below the required speed range. */
  TooSlow = 'TooSlow'
}

export type GateInfringementRule = InfringementRule & {
  __typename?: 'GateInfringementRule';
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  gateCriteria?: Maybe<Array<Maybe<GateCriteria>>>;
  /** @deprecated Access the individual gates in the GateCriteria property instead. */
  gateId: Scalars['Int']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** @deprecated Access the individual gates in the GateCriteria property instead. */
  infringementDirections?: Maybe<Array<Maybe<GateDirection>>>;
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

export type GateIntersectionFilterInput = {
  /** GateIds to check intersections with. */
  gateIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Provides information related to a Gate intersection with an operation. */
export type GateIntersectionInfo = {
  __typename?: 'GateIntersectionInfo';
  /** The XY intersection point of the track to the gate. */
  deviationX: Scalars['Float']['output'];
  /** The Z axis intersection point of the track to the gate. */
  deviationY: Scalars['Float']['output'];
  /** The direction of the operation at the time of intersection. */
  direction?: Maybe<GateDirection>;
  /** The gate related to the intersection if any. */
  gate?: Maybe<GateType>;
  position?: Maybe<PositionType>;
  /** The time at which the operation penetrated the intersection. */
  time?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The Velocity at the intersection. */
  velocity: Scalars['Float']['output'];
};

export enum GateIntersectionMode {
  /** The gate must be intersected. */
  MustIntersect = 'MustIntersect',
  /** The gate must not be intersected. */
  MustNotIntersect = 'MustNotIntersect'
}

export type GateType = {
  __typename?: 'GateType';
  /** The time the gate was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** A filter for the gate, which is used to determine which operations will be assessed by the gate. */
  filter?: Maybe<GateFilter>;
  /** The geometry for the gate. */
  geometry?: Maybe<GateGeometryType>;
  /** The group name for the gate. */
  groupName: Scalars['String']['output'];
  /** The id of the gate. */
  id: Scalars['Int']['output'];
  /** A value indicating whether this gate is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the gate was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the gate. */
  name: Scalars['String']['output'];
};

export type GeoJsonLineString = {
  __typename?: 'GeoJsonLineString';
  coordinates?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Describes an address returned by an address geocoding service, including positional information. */
export type GeocodedAddress = {
  __typename?: 'GeocodedAddress';
  /** The city name for the address. */
  city?: Maybe<Scalars['String']['output']>;
  /** The country within which the address can be found. */
  country?: Maybe<Scalars['String']['output']>;
  /** The county (otherwise known as municipality or local government area) of the address. */
  county?: Maybe<Scalars['String']['output']>;
  /** The full address of the location. */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** A named neighborhood for the address. */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** The geographic position of the address. */
  position?: Maybe<PositionType>;
  /** The postcode or zipcode for the address. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** The state within which the address can be found. */
  state?: Maybe<Scalars['String']['output']>;
  /** The human-readable address of the location. */
  streetAddress?: Maybe<Scalars['String']['output']>;
  /** The name of the street for the address. */
  streetName?: Maybe<Scalars['String']['output']>;
  /** The number on the street for the address. */
  streetNumber?: Maybe<Scalars['String']['output']>;
};

/** A map layer. */
export type GisLayer = {
  /** The format of the GIS Layer, such as KML, GeoJson, PBF. */
  format: Scalars['String']['output'];
  /** The id of the GIS Layer. */
  id: Scalars['Int']['output'];
  /** The maximum zoom level at which the GIS layer should be made visible; a null value indicates there is no maximum zoom level. */
  maxZoomLevel?: Maybe<Scalars['Boolean']['output']>;
  /** The minimum zoom level at which the GIS layer should be made visible; a null value indicates there is no minimum zoom level. */
  minZoomLevel?: Maybe<Scalars['Boolean']['output']>;
  /** The display name of the GIS Layer. */
  name: Scalars['String']['output'];
  /** Indicates whether the GIS Layer is visible (turned on) or not. */
  visible: Scalars['Boolean']['output'];
};

/** A grid, centered on a position, with a variable width and height and a uniform cell size. */
export type Grid = {
  __typename?: 'Grid';
  /** The center point of the grid. */
  centerPosition?: Maybe<PositionType>;
  /** The corner points of the grid, in the order of top left, top right, bottom right and bottom left (i.e. in a clockwise direction). */
  cornerPoints?: Maybe<Array<Maybe<PositionType>>>;
  /** The height of the grid, in meters. */
  height: Scalars['Float']['output'];
  /** The number cells in the vertical (north/south) direction. */
  numCellsHigh: Scalars['Int']['output'];
  /** The number of cells in the horizontal (east/west) direction. */
  numCellsWide: Scalars['Int']['output'];
  /** The size of the cells within the grid, in meters. */
  resolution: Scalars['Float']['output'];
  /** The width of the grid, in meters. */
  width: Scalars['Float']['output'];
};

/** Provides image data that will be embedded within the resulting export. */
export type ImageDataType = {
  /** The name of the image data that will be used in the export. */
  key: Scalars['String']['input'];
  /** The data for the image that will be embedded, as a base64 string of the source binary image. */
  value: Scalars['String']['input'];
};

export type Infringement = {
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
};

/** Describes a filter that can be applied to an infringement rule.. */
export type InfringementCandidateFilter = {
  __typename?: 'InfringementCandidateFilter';
  /** The aircraft categories applied by the filter. */
  aircraftCategories?: Maybe<Array<Maybe<AircraftCategory>>>;
  /** The aircraft types applied by the filter. */
  aircraftTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The airports and runways applied by the filter. */
  airportRunways?: Maybe<Array<Maybe<AirportRunwayIdSetType>>>;
  /** The days of the week applied by the filter. */
  daysOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  /** The end time of day applied by the filter. */
  endTime?: Maybe<Scalars['Seconds']['output']>;
  /** The lowest maximum landing weight applied by the filter. */
  lowestMaxLandingWeight?: Maybe<Scalars['Float']['output']>;
  /** The lowest maximum take off weight applied by the filter. */
  lowestMaxTakeOffWeight?: Maybe<Scalars['Float']['output']>;
  /**
   * The lowest maximum landing weight applied by the filter.
   * @deprecated Please use LowestMaxLandingWeight instead.
   */
  lowestMinLandingWeight?: Maybe<Scalars['Float']['output']>;
  /** The operation types applied by the filter. */
  operationTypes?: Maybe<Array<Maybe<OperationType>>>;
  /** The operator categories applied by the filter. */
  operatorCategories?: Maybe<Array<Maybe<OperatorCategory>>>;
  /** The name of the operation's path field that is applied by the filter. */
  pathName?: Maybe<Scalars['String']['output']>;
  /** The SQL query string used to define the filter. */
  queryString?: Maybe<Scalars['String']['output']>;
  /** The start time of day applied by the filter. */
  startTime?: Maybe<Scalars['Seconds']['output']>;
};

export type InfringementCandidateSummary = {
  __typename?: 'InfringementCandidateSummary';
  /** The aircraft identifier (ACID) of the operation associated with the infringement candidate. */
  acid: Scalars['String']['output'];
  /** The aircraft category of the operation associated with the infringement candidate. */
  aircraftCategory?: Maybe<AircraftCategory>;
  /** The aircraft type of the operation associated with the infringement candidate. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The airline of the operation associated with the infringement candidate. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The aiport identifier of the operation associated with the infringement candidate. */
  airportId?: Maybe<Scalars['String']['output']>;
  /** The infringement that was generated by the operation if it infringed the rule. */
  detail?: Maybe<Infringement>;
  /** The id of the infringement associated with the infringement candidate. */
  infringementId?: Maybe<Scalars['Int']['output']>;
  /** The type of the infringement associated with the infringement candidate. */
  infringementType?: Maybe<InfringementType>;
  /** Indicates whether the operation infringed the rule. */
  isInfringement: Scalars['Boolean']['output'];
  /** The operation id of the infringement candidate. */
  operationId: Scalars['Int']['output'];
  /** The time of the operation associated with the infringement candidate. */
  operationTime: Scalars['DateTimeOffset']['output'];
  /** The type of operation associated with the infringement candidate. */
  operationType?: Maybe<OperationType>;
  /** The operator category of the operation associated with the infringement candidate. */
  operatorCategory?: Maybe<OperatorCategory>;
  /** The position the operation was at when it infringed the rule. */
  position?: Maybe<PositionType>;
  /** The remote airport identifier of the operation associated with the infringement candidate. */
  remoteAirportId?: Maybe<Scalars['String']['output']>;
  /** The infringement rule associated with the infringement candidate. */
  rule?: Maybe<InfringementRule>;
  /** The identifier of the rule associated with the infringement candidate. */
  ruleId: Scalars['Int']['output'];
  /** The name of the rule associated with the infringement candidate. */
  ruleName: Scalars['String']['output'];
  /** The runway name of the operation associated with the infringement candidate. */
  runwayName?: Maybe<Scalars['String']['output']>;
  /** The severity of the infringement associated with the infringement candidate. */
  severity?: Maybe<Scalars['String']['output']>;
  /** The status of the infringement associated with the infringement candidate. */
  status?: Maybe<Scalars['String']['output']>;
  /** The time of the infringement associated with the infringement candidate. */
  time: Scalars['DateTimeOffset']['output'];
};

/** A connection from an object to a list of objects of type `InfringementCandidateSummary`. */
export type InfringementCandidateSummaryConnection = {
  __typename?: 'InfringementCandidateSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<InfringementCandidateSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<InfringementCandidateSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `InfringementCandidateSummary`. */
export type InfringementCandidateSummaryEdge = {
  __typename?: 'InfringementCandidateSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InfringementCandidateSummary>;
};

/** A set of query options that can be used for retrieving InfringementCandidateSummary data objects. */
export type InfringementCandidateSummaryFilter = {
  /** An array of aircraft identifiers (ACIDs) that will be used to filter the results. */
  acids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of Aircraft Categories that will be used to filter the results. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** An array of Aircraft Types that will be used to filter the results. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of Airlines that will be used to filter the results. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Only infringement candidates whose related operation is tagged none of these values are returned. */
  excludeOperationTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** Only infringement candidates whose related operation is tagged with one of these values are returned. */
  includeOperationTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** An array of infringement types that will be used to filter the results. */
  infringementTypes?: InputMaybe<Array<InputMaybe<InfringementType>>>;
  /** Filter results based on whether they are infringements or candidates. */
  isInfringement?: InputMaybe<Scalars['Boolean']['input']>;
  /** An array of Operation Types that will be used to filter the results. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** An array of Operator Categories that will be used to filter the results. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** An array of infringement rule ids that will be used to filter the results. */
  ruleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** An array of infringement rule names that will be used to filter the results. */
  ruleNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of infringement severities that will be used to filter the results. */
  severities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of infringement statuses that will be used to filter the results. */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The time period used as part of the filter (i.e. daily start and end times). */
  timePeriod?: InputMaybe<InputTimePeriod>;
};

export type InfringementInput = {
  actionRequired?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  excused?: InputMaybe<Scalars['Boolean']['input']>;
  excusedReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  severity?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InfringementRule = {
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

export type InfringementRuleFilter = {
  infringementTypes?: InputMaybe<Array<InputMaybe<InfringementType>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ruleNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Represents an single infringement row for display in a table- or grid-like component. */
export type InfringementSummary = {
  __typename?: 'InfringementSummary';
  /** The aircraft id of the operation that caused the infringement. */
  acid: Scalars['String']['output'];
  /** The aircraft category of the operation that caused the infringement. */
  aircraftCategory?: Maybe<AircraftCategory>;
  /** The aircraft type of the operation that caused the infringement. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The airline of the operation that caused the infringement. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The local airport that the operation landed at or took off from, as either IATA or ICAO. */
  airportId?: Maybe<Scalars['String']['output']>;
  /** The Infringement data object for the infringement summary. */
  detail?: Maybe<Infringement>;
  /** The unique id of the infringement. */
  id: Scalars['Int']['output'];
  /** The type of the infringement. */
  infringementType?: Maybe<InfringementType>;
  /** The id of the operation that caused the infringement. */
  operationId: Scalars['Int']['output'];
  /** The tags associated with the operation that caused the infringement. */
  operationTags?: Maybe<Array<Maybe<Tag>>>;
  /** The type of the operation that caused the infringement. */
  operationType?: Maybe<OperationType>;
  /** The category of the operator for the flight. */
  operatorCategory?: Maybe<OperatorCategory>;
  /** The position of the aircraft when the infringement occurred. */
  position?: Maybe<PositionType>;
  /** The remote airport, as either IATA or ICAO. */
  remoteAirportId?: Maybe<Scalars['String']['output']>;
  /** The rule that caused the infringement. */
  rule?: Maybe<InfringementRule>;
  /** The identifier of the rule used to generate the infringement. */
  ruleId: Scalars['Int']['output'];
  /** The name of the rule used to generate the infringement. */
  ruleName: Scalars['String']['output'];
  /** The name runway that the operation landed at or took off from. */
  runwayName?: Maybe<Scalars['String']['output']>;
  /** The severity of the infringement. */
  severity: Scalars['String']['output'];
  /** The status of the infringement. */
  status?: Maybe<Scalars['String']['output']>;
  /** The time of the infringement. */
  time: Scalars['DateTimeOffset']['output'];
};


/** Represents an single infringement row for display in a table- or grid-like component. */
export type InfringementSummaryOperationTagsArgs = {
  returnOnly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection from an object to a list of objects of type `InfringementSummary`. */
export type InfringementSummaryConnection = {
  __typename?: 'InfringementSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<InfringementSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<InfringementSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `InfringementSummary`. */
export type InfringementSummaryEdge = {
  __typename?: 'InfringementSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<InfringementSummary>;
};

/** A set of query options that can be used for retrieving InfringementSummary data objects. */
export type InfringementSummaryFilter = {
  /** An array of aircraft identifiers (ACIDs) that will be used to filter the results. */
  acids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of Aircraft Categories that will be used to filter the results. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** An array of Aircraft Types that will be used to filter the results. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of Airlines that will be used to filter the results. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Only infringements whose related operation has none of these tags to be returned. */
  excludeOperationTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** Only infringements whose related operation has at least one of these tags to be returned. */
  includeOperationTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** An array of infringement types that will be used to filter the results. */
  infringementTypes?: InputMaybe<Array<InputMaybe<InfringementType>>>;
  /** An array of infringement ids that will be used to filter the results. */
  limitToIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** An array of Operation Types that will be used to filter the results. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** An array of Operator Categories that will be used to filter the results. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** An array of infringement rule ids that will be used to filter the results. */
  ruleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** An array of infringement rule names that will be used to filter the results. */
  ruleNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of infringement severities that will be used to filter the results. */
  severities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of infringement statuses that will be used to filter the results. */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The time period used as part of the filter (i.e. daily start and end times). */
  timePeriod?: InputMaybe<InputTimePeriod>;
};

export enum InfringementType {
  /** A rule where an operation must climb at a constant rate to a specified altitude, or an infringement of that rule. */
  Cco = 'Cco',
  /** A rule where an operation must descend at a constant rate from a specified altitude, or an infringement of that rule. */
  Cdo = 'Cdo',
  /** A rule where an operation must conform to a corridor, or an infringement of that rule. */
  Corridor = 'Corridor',
  /** A rule where an operation must only operate at an airport within a specified period of the day, or an infringement of that rule. */
  Curfew = 'Curfew',
  /** A rule where an operation must not enter a region, or an infringement of that rule. */
  Exclusion = 'Exclusion',
  /** A rule where an operation must not penetrate a gate, or an infringement of that rule. */
  Gate = 'Gate',
  /** A rule constructed of airport specific filters, or an infringement of that rule. */
  General = 'General',
  /** A rule where an operation must achieve a certain height after a specified flight distance, or an infringement of that rule. */
  MinHeight = 'MinHeight',
  /** A rule that checks the amount of noise made by an operation at noise monitors, or an infringement of that rule. */
  Noise = 'Noise'
}

/**
 * Specifies details associated with exporting an aircraft noise contour to a target model, including the ability to set the target counts on the scenario.
 *
 * Specify a different target day, evening or night count when exporting a scenario to have all the records within the
 * scenario adjusted up or down.  The adjustment is such that the sum of all records within the scenario will match the
 * specified targets.
 */
export type InputAircraftNoiseModelingScenarioExportAdjustments = {
  /** The target number of flights for the day period when exporting a scenario. */
  targetDayCount: Scalars['Float']['input'];
  /** The target number of flights for the evening period when exporting a scenario. */
  targetEveningCount: Scalars['Float']['input'];
  /** The target number of flights for the night period when exporting a scenario. */
  targetNightCount: Scalars['Float']['input'];
};

/** Provides filters for the creation of an aircraft noise modeling scenario. */
export type InputAircraftNoiseModelingScenarioFilter = {
  /** A list of aircraft categories used to filter flights that will be included in the scenario. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** A list of aircraft types that will be included in the scenario. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of airlines categories used to filter flights that will be included in the scenario. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of airport ids used to filter flights that will be included in the scenario. */
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of operation types used to filter flights that will be included in the scenario.  Note that only Arrivals and Departures are supported. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** A list of operator categories categories used to filter flights that will be included in the scenario. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** A list of path names used to filter flights that will be included in the scenario. */
  pathNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of runway names used to filter flights that will be included in the scenario. */
  runwayNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The time period during the day that is used to filter flights that will be included in the scenario. */
  timePeriod?: InputMaybe<InputTimePeriod>;
};

/**
 * An input object for modifying an aircraft noise modeling scenario record's aircraft id, stage length, modeling route and day/evening/night counts.
 * During mutations that change records in a scenario, validation is carried out to ensure that:
 * * The modelingAircraftId is a valid aircraft id for the scenario's noise model type (AEDT or INM),
 * * The stageLength is valid if:
 *     * It's either M or a value between 1 and 11,
 *     * It's a value the supplied modelingAircraftId can actually fly when the modeling route is a departure,
 *     * It is set to 1 when the modeling rotue is an arrival.
 */
export type InputAircraftNoiseModelingScenarioRecord = {
  /** The number of flights that operated during the Day period (typically 07:00 to 19:00) for the record. */
  dayCount?: InputMaybe<Scalars['Float']['input']>;
  /** The number of flights that operated during the Evening period (typically 19:00 to 23:00) for the record. */
  eveningCount?: InputMaybe<Scalars['Float']['input']>;
  /** The unique id of this aircraft noise modeling scenario record. **Insert: Ignored**. **Update: Required**. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The modeling aircraft id for the record, which defines the aircraft type used by the noise modeling software (i.e. INM or AEDT). **Insert: Required**. */
  modelingAircraftId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the modeling route associated with the record. **Insert: Required**. */
  modelingRouteId?: InputMaybe<Scalars['Int']['input']>;
  /** The number of flights that operated during the Night period (typically 23:00 to 07:00) for the record. */
  nightCount?: InputMaybe<Scalars['Float']['input']>;
  /** The unique id of this aircraft noise modeling scenario record. **Insert: Required**. **Update: Ignored**. */
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
  /** The stage length for the record, indicating how far the flights for this record have travelled.  Can be either M or a number from 1 to 11. **Insert: Required**. */
  stageLength?: InputMaybe<Scalars['String']['input']>;
};

export type InputAirportRunwayIdSet = {
  airportId: Scalars['String']['input'];
  runwayNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Describes a rule that detects operations that fail to climb continuously to a defined height or their top of ascent. */
export type InputCcoInfringementRule = {
  /** The length (in meters) that an operation will be automatically made an infringement if it flies level for longer than this. */
  autoInfringementSegmentLength?: InputMaybe<Scalars['Float']['input']>;
  /** The infringement candidate filter for the rule. */
  candidateFilter?: InputMaybe<InputInfringementCandidateFilter>;
  /** The maximum altitude (in feet above MSL) of the range in which the operations are tested against this rule. */
  ceilingAltitude?: InputMaybe<Scalars['Float']['input']>;
  /** The description of the infringement rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The minimum altitude (in feet above MSL) of the range in which the operations are tested against this rule. */
  floorAltitude?: InputMaybe<Scalars['Float']['input']>;
  /** The unique id of the infringement rule. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this rule is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum variation an operation's altitude can have before being detected as no longer flying level. */
  maxAltitudeVariation?: InputMaybe<Scalars['Float']['input']>;
  /** The maximum level segments an operation can have before an infringement is raised. */
  maxLevelSegments?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum length (in meters) that an operation must fly level before being detected as a level segment. */
  minLevelSegmentLength?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the infringement rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A value indicating whether a significant negative change in an operation's altitude can cause a level segment to end. */
  noDescentDuringSegment?: InputMaybe<Scalars['Boolean']['input']>;
  /** The default severity of infringements created by  this rule. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a rule that detects operations that fail to descend continuously from a defined height or their top of ascent. */
export type InputCdoInfringementRule = {
  /** The length (in meters) that an operation will be automatically made an infringement if it flies level for longer than this. */
  autoInfringementSegmentLength?: InputMaybe<Scalars['Float']['input']>;
  /** The infringement candidate filter for the rule. */
  candidateFilter?: InputMaybe<InputInfringementCandidateFilter>;
  /** The maximum altitude (in feet above MSL) of the range in which the operations are tested against this rule. */
  ceilingAltitude?: InputMaybe<Scalars['Float']['input']>;
  /** The description of the infringement rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The minimum altitude (in feet above MSL) of the range in which the operations are tested against this rule. */
  floorAltitude?: InputMaybe<Scalars['Float']['input']>;
  /** The unique id of the infringement rule. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this rule is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The maximum variation an operation's altitude can have before being detected as no longer flying level. */
  maxAltitudeVariation?: InputMaybe<Scalars['Float']['input']>;
  /** The maximum level segments an operation can have before an infringement is raised. */
  maxLevelSegments?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum length (in meters) that an operation must fly level before being detected as a level segment. */
  minLevelSegmentLength?: InputMaybe<Scalars['Float']['input']>;
  /** The name of the infringement rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A value indicating whether a significant positive change in an operation's altitude can cause a level segment to end. */
  noAscentDuringSegment?: InputMaybe<Scalars['Boolean']['input']>;
  /** The default severity of infringements created by  this rule. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** A comment that can be attached to a data model. */
export type InputComment = {
  /** The core text of the comment. */
  body: Scalars['String']['input'];
  /** The unique id of the comment. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type InputCorridor = {
  /** A filter for the corridor, which is used to determine which operations will be assessed by the corridor. */
  filter?: InputMaybe<InputGateFilter>;
  /** The geometry for the corridor. */
  geometry?: InputMaybe<Array<InputMaybe<InputGateGeometry>>>;
  /** The group name for the corridor. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the corridor. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this corridor is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the corridor. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a rule that detects operations that fail to operate within Noise Preferential Route's corridor. */
export type InputCorridorInfringementRule = {
  /** The side or sides of the corridor that an operation can penetrate to successfully navigate the corridor and not cause an infringement. */
  allowedPassage?: InputMaybe<Array<InputMaybe<CorridorPassage>>>;
  /** The infringement candidate filter for the rule. */
  candidateFilter?: InputMaybe<InputInfringementCandidateFilter>;
  /** The ceiling altitude (in feet above MSL) beyond which operations are not assessed. */
  ceilingAltitude?: InputMaybe<Scalars['Float']['input']>;
  /** The identifier of the corridor that will be checked for penetrations by operations. */
  corridorId?: InputMaybe<Scalars['Int']['input']>;
  /** The description of the infringement rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique id of the infringement rule. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this rule is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the infringement rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The name of the path which operations that follow it will be tested against the associated corridor. */
  pathName?: InputMaybe<Scalars['String']['input']>;
  /** The default severity of infringements created by  this rule. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a rule that detects operations that take place outside of allowable hours. */
export type InputCurfewInfringementRule = {
  /** The infringement candidate filter for the rule. */
  candidateFilter?: InputMaybe<InputInfringementCandidateFilter>;
  /** The description of the infringement rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique id of the infringement rule. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this rule is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the infringement rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The default severity of infringements created by  this rule. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a rule that detects operations that fly into excluded airspace. */
export type InputExclusionInfringementRule = {
  /** The infringement candidate filter for the rule. */
  candidateFilter?: InputMaybe<InputInfringementCandidateFilter>;
  /** The description of the infringement rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique id of the infringement rule. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this rule is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the infringement rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The selection zone id. */
  selectionZoneId?: InputMaybe<Scalars['Int']['input']>;
  /** The default severity of infringements created by  this rule. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

export type InputGate = {
  /** A filter for the gate, which is used to determine which operations will be assessed by the gate. */
  filter?: InputMaybe<InputGateFilter>;
  /** The geometry for the gate. */
  geometry?: InputMaybe<InputGateGeometry>;
  /** The group name for the gate. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the gate. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this gate is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the gate. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Describes a criteria that a flight is assessed against when checking it against a gate infringement rule. */
export type InputGateCriteria = {
  /** The optional altitude range (in feet above MSL) that forms part of the assessment criteria - setting this value to null indicates no sub-filter based on altitude. */
  altitudeRange?: InputMaybe<InputRangeOfFloat>;
  /** The optional gate directions that form part of the assessment criteria - setting the array as null indicates no sub-filter based on direction. */
  gateDirections?: InputMaybe<Array<InputMaybe<GateDirection>>>;
  /** The identifier of the gate. */
  gateId?: InputMaybe<Scalars['Int']['input']>;
  /** The intersection mode that must be followed to not be an infringement. */
  intersectionMode?: InputMaybe<GateIntersectionMode>;
  /** The speed range (in meters per second) that forms part of the assessment criteria - setting this value to null indicates no sub-filter based on speed. */
  speedRange?: InputMaybe<InputRangeOfFloat>;
};

/** Describes the filter for a gate or corridor, which controls which operations are assessed by geometric processing. */
export type InputGateFilter = {
  /** A list of operation types that are checked when processing the gate or corridor. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** A list of runways that are used in the filter when processing the gate or corridor. */
  runways?: InputMaybe<Array<InputMaybe<InputGateFilterRunway>>>;
};

/** Describes a runway filter for a gate or corridor. */
export type InputGateFilterRunway = {
  /** The key of the airport being used in the filter, as either IATA or ICAO. */
  airportId: Scalars['String']['input'];
  /** The name of the runway being used in the filter. */
  runwayName: Scalars['String']['input'];
};

export type InputGateGeometry = {
  /** The anchor position of the gate. */
  anchorPosition: InputPositionType;
  /** The ceiling altitude of the gate in feet above MSL. */
  ceilingAltitude: Scalars['Float']['input'];
  /** The floor altitude of the gate in feet above MSL. */
  floorAltitude: Scalars['Float']['input'];
  /** The left position of the gate. */
  leftPosition: InputPositionType;
  /** The right position of the gate. */
  rightPosition: InputPositionType;
};

/** Describes a rule that detects operations that fly into an excluded gate. */
export type InputGateInfringementRule = {
  /** The infringement candidate filter for the rule. */
  candidateFilter?: InputMaybe<InputInfringementCandidateFilter>;
  /** The description of the infringement rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The criteria for each gate in the rule that a flight is assessed against. */
  gateCriteria?: InputMaybe<Array<InputMaybe<InputGateCriteria>>>;
  /** The unique id of the infringement rule. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this rule is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the infringement rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The default severity of infringements created by  this rule. */
  severity?: InputMaybe<Scalars['String']['input']>;
};

export type InputGeographicCircleType = {
  /** The central point of a geographic circle. */
  location?: InputMaybe<InputPositionType>;
  /** The radius of a geographic circle in meters. */
  radius: Scalars['Float']['input'];
};

/** Allows a Grid to be supplied as an input parameter to GraphQL queries and mutations. */
export type InputGrid = {
  /** The center point of the grid. */
  centerPosition?: InputMaybe<InputPositionType>;
  /** The height of the grid, in meters. */
  height: Scalars['Float']['input'];
  /** The size of the cells within the grid, in meters. */
  resolution: Scalars['Float']['input'];
  /** The width of the grid, in meters. */
  width: Scalars['Float']['input'];
};

/** Describes a filter that can be applied to an infringement rule. */
export type InputInfringementCandidateFilter = {
  /** The aircraft categories applied by the filter. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** The aircraft types applied by the filter. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The airports and runways applied by the filter. */
  airportRunways?: InputMaybe<Array<InputMaybe<InputAirportRunwayIdSet>>>;
  /** The days of the week applied by the filter. */
  daysOfWeek?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  /** The end time of day applied by the filter. */
  endTime?: InputMaybe<Scalars['Seconds']['input']>;
  /** The lowest maximum landing weight applied by the filter. */
  lowestMaxLandingWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The lowest maximum take off weight applied by the filter. */
  lowestMaxTakeOffWeight?: InputMaybe<Scalars['Float']['input']>;
  /** The operation types applied by the filter. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** The operator categories applied by the filter. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** The name of the operation's path field that is applied by the filter. */
  pathName?: InputMaybe<Scalars['String']['input']>;
  /** The SQL query string used to define the filter. */
  queryString?: InputMaybe<Scalars['String']['input']>;
  /** The start time of day applied by the filter. */
  startTime?: InputMaybe<Scalars['Seconds']['input']>;
};

export type InputIntersectionFilter = {
  gateIntersection?: InputMaybe<GateIntersectionFilterInput>;
};

/** Describes a rule that detects operations that have triggered noise events. */
export type InputMonitorThreshold = {
  /** The location id for the noise event. */
  locationId: Scalars['Int']['input'];
  /** The noise threshold. */
  threshold: Scalars['Float']['input'];
};

/** Describes a rule that detects operations that have triggered noise events. */
export type InputNoiseInfringementRule = {
  /** The infringement candidate filter for the rule. */
  candidateFilter?: InputMaybe<InputInfringementCandidateFilter>;
  /** The description of the infringement rule. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique id of the infringement rule. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this rule is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The noise metric for the rule. Valid Values are: LMAX, LEQ, SEL, EPNL. */
  metric?: InputMaybe<Scalars['String']['input']>;
  /** The name of the infringement rule. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The default severity of infringements created by  this rule. */
  severity?: InputMaybe<Scalars['String']['input']>;
  /** The thresholds for the rule. */
  thresholds?: InputMaybe<Array<InputMaybe<InputMonitorThreshold>>>;
};

export type InputPcaFilter = {
  /** Only include flights whose horizontal distance (in meters) from the Point of Closest Approach to the reference point falls within this range (leave values null to not apply them in the filter). */
  horizontalRange?: InputMaybe<InputRangeOfFloat>;
  /** The reference point to which point of closest approaches are calculated. */
  position: InputPositionType;
  /** Only include flights whose slant distance (in meters) from the Point of Closest Approach to the reference point falls within this range (leave values null to not apply them in the filter). */
  slantRange?: InputMaybe<InputRangeOfFloat>;
  /** Only include flights whose vertical distance (in feet) from the Point of Closest Approach to the reference point falls within this range (leave values null to not apply them in the filter). */
  verticalRange?: InputMaybe<InputRangeOfFloat>;
};

export type InputPolygonSelectionZone = {
  /** The polygon selection zone's ceiling in feet above MSL. */
  ceilingAltitude?: InputMaybe<Scalars['Float']['input']>;
  /** The polygon selection zone's floor in feet above MSL. */
  floorAltitude?: InputMaybe<Scalars['Float']['input']>;
  /** The group name for the polygon selection zone. */
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** The id of the polygon selection zone. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this polygon selection zone is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the polygon selection zone. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The points that describe the polygon selection zone. */
  points?: InputMaybe<Array<InputMaybe<InputPositionType>>>;
};

/** A position in the world that is expressed in Latitude, Longitude and Altitude. */
export type InputPositionType = {
  /** The altitude of the Position in feet above mean sea level (AMSL). */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  /** The latitude (i.e. Y axis) of the Position, in decimal degrees. */
  latitude: Scalars['Float']['input'];
  /** The longitude (i.e. X axis) of the Position, in the decimal degrees. */
  longitude: Scalars['Float']['input'];
};

/** Defines a range of floating point numbers bounded by nullable start and end values. */
export type InputRangeOfFloat = {
  /** The ending vaue of the range. */
  end?: InputMaybe<Scalars['Float']['input']>;
  /** The starting value of the range. */
  start?: InputMaybe<Scalars['Float']['input']>;
};

/** A tag that can be added to a data object or used in filtering data objects to which it is attached. */
export type InputTag = {
  /**
   * When used as part of a mutation, indicates whether a data review tag is set to completed or not.
   * When used as part of a query filter, use a non-null boolean value to find objects whose data review tag is completed or not.
   */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the tag. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The unique id of the definition of the tag registered in the system. */
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

/** A daily time period expressed as a start and end time. The period can cross a midnight boundary by specifying an end time earlier than the start time */
export type InputTimePeriod = {
  /** The end time of the period. */
  end: Scalars['Seconds']['input'];
  /** The start time of the period. */
  start: Scalars['Seconds']['input'];
};

export type InputTrackDensityFilterType = {
  /** An Anoms API query cursor that contains the set of operations that will be included in a track density. */
  anomsApiQueryCursor: Scalars['String']['input'];
};

/**
 * Defines the start and end of each of the Day, Evening and Night periods that are used in noise measurement metrics such as DNL and LDEN/CNEL.
 *
 * Various metrics don't require the Evening or Night period to be specified - DNL doesn't have an evening period, for example, and an unweighted
 * "whole day" metric doesn't have an Evening or Night.  The model supports this by allowing the start of the evening and night periods
 * to be null (incidating they're not required).
 *
 * The end times of the periods are also defined, and are taken as relative to the start times of their subsequent day period (i.e. Day finishes at
 * Evening start, Evening finishes at Night Start, and Night finishes at Day start).  If a period's start time is null, so is its end time.
 *
 * When there is no Evening period, but there is a Night period, then Day finishes at Night start.
 * When there is no Evening or Night period, then Day finishes at Day Start.
 * When there is no Night period but an Evening period, then Evening finishes at Day Start.
 *
 * All times are in the local timezone to which they are being applied.
 */
export type MeasurementDayPeriod = {
  __typename?: 'MeasurementDayPeriod';
  /** The end of the Day period (exclusive). */
  dayEnd: Scalars['Seconds']['output'];
  /** The start time of the Day period (inclusive).  The Night period, if it exists, finishes just before this time. */
  dayStart: Scalars['Seconds']['output'];
  /** The end of the Evening period (exclusive), if the Evening period is defined. */
  eveningEnd?: Maybe<Scalars['Seconds']['output']>;
  /** The start time of the Evening period (inclusive), which is set to null for noise measurement metrics (such as DNL) that do not define an Evening period.  If there is an Evening period, the Day period ends just before this time. */
  eveningStart?: Maybe<Scalars['Seconds']['output']>;
  /** The end time of the Night period (exclusive), if the Night period is defined. */
  nightEnd?: Maybe<Scalars['Seconds']['output']>;
  /** The start time of the Night period (inclusive).  If there is an Evening period, it ends just before this time - otherwise it's the Day period that ends just before this time. */
  nightStart?: Maybe<Scalars['Seconds']['output']>;
};

/**
 * Defines the start of each of the Day, Evening and Night periods that are used in noise measurement metrics such as DNL and LDEN/CNEL.
 *
 * DNL by definition doesn't have an Evening period, and an unweighted Whole Day metric doesn't have either an Evening or a Night period.  Leave the start times of the unwanted periods as null or unspecified.
 *
 * All times are in the local timezone to which they are being applied.
 */
export type MeasurementDayPeriodInput = {
  /** The start time of the Day period (in seconds since midnight).  The Night period finishes just before this time. */
  dayStart: Scalars['Seconds']['input'];
  /** The start time of the Evening period (in seconds since midnight), which is set to null for noise measurement metrics (such as DNL) that do not define an Evening period.  When defined, the Day period ends just before this time. */
  eveningStart?: InputMaybe<Scalars['Seconds']['input']>;
  /** The start time of the Night period (in seconds since midnight).  If there is an Evening period, it ends just before this time - otherwise it's the Day period that ends just before this time. */
  nightStart?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Specifies the way in which a emission data is calculated based on the Metric selected. */
export enum Metric {
  /** Represents the average greenhouse gas emissions per flight. */
  GreenhouseGasPerMovement = 'GreenhouseGasPerMovement',
  /** Represents the average greenhouse gas emissions per passenger. */
  GreenhouseGasPerPassenger = 'GreenhouseGasPerPassenger',
  /** Represents the average greenhouse gas emissions per passenger kilometer travelled. */
  GreenhouseGasPerPassengerKilometer = 'GreenhouseGasPerPassengerKilometer',
  /** Represents total greenhouse gas emissions produced by all operations at the airport. */
  GreenhouseGasTotal = 'GreenhouseGasTotal',
  /** Represents TMA (Terminal Management Area) efficiency which is a rough guide to comparing desired approach distance to actual distance. */
  TerminalManagementAreaEfficiencyTotal = 'TerminalManagementAreaEfficiencyTotal'
}

export type MinHeightInfringement = Infringement & {
  __typename?: 'MinHeightInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  recordedAltitude: Scalars['Float']['output'];
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
};

export type MinHeightInfringementRule = InfringementRule & {
  __typename?: 'MinHeightInfringementRule';
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  flightDistance: Scalars['Float']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  requiredAltitude: Scalars['Float']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
};

export type MonitorLocation = {
  __typename?: 'MonitorLocation';
  airportId: Scalars['String']['output'];
  /** The noise device location configuration. */
  configuration?: Maybe<NoiseDeviceLocationConfiguration>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<PositionType>;
};

export type MonitorLocationSummary = {
  __typename?: 'MonitorLocationSummary';
  /** The description for the noise device. */
  deviceDescription?: Maybe<Scalars['String']['output']>;
  /** The unique id of noise device. */
  deviceId: Scalars['Int']['output'];
  /** The shortname for the noise device. */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** The model of the noise device. */
  deviceType?: Maybe<Scalars['String']['output']>;
  /** Whether or not the noise device is active. */
  isActive: Scalars['Boolean']['output'];
  /** When the last time data was recieved from this device location. */
  lastData?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the location for the noise device. */
  locationDescription?: Maybe<Scalars['String']['output']>;
  /** The unique id of the location. */
  locationId: Scalars['Int']['output'];
  /** The shortname of the location for the noise device. */
  locationName?: Maybe<Scalars['String']['output']>;
  /** This is the long lat position of the location. */
  position?: Maybe<PositionType>;
  /** The trigger type for this noise device location. */
  trigger: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `MonitorLocationSummary`. */
export type MonitorLocationSummaryConnection = {
  __typename?: 'MonitorLocationSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<MonitorLocationSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<MonitorLocationSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `MonitorLocationSummary`. */
export type MonitorLocationSummaryEdge = {
  __typename?: 'MonitorLocationSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MonitorLocationSummary>;
};

/** A set of query options that can be used for retrieving NoiseEventSummary data model objects */
export type MonitorLocationSummaryFilter = {
  /** A list of location ids that will be used to filter the result */
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type MonitorLocationTemplate = {
  __typename?: 'MonitorLocationTemplate';
  /** The activation time of the template. */
  activationTime: Scalars['Seconds']['output'];
  /** The End Event duration for the template. */
  endEventDuration: Scalars['Float']['output'];
  /** The location id of the template. */
  locationId: Scalars['Int']['output'];
  /** The Max Event duration for the template. */
  maxEventDuration: Scalars['Float']['output'];
  /** The Min Event duration for the template. */
  minEventDuration: Scalars['Float']['output'];
  /** The threshold for the template. */
  threshold: Scalars['Float']['output'];
  /** The noise metric used to detect noise events when the template is active. */
  trigger?: Maybe<NoiseMeasurementType>;
};

export type MonitorThreshold = {
  __typename?: 'MonitorThreshold';
  locationId: Scalars['Int']['output'];
  threshold: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Adds an aircraft complaint record with the provided parameters. */
  addAircraftComplaint?: Maybe<Complaint>;
  /** Adds a new record record.  See the **InputAircraftNoiseModelingScenarioRecord** documentation for validation rules applied during this mutation. */
  addAircraftNoiseModelingScenarioRecord?: Maybe<AircraftNoiseModelingScenarioRecord>;
  /** Adds a new rule record. */
  addCcoInfringementRule?: Maybe<InfringementRule>;
  /** Adds a new rule record. */
  addCdoInfringementRule?: Maybe<InfringementRule>;
  /** Adds a new complainer record. */
  addComplainer?: Maybe<Complainer>;
  /** Adds a note about the complaint. */
  addComplaintComment?: Maybe<Comment>;
  /** Adds a new corridor record. */
  addCorridor?: Maybe<CorridorType>;
  /** Adds a new rule record. */
  addCorridorInfringementRule?: Maybe<InfringementRule>;
  /** Adds a new rule record. */
  addCurfewInfringementRule?: Maybe<InfringementRule>;
  /** Adds a new rule record. */
  addExclusionInfringementRule?: Maybe<InfringementRule>;
  /** Adds a new gate record. */
  addGate?: Maybe<GateType>;
  /** Adds a new rule record. */
  addGateInfringementRule?: Maybe<InfringementRule>;
  /** Adds a new location record. */
  addNoiseDeviceLocation?: Maybe<MonitorLocation>;
  /** Adds tags to noiseEvent records and data review tags to have their isCompleted state set. */
  addNoiseEventTags?: Maybe<Array<Maybe<NoiseEvent>>>;
  /** Adds a new rule record. */
  addNoiseInfringementRule?: Maybe<InfringementRule>;
  /** Adds tags to operation records and data review tags to have their isCompleted state set. */
  addOperationTags?: Maybe<Array<Maybe<Operation>>>;
  /** Adds a new zone record. */
  addPolygonSelectionZone?: Maybe<SelectionZone>;
  /**
   *
   * Begins the upload process for an AEDT noise contour. A new upload job is created, containing an upload URL for a single file.
   *
   * The file must be a .zip file containing the ESRI Shape files that have been exported from AEDT which describe the contour.  The files that must be contained within the
   * .zip file are:
   * * A .shp file, containing the geometry for each contour band,
   * * A .dbf file, containing the Contour attribute to specify the level and the Metric attribute to specify the noise metric for every band,
   * * A .prj file, containing the details of the map projection which the contour's local coordinates are in,
   * * A .shx file, containing details about how to navigate the features within the shape file.
   *
   * Each of the files within the .zip file should have the same base name, but just a different extension.
   *
   * Use the generated signed URL to push the .zip file using HTTP PUT, then call **completeAircraftNoiseContourAEDTUpload**.
   *
   */
  beginAircraftNoiseContourAEDTUpload?: Maybe<DataFileUploadJob>;
  /**
   *
   * Begins the upload process for an INM noise contour. A new upload job is created, containing an upload URL for a single file.
   *
   * The file must be a .zip file containing the INM study files that have been processed in INM to contain a single output (that describes the contour).  The minimum set of files that must be contained within the
   * .zip file are:
   * * A scenario.dbf file, containing the name and description of the scenario (that will be copied to the contour),
   * * An output.dbf file, containing details of the contour such as the metric, min and max levels and level increments,
   * * A [output]\conr_pts.dbf file (in a subdirectory whose name will be matched to an entry in output.dbf), containing the geometry of the contour's bands
   *
   * Use the generated signed URL to push the .zip file using HTTP PUT, then call **completeAircraftNoiseContourINMUpload**.
   *
   * Note: INM allows multiple outputs (and therefore multiple conr_pts.dbf) files to be created from a single study, however the zip file must contain
   * **only 1** conr_pts.dbf file.  It is up to the caller of this API, or the user who is providing the file, to ensure this is the case.
   *
   * If there are missing files, or more than 1 of any of the required files, the processing of the contour will fail.
   *
   */
  beginAircraftNoiseContourINMUpload?: Maybe<DataFileUploadJob>;
  /** Cancel an already running track density. */
  cancelTrackDensity?: Maybe<Scalars['Boolean']['output']>;
  /** Requests reprocessing to occur for a scenario within a time range. */
  carbonEmissionsRequestReprocessing?: Maybe<Scalars['Int']['output']>;
  /**
   * Call this method once the AEDT .zip file has been uploaded to the URL provided by **beginAircraftNoiseContourAEDTUpload**.
   * The provided .zip file will be processed and the resulting contour will be added to the system.
   *
   * The returned result is just the provided jobId; use this to query **aircraftNoiseContourUploadResult**, which will indicate that the processing is complete.
   */
  completeAircraftNoiseContourAEDTUpload?: Maybe<Scalars['ID']['output']>;
  /**
   * Call this method once the INM .zip file has been uploaded to the URL provided by **beginAircraftNoiseContourINMUpload**.
   * The provided .zip file will be processed and the resulting contour will be added to the system.
   *
   * The returned result is just the provided jobId; use this to query **aircraftNoiseContourUploadResult**, which will indicate that the processing is complete.
   */
  completeAircraftNoiseContourINMUpload?: Maybe<Scalars['ID']['output']>;
  /** Deletes an existing contour record. */
  deleteAircraftNoiseContour?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing rule record. */
  deleteCcoInfringementRule?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing rule record. */
  deleteCdoInfringementRule?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing corridor record. */
  deleteCorridor?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing rule record. */
  deleteCorridorInfringementRule?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing rule record. */
  deleteCurfewInfringementRule?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing rule record. */
  deleteExclusionInfringementRule?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing gate record. */
  deleteGate?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing rule record. */
  deleteGateInfringementRule?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing rule record. */
  deleteNoiseInfringementRule?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes an existing zone record. */
  deletePolygonSelectionZone?: Maybe<Scalars['Boolean']['output']>;
  /** Removes a comment from a complaint. */
  removeComplaintComment?: Maybe<Scalars['Boolean']['output']>;
  /** Removes tags from noiseEvent records. */
  removeNoiseEventTags?: Maybe<Array<Maybe<NoiseEvent>>>;
  /** Removes tags from operation records. */
  removeOperationTags?: Maybe<Array<Maybe<Operation>>>;
  /** Reverts one or more DataUpdate changes associated with an Audit Log Entry for Operations, Tracks or Noise Events. */
  revertAuditLogEntries?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set how an scenario/aircraft type/engine model combination maps to a MappedLTOAircraftEngine and a MappedEnrouteAircraftEngine.
   *
   * The mutation will:
   * * Add a new mapping if one doesn't exist for the supplied scenario/aircraft/engine model
   * * Find a mapping with the supplied scenario/aircraft/engine model combination and updates it
   *
   * When adding or updating a mapping, the mutation will return the added/updated AircraftMapping object.
   *
   */
  setAirQualityAircraftTypeMap?: Maybe<AircraftMapping>;
  /** Correlates an aircraft complaint to an operation, or breaks an existing correlation. */
  setAircraftComplaintCorrelation?: Maybe<Complaint>;
  /**
   * Set how an aircraft/engine/airline combination maps to a noise modeling aircraft type.
   *
   * For the specified source (System or User), the mutation will:
   * * Add a new mapping if one doesn't exist for the supplied aircraft/engine/airline combination
   * * Find a mapping with the supplied aircraft/engine/airline combination and updates it
   * * Delete an existing mapping if the supplied noise modeling aircraft id is null
   *
   * When adding or updating a mapping, the mutation will return the added/updated aircraft to noise modeling type map object.
   *
   * When deleting an existing mapping, the mutation returns null.
   *
   * Note updating the System and User data sources are controlled by different permissions; most calls to this mutation should update the User data source unless
   * specifically intending to update the System data source.
   *
   */
  setAircraftToNoiseModelingTypeMap?: Maybe<AircraftToNoiseModelingTypeMap>;
  /** Sets the configuration for a noise device, also queueing the configuration to be sent to the device. */
  setNoiseDeviceConfiguration?: Maybe<NoiseDeviceConfiguration>;
  /** Sets the configuration for a noise device location, also queueing the configuration to be sent to the device. */
  setNoiseDeviceLocationConfiguration?: Maybe<NoiseDeviceLocationConfiguration>;
  setNoiseEventCause?: Maybe<NoiseEvent>;
  setNoiseEventsCause?: Maybe<Array<Maybe<NoiseEvent>>>;
  /** Updates a record whose id is supplied in the object provided in $complaint.  Only specify properties you want to update. */
  updateAircraftComplaint?: Maybe<Complaint>;
  /**
   * Bulk updates the properties on a set of complaint records whose ids are in the supplied list.
   * Only specify the arguments that match the properties you want to update.
   */
  updateAircraftComplaints?: Maybe<Array<Maybe<Complaint>>>;
  /** updateAircraftFuelMappings */
  updateAircraftFuelMappings?: Maybe<Array<Maybe<AircraftFuelMapping>>>;
  /** updateAircraftMappings */
  updateAircraftMappings?: Maybe<Array<Maybe<AircraftMapping>>>;
  /** Updates a record whose id is supplied in the object provided in $record.  Only specify properties you want to update.  See the **InputAircraftNoiseModelingScenarioRecord** documentation for validation rules applied during this mutation. */
  updateAircraftNoiseModelingScenarioRecord?: Maybe<AircraftNoiseModelingScenarioRecord>;
  /**
   * Bulk updates the properties on a set of records records whose ids are in the supplied list.
   * Only specify the arguments that match the properties you want to update.  See the **InputAircraftNoiseModelingScenarioRecord** documentation for validation rules applied during this mutation.
   */
  updateAircraftNoiseModelingScenarioRecords?: Maybe<Array<Maybe<AircraftNoiseModelingScenarioRecord>>>;
  /** updateAirlineLoadFactor */
  updateAirlineLoadFactor?: Maybe<Array<Maybe<AilineLoadFactors>>>;
  /** updateAirlineMappings */
  updateAirlineMappings?: Maybe<Array<Maybe<AirlineMapping>>>;
  /** Updates a record whose id is supplied in the object provided in $rule.  Only specify properties you want to update. */
  updateCcoInfringementRule?: Maybe<InfringementRule>;
  /** Updates a record whose id is supplied in the object provided in $rule.  Only specify properties you want to update. */
  updateCdoInfringementRule?: Maybe<InfringementRule>;
  /** Updates a record whose id is supplied in the object provided in $complainer.  Only specify properties you want to update. */
  updateComplainer?: Maybe<Complainer>;
  /** Updates a note about the complaint. */
  updateComplaintComment?: Maybe<Comment>;
  /** Updates a record whose id is supplied in the object provided in $corridor.  Only specify properties you want to update. */
  updateCorridor?: Maybe<CorridorType>;
  /** Updates a record whose id is supplied in the object provided in $rule.  Only specify properties you want to update. */
  updateCorridorInfringementRule?: Maybe<InfringementRule>;
  /** Updates a record whose id is supplied in the object provided in $rule.  Only specify properties you want to update. */
  updateCurfewInfringementRule?: Maybe<InfringementRule>;
  /** Updates a record whose id is supplied in the object provided in $rule.  Only specify properties you want to update. */
  updateExclusionInfringementRule?: Maybe<InfringementRule>;
  /** Updates a record whose id is supplied in the object provided in $gate.  Only specify properties you want to update. */
  updateGate?: Maybe<GateType>;
  /** Updates a record whose id is supplied in the object provided in $rule.  Only specify properties you want to update. */
  updateGateInfringementRule?: Maybe<InfringementRule>;
  /** Updates a record whose id is supplied in the object provided in $infringement.  Only specify properties you want to update. */
  updateInfringement?: Maybe<Infringement>;
  /**
   * Bulk updates the properties on a set of infringement records whose ids are in the supplied list.
   * Only specify the arguments that match the properties you want to update.
   */
  updateInfringements?: Maybe<Array<Maybe<Infringement>>>;
  /** Updates a record whose id is supplied in the object provided in $device.  Only specify properties you want to update. */
  updateNoiseDevice?: Maybe<NoiseDevice>;
  /** Updates a record whose id is supplied in the object provided in $location.  Only specify properties you want to update. */
  updateNoiseDeviceLocation?: Maybe<MonitorLocation>;
  /** Updates a record whose id is supplied in the object provided in $rule.  Only specify properties you want to update. */
  updateNoiseInfringementRule?: Maybe<InfringementRule>;
  /** Updates a record whose id is supplied in the object provided in $operation.  Only specify properties you want to update. */
  updateOperation?: Maybe<Operation>;
  /**
   * Bulk updates the properties on a set of operation records whose ids are in the supplied list.
   * Only specify the arguments that match the properties you want to update.
   */
  updateOperations?: Maybe<Array<Maybe<Operation>>>;
  /** updatePhaseDefaults */
  updatePhaseDefaults?: Maybe<Array<Maybe<PhaseDefault>>>;
  /** Updates a record whose id is supplied in the object provided in $zone.  Only specify properties you want to update. */
  updatePolygonSelectionZone?: Maybe<SelectionZone>;
  /** updateScenarios */
  updateScenarios?: Maybe<Array<Maybe<Scenario>>>;
  updateSettingsForDeployedProduct?: Maybe<Scalars['String']['output']>;
};


export type MutationAddAircraftComplaintArgs = {
  complaint: AircraftComplaintInput;
};


export type MutationAddAircraftNoiseModelingScenarioRecordArgs = {
  record: InputAircraftNoiseModelingScenarioRecord;
};


export type MutationAddCcoInfringementRuleArgs = {
  rule: InputCcoInfringementRule;
};


export type MutationAddCdoInfringementRuleArgs = {
  rule: InputCdoInfringementRule;
};


export type MutationAddComplainerArgs = {
  complainer: ComplainerInput;
};


export type MutationAddComplaintCommentArgs = {
  comment?: InputMaybe<InputComment>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddCorridorArgs = {
  corridor: InputCorridor;
};


export type MutationAddCorridorInfringementRuleArgs = {
  rule: InputCorridorInfringementRule;
};


export type MutationAddCurfewInfringementRuleArgs = {
  rule: InputCurfewInfringementRule;
};


export type MutationAddExclusionInfringementRuleArgs = {
  rule: InputExclusionInfringementRule;
};


export type MutationAddGateArgs = {
  gate: InputGate;
};


export type MutationAddGateInfringementRuleArgs = {
  rule: InputGateInfringementRule;
};


export type MutationAddNoiseDeviceLocationArgs = {
  location: NoiseDeviceLocationInput;
};


export type MutationAddNoiseEventTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<InputTag>>>;
};


export type MutationAddNoiseInfringementRuleArgs = {
  rule: InputNoiseInfringementRule;
};


export type MutationAddOperationTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<InputTag>>>;
};


export type MutationAddPolygonSelectionZoneArgs = {
  zone: InputPolygonSelectionZone;
};


export type MutationCancelTrackDensityArgs = {
  id: Scalars['String']['input'];
};


export type MutationCarbonEmissionsRequestReprocessingArgs = {
  endTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  scenarioId?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};


export type MutationCompleteAircraftNoiseContourAedtUploadArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCompleteAircraftNoiseContourInmUploadArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteAircraftNoiseContourArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCcoInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCdoInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCorridorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCorridorInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCurfewInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteExclusionInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGateInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNoiseInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePolygonSelectionZoneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveComplaintCommentArgs = {
  commentId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveNoiseEventTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<InputTag>>>;
};


export type MutationRemoveOperationTagsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<InputTag>>>;
};


export type MutationRevertAuditLogEntriesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type MutationSetAirQualityAircraftTypeMapArgs = {
  aircraftType: Scalars['String']['input'];
  engineModel: Scalars['String']['input'];
  enrouteAircraftType?: InputMaybe<Scalars['String']['input']>;
  enrouteEngineModel?: InputMaybe<Scalars['String']['input']>;
  ltoAircraftType?: InputMaybe<Scalars['String']['input']>;
  ltoEngineModel?: InputMaybe<Scalars['String']['input']>;
  scenarioId: Scalars['ID']['input'];
  source?: InputMaybe<AirQualityMappingSource>;
};


export type MutationSetAircraftComplaintCorrelationArgs = {
  correlation?: InputMaybe<AircraftComplaintCorrelationDetails>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetAircraftToNoiseModelingTypeMapArgs = {
  aircraftType?: InputMaybe<Scalars['String']['input']>;
  airline?: InputMaybe<Scalars['String']['input']>;
  engineModel?: InputMaybe<Scalars['String']['input']>;
  modelingAircraftId?: InputMaybe<Scalars['String']['input']>;
  noiseModelType: AircraftNoiseModelType;
  source: NoiseModelingTypeMapSource;
};


export type MutationSetNoiseDeviceConfigurationArgs = {
  configuration: NoiseDeviceConfigurationInput;
};


export type MutationSetNoiseDeviceLocationConfigurationArgs = {
  configuration: NoiseDeviceLocationConfigurationInput;
};


export type MutationSetNoiseEventCauseArgs = {
  cause?: InputMaybe<NoiseEventCause>;
  classificationOverride?: InputMaybe<Scalars['String']['input']>;
  correlation?: InputMaybe<NoiseEventCorrelationDetails>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetNoiseEventsCauseArgs = {
  cause?: InputMaybe<NoiseEventCause>;
  classificationOverride?: InputMaybe<Scalars['String']['input']>;
  correlatedDataEffect?: InputMaybe<NoiseEventCorrelatedDataUpdate>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationUpdateAircraftComplaintArgs = {
  complaint: AircraftComplaintInput;
};


export type MutationUpdateAircraftComplaintsArgs = {
  ids: Array<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAircraftFuelMappingsArgs = {
  aircraftFuelMappings?: InputMaybe<Array<InputMaybe<BulkAircraftFuelMappingChangeInput>>>;
};


export type MutationUpdateAircraftMappingsArgs = {
  aircraftMappings?: InputMaybe<Array<InputMaybe<BulkAircraftMappingChangeInput>>>;
};


export type MutationUpdateAircraftNoiseModelingScenarioRecordArgs = {
  record: InputAircraftNoiseModelingScenarioRecord;
};


export type MutationUpdateAircraftNoiseModelingScenarioRecordsArgs = {
  dayCount?: InputMaybe<Scalars['Float']['input']>;
  eveningCount?: InputMaybe<Scalars['Float']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  modelingAircraftId?: InputMaybe<Scalars['String']['input']>;
  modelingRouteId?: InputMaybe<Scalars['Int']['input']>;
  nightCount?: InputMaybe<Scalars['Float']['input']>;
  stageLength?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAirlineLoadFactorArgs = {
  airlineLoadFactor?: InputMaybe<Array<InputMaybe<BulkAirlineLoadFactorsChangeInput>>>;
};


export type MutationUpdateAirlineMappingsArgs = {
  airlineMappings?: InputMaybe<Array<InputMaybe<BulkAirlineMappingChangeInput>>>;
};


export type MutationUpdateCcoInfringementRuleArgs = {
  rule: InputCcoInfringementRule;
};


export type MutationUpdateCdoInfringementRuleArgs = {
  rule: InputCdoInfringementRule;
};


export type MutationUpdateComplainerArgs = {
  complainer: ComplainerInput;
};


export type MutationUpdateComplaintCommentArgs = {
  comment?: InputMaybe<InputComment>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateCorridorArgs = {
  corridor: InputCorridor;
};


export type MutationUpdateCorridorInfringementRuleArgs = {
  rule: InputCorridorInfringementRule;
};


export type MutationUpdateCurfewInfringementRuleArgs = {
  rule: InputCurfewInfringementRule;
};


export type MutationUpdateExclusionInfringementRuleArgs = {
  rule: InputExclusionInfringementRule;
};


export type MutationUpdateGateArgs = {
  gate: InputGate;
};


export type MutationUpdateGateInfringementRuleArgs = {
  rule: InputGateInfringementRule;
};


export type MutationUpdateInfringementArgs = {
  infringement: InfringementInput;
};


export type MutationUpdateInfringementsArgs = {
  actionRequired?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  excused?: InputMaybe<Scalars['Boolean']['input']>;
  excusedReason?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['Int']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateNoiseDeviceArgs = {
  device: NoiseDeviceInput;
};


export type MutationUpdateNoiseDeviceLocationArgs = {
  location: NoiseDeviceLocationInput;
};


export type MutationUpdateNoiseInfringementRuleArgs = {
  rule: InputNoiseInfringementRule;
};


export type MutationUpdateOperationArgs = {
  operation: OperationInput;
};


export type MutationUpdateOperationsArgs = {
  aircraftCategory?: InputMaybe<AircraftCategory>;
  aircraftCount?: InputMaybe<Scalars['Int']['input']>;
  aircraftType?: InputMaybe<Scalars['String']['input']>;
  airline?: InputMaybe<Scalars['String']['input']>;
  airportId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['Int']['input']>;
  operationType?: InputMaybe<OperationType>;
  operatorCategory?: InputMaybe<OperatorCategory>;
  remoteAirportId?: InputMaybe<Scalars['String']['input']>;
  runwayName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePhaseDefaultsArgs = {
  phaseDefaults?: InputMaybe<Array<InputMaybe<BulkPhaseDefaultChangeInput>>>;
};


export type MutationUpdatePolygonSelectionZoneArgs = {
  zone: InputPolygonSelectionZone;
};


export type MutationUpdateScenariosArgs = {
  scenarios?: InputMaybe<Array<InputMaybe<BulkScenarioChangeInput>>>;
};


export type MutationUpdateSettingsForDeployedProductArgs = {
  settings?: InputMaybe<Array<InputMaybe<SettingInput>>>;
};

export type NoiseDevice = {
  __typename?: 'NoiseDevice';
  /** The noise device configurations. */
  configuration?: Maybe<NoiseDeviceConfiguration>;
  /** The device description. */
  description: Scalars['String']['output'];
  /** The external identification key of the device. */
  deviceKey?: Maybe<Scalars['String']['output']>;
  /** A key that is used to identify the incoming device messages in the ingestion queues. */
  deviceRegistrationKey?: Maybe<Scalars['String']['output']>;
  /** A string that represents the type of device. */
  deviceType: Scalars['String']['output'];
  /** The Noise device's id. */
  id: Scalars['Int']['output'];
  /** A value indicating whether this instance is currently active and recording information. */
  isActive: Scalars['Boolean']['output'];
  /** A value indicating whether this instance is mobile and able to be moved around. */
  isPortable: Scalars['Boolean']['output'];
  /** The device's location id */
  locationId: Scalars['Int']['output'];
  /** The device name. This is only nullable for backwards compatiability. */
  name?: Maybe<Scalars['String']['output']>;
  /** The serial number of the device. */
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type NoiseDeviceConfiguration = {
  __typename?: 'NoiseDeviceConfiguration';
  /** The expected decibel level recorded by the device during a controlled/test noise event. */
  acousticLevel: Scalars['Float']['output'];
  /** The allowed variation from the AcousticLevel before an acoustic calibration is considered failed. */
  acousticTolerance: Scalars['Float']['output'];
  /** The times of the day when the device will perform a calibration test */
  calibrationTimes?: Maybe<Array<Maybe<Scalars['Seconds']['output']>>>;
  /** The device id. */
  deviceId: Scalars['Int']['output'];
  /** The expected decibel level recorded by the device during a simulated/digital on-device test. */
  injectionLevel: Scalars['Float']['output'];
  /** The allowed variation from the InjectionLevel before an injection calibration is considered failed. */
  injectionTolerance: Scalars['Float']['output'];
};

export type NoiseDeviceConfigurationInput = {
  /** The Acoustic Level. */
  acousticLevel?: InputMaybe<Scalars['Float']['input']>;
  /** The Acoustic Tolerance. */
  acousticTolerance?: InputMaybe<Scalars['Float']['input']>;
  /** The Calibration Times. **Insert: Required**. */
  calibrationTimes?: InputMaybe<Array<InputMaybe<Scalars['Seconds']['input']>>>;
  /** The device id. **Insert: Required**. */
  deviceId?: InputMaybe<Scalars['Int']['input']>;
  /** The Injection Level. */
  injectionLevel?: InputMaybe<Scalars['Float']['input']>;
  /** The Injection Tolearance. */
  injectionTolerance?: InputMaybe<Scalars['Float']['input']>;
};

export type NoiseDeviceInput = {
  /** The device description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The external identification key of the device. */
  deviceKey?: InputMaybe<Scalars['String']['input']>;
  /** A key that is used to identify the incoming device messages in the ingestion queues. */
  deviceRegistrationKey?: InputMaybe<Scalars['String']['input']>;
  /** A string that represents the type of device. */
  deviceType?: InputMaybe<Scalars['String']['input']>;
  /** The Noise device's id. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** A value indicating whether this instance is currently active and recording information. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A value indicating whether this instance is mobile and able to be moved around. */
  isPortable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The device's location id */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** The device name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The serial number of the device. */
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type NoiseDeviceLocationConfiguration = {
  __typename?: 'NoiseDeviceLocationConfiguration';
  /** The unique identifier of the noise monitor location. */
  locationId: Scalars['Int']['output'];
  /** The device location templates */
  noiseEventTemplates?: Maybe<Array<Maybe<MonitorLocationTemplate>>>;
  /** The device location Percentiles */
  percentiles?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type NoiseDeviceLocationConfigurationInput = {
  /** The unique identifier of the noise monitor location. **Insert: Required**. */
  locationId?: InputMaybe<Scalars['Int']['input']>;
  /** The device location templates. **Insert: Required**. */
  noiseEventTemplates?: InputMaybe<Array<InputMaybe<NoiseEventTemplateInput>>>;
  /** The device location Percentiles. */
  percentiles?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type NoiseDeviceLocationFilter = {
  /** The end time of a period in which a device at the deviceing location must have been actively recording data in order to be returned by the filter. */
  activePeriodEndTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  /** The start time of a period in which a device at the deviceing location must have been actively recording data in order to be returned by the filter. */
  activePeriodStartTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  /** A list of AirportIds to retrieve as part of the filter. */
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A value indicating whether the location has devices. */
  hasAttachedDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of Ids to retrieve as part of the filter. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of Names to retrieve as part of the filter. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NoiseDeviceLocationInput = {
  /** The description of the noise monitor location. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The facility the device location is associated with. */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the noise monitor location. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the noise monitor location. **Insert: Required**. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The position of the noise monitor location. **Insert: Required**. */
  position?: InputMaybe<InputPositionType>;
  /** The weather monitor for this location. */
  weatherLocationId?: InputMaybe<Scalars['Int']['input']>;
};

/** A noise event recorded by a noise monitor */
export type NoiseEvent = {
  __typename?: 'NoiseEvent';
  /** The classification of the noise event that provides more specific details about its identified source. */
  classification?: Maybe<Scalars['String']['output']>;
  /** Details about the correlated data associated with the primary cause of the noise event. */
  correlation?: Maybe<NoiseEventCorrelationInterface>;
  /** The unique id for the noise event. */
  id: Scalars['Int']['output'];
  /** The id of the noise monitor location at which the noise event was recorded. */
  locationId: Scalars['Int']['output'];
  /** The identified primary cause of the noise event. */
  primaryCause?: Maybe<NoiseEventCause>;
  /** The tags associated with the noise event. */
  tags?: Maybe<Array<Maybe<Tag>>>;
};


/** A noise event recorded by a noise monitor */
export type NoiseEventTagsArgs = {
  returnOnly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NoiseEventAudio = {
  __typename?: 'NoiseEventAudio';
  deviceId: Scalars['Int']['output'];
  duration: Scalars['Float']['output'];
  endTime: Scalars['DateTimeOffset']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  noiseEventId: Scalars['Int']['output'];
  resourceUri?: Maybe<UriResource>;
  startTime: Scalars['DateTimeOffset']['output'];
};

/** A list of possible noise event causes. */
export enum NoiseEventCause {
  /** The primary cause of the noise event is aircraft. */
  Aircraft = 'Aircraft',
  /** The primary cause of the noise event is community. */
  Community = 'Community',
  /** The primary cause of the noise event is equipment related. */
  Equipment = 'Equipment',
  /** The cause of the noise event is not known. */
  Unknown = 'Unknown',
  /** The primary cause of the noise event is weather. */
  Weather = 'Weather'
}

export enum NoiseEventClass {
  /** A noise event attributed to the community. */
  Community = 'Community',
  /** A noise event attributed to the community and local aircraft. */
  CommunityAndLocalAircraft = 'CommunityAndLocalAircraft',
  /** A noise event attributed to the community and non local aircraft. */
  CommunityAndNonLocalAircraft = 'CommunityAndNonLocalAircraft',
  /** A noise event attributed to equipment. */
  Equipment = 'Equipment',
  /** A noise event attributed to mixed local and non local aircraft. */
  MixedLocalAndNonLocalAircraft = 'MixedLocalAndNonLocalAircraft',
  /** A noise event attributed to multiple local aircraft. */
  MultipleLocalAircraft = 'MultipleLocalAircraft',
  /** A noise event attributed to non local aircraft. */
  NonLocalAircraft = 'NonLocalAircraft',
  /** A noise event that has yet to be attributed. */
  NotSet = 'NotSet',
  /** A noise event attributed to a single local aircraft. */
  SingleLocalAircraft = 'SingleLocalAircraft',
  /** A noise event attributed to the weather. */
  Weather = 'Weather'
}

/** Definitions of what will happen to correlated data when changing a noise event's primary cause. */
export enum NoiseEventCorrelatedDataUpdate {
  /** Always break existing correlations. */
  BreakExistingCorrelations = 'BreakExistingCorrelations',
  /** Maintain correlations for noise events when the noise event's cause is not changed from its current value. */
  MaintainCorrelationsWithSameCause = 'MaintainCorrelationsWithSameCause'
}

/** Information relating to data to which to correlate the noise event, such as a flight. */
export type NoiseEventCorrelationDetails = {
  /** The id of the operation to correlate to the noise event. */
  operationId?: InputMaybe<Scalars['Int']['input']>;
};

/** Describes the correlation between a noise event and the primary source of the noise. */
export type NoiseEventCorrelationInterface = {
  /** The name of the type of data to which the noise event is correlated. */
  targetDataType: Scalars['String']['output'];
};

/** Information about the correlation between a noise event and an operation. */
export type NoiseEventOperationCorrelation = NoiseEventCorrelationInterface & {
  __typename?: 'NoiseEventOperationCorrelation';
  operationId: Scalars['Int']['output'];
  /** The name of the type of data to which the noise event is correlated. */
  targetDataType: Scalars['String']['output'];
};

export type NoiseEventSampleCollection = {
  __typename?: 'NoiseEventSampleCollection';
  duration: Scalars['Float']['output'];
  endTime: Scalars['DateTimeOffset']['output'];
  frequencyWeighting?: Maybe<FrequencyWeighting>;
  id: Scalars['Int']['output'];
  noiseEventId: Scalars['Int']['output'];
  noiseMeasurementType?: Maybe<NoiseMeasurementType>;
  sampleResolution: Scalars['Float']['output'];
  sampleType?: Maybe<SampleType>;
  samples?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  startTime: Scalars['DateTimeOffset']['output'];
  timeWeighting?: Maybe<TimeWeighting>;
};

export type NoiseEventSummary = {
  __typename?: 'NoiseEventSummary';
  /** The aircraft identifier (ACID) of the operation correlated to the noise event, if any. */
  acid?: Maybe<Scalars['String']['output']>;
  /** The aircraft category of the operation correlated to the noise event, if any. */
  aircraftCategory?: Maybe<AircraftCategory>;
  /** The aircraft type of the operation correlated to the noise event, if any. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The airline of the operation correlated to the noise event, if any. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The local airport that the correlated  operation landed at or took off from, as either IATA or ICAO. */
  airportId?: Maybe<Scalars['String']['output']>;
  /** Details about an audio recording taken during the noise event. */
  audio?: Maybe<NoiseEventAudio>;
  /** The classification of the noise event. */
  classification?: Maybe<NoiseEventClass>;
  /** The correlation id of the noise event. */
  correlationId?: Maybe<Scalars['Int']['output']>;
  /** The duration of the noise event, in seconds. */
  duration: Scalars['Float']['output'];
  /** The end time of the noise event. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** The EPNL (Effective Perceived Noise Level) of the noise event, in dB. */
  epnl?: Maybe<Scalars['Float']['output']>;
  /** The unique id of the noise event. */
  id: Scalars['Int']['output'];
  /** The LEQ (Level Equivalent) of the noise event, in dB. */
  leq: Scalars['Float']['output'];
  /** The description of the noise event location that recorded the noise. */
  locationDescription: Scalars['String']['output'];
  /** The id of the noise event location that recorded the noise. */
  locationId: Scalars['Int']['output'];
  /** The name of the noise event location that recorded the noise. */
  locationName: Scalars['String']['output'];
  /** The max level of the noise event, in dB. */
  maxLevel: Scalars['Float']['output'];
  /** Details about the operation correlated to the noise event, if any. */
  operation?: Maybe<OperationSummary>;
  /** The unique id of the operation correlated to the noise event, if any. */
  operationId?: Maybe<Scalars['Int']['output']>;
  /** The operation type of the operation correlated to the noise event, if any. */
  operationType?: Maybe<OperationType>;
  /** The category of the operator of the correlated operation, if any. */
  operatorCategory?: Maybe<OperatorCategory>;
  /** The remote airport of the correlated operation, as either IATA or ICAO. */
  remoteAirportId?: Maybe<Scalars['String']['output']>;
  /** The name runway that the correlated operation landed at or took off from. */
  runwayName?: Maybe<Scalars['String']['output']>;
  /** The noise samples recorded during the noise event, in dB. */
  samples?: Maybe<NoiseEventSampleCollection>;
  /** The SEL (Sound Energy Level) of the noise event, in dB. */
  sel: Scalars['Float']['output'];
  /** The start time of the noise event. */
  startTime: Scalars['DateTimeOffset']['output'];
  /** A list of tags associated with the noise event. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The noise event threshold configured on the noise monitor when the noise event was recorded, in dB. */
  threshold: Scalars['Float']['output'];
  /** The time of the max level of the noise event. */
  time: Scalars['DateTimeOffset']['output'];
};


export type NoiseEventSummaryTagsArgs = {
  returnOnly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection from an object to a list of objects of type `NoiseEventSummary`. */
export type NoiseEventSummaryConnection = {
  __typename?: 'NoiseEventSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<NoiseEventSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<NoiseEventSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `NoiseEventSummary`. */
export type NoiseEventSummaryEdge = {
  __typename?: 'NoiseEventSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<NoiseEventSummary>;
};

/** A set of query options that can be used for retrieving NoiseEventSummary data model objects */
export type NoiseEventSummaryFilter = {
  /** A list of correlated operation aircraft categories that will be used to filter the results. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** A list of correlated operation aircraft types that will be used to filter the results. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of correlated operation airlines that will be used to filter the results. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of noise event classifications that will be used to filter the results. */
  classifications?: InputMaybe<Array<InputMaybe<NoiseEventClass>>>;
  /** A list of correlation ids that will be used to filter the results. */
  correlationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Filters results to those whose duration (seconds) falls within a min/max range. */
  durationRange?: InputMaybe<InputRangeOfFloat>;
  /** Only noise events that have none of these supplied tags will be returned. */
  excludeTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** Only noise events that have at least one of these supplied tags will be returned. */
  includeTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** A list of noise event ids that will be used to filter the results. */
  limitToIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of noise monitor location ids that will be used to filter the results. */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of noise monitor location names that will be used to filter the results. */
  locationNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filters results to those whose max level (dB) values fall within a min/max range. */
  maxLevelRange?: InputMaybe<InputRangeOfFloat>;
  /** A list of correlated operation ids that will be used to filter the results. */
  operationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** A list of correlated operation types that will be used to filter the results. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** A list of flight operator categories that will be used to filter the results. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** Filters results to those whose SEL (dB) values fall within a min/max range. */
  sELRange?: InputMaybe<InputRangeOfFloat>;
  /** The time period used as part of the filter (i.e. daily start and end times). */
  timePeriod?: InputMaybe<InputTimePeriod>;
};

export type NoiseEventTemplateInput = {
  /** The activation time of the template. */
  activationTime?: InputMaybe<Scalars['Seconds']['input']>;
  /** The End Event duration for the template. */
  endEventDuration?: InputMaybe<Scalars['Float']['input']>;
  /** The Max Event duration for the template. */
  maxEventDuration?: InputMaybe<Scalars['Float']['input']>;
  /** The Min Event duration for the template. */
  minEventDuration?: InputMaybe<Scalars['Float']['input']>;
  /** The threshold for the template. */
  threshold?: InputMaybe<Scalars['Float']['input']>;
  /** The trigger for the the template. */
  trigger?: InputMaybe<NoiseMeasurementType>;
};

export type NoiseInfringement = Infringement & {
  __typename?: 'NoiseInfringement';
  actionRequired?: Maybe<Scalars['String']['output']>;
  assignedTo?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  excused: Scalars['Boolean']['output'];
  excusedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  infringementType?: Maybe<InfringementType>;
  noiseEventIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  operationId: Scalars['Int']['output'];
  position?: Maybe<PositionType>;
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  severity: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time: Scalars['DateTimeOffset']['output'];
};

export type NoiseInfringementRule = InfringementRule & {
  __typename?: 'NoiseInfringementRule';
  /** The infringement candidate filter for the rule. */
  candidateFilter?: Maybe<InfringementCandidateFilter>;
  /** The date time the infringement rule was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The description of the infringement rule. */
  description: Scalars['String']['output'];
  /** The unique id of the infringement rule. */
  id: Scalars['Int']['output'];
  /** The type of the infringement rule. */
  infringementType?: Maybe<InfringementType>;
  /** A value indicating whether this rule is active. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the infringement rule was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  metric: Scalars['String']['output'];
  /** The name of the infringement rule. */
  name: Scalars['String']['output'];
  /** The default severity of infringements created by  this rule. */
  severity: Scalars['String']['output'];
  thresholds?: Maybe<Array<Maybe<MonitorThreshold>>>;
};

export enum NoiseMeasurementType {
  /** An A-weighted, fast time-weighted, sound level. */
  Laf = 'LAF',
  /** An A-weighted, impulse time-weighted, sound level. */
  Lai = 'LAI',
  /** An A-weighted, slow-time weighted, sound level. */
  Las = 'LAS',
  /** An A-weighted LEQ value. */
  LAeq = 'LAeq',
  /** An A-weighted peak sound level. */
  LApk = 'LApk',
  /** A C-weighted, fast time-weighted, sound level. */
  Lcf = 'LCF',
  /** A C-weighted, impulse time-weighted, sound level. */
  Lci = 'LCI',
  /** A C-weighted, slow time-weighted, sound level. */
  Lcs = 'LCS',
  /** A C-weighted LEQ value. */
  LCeq = 'LCeq',
  /** A C-weighted, peak sound level. */
  LCpk = 'LCpk',
  /** A Z-weighted, fast time-weighted, sound level. */
  Lzf = 'LZF',
  /** A Z-weighted, impulse time-weighted, sound level. */
  Lzi = 'LZI',
  /** A Z-weighted, slow time-weighted, sound level. */
  Lzs = 'LZS',
  /** A Z-weighted LEQ value. */
  LZeq = 'LZeq',
  /** A Z-weighted, peak sound level. */
  LZpk = 'LZpk',
  /** An LEQ value with an unknown frequency weighting. */
  Leq = 'Leq',
  /** A perceived noise level which accounts for the fact that jet engines are perceived to be noisier than propeller aircraft. */
  Pnl = 'PNL',
  /** A tone-corrected perceived noise level which has been adjusted for the degree of irregularity that may occur among contiguous one-third-octave band sound pressure levels of aircraft noise. */
  Pnlt = 'PNLT',
  /** Sound Pressure Level or Sound Level when Frequency Weighting and Time Weighting is unknown. */
  Spl = 'SPL'
}

/** A specific aircraft that is recognised within modeling software such as INM or AEDT. */
export type NoiseModelingAircraftType = {
  __typename?: 'NoiseModelingAircraftType';
  /** The identifier that the modeling software knows this aircraft type as. */
  aircraftId: Scalars['String']['output'];
  /** The display name that a user of the modeling software knows this aircraft type as. */
  aircraftName: Scalars['String']['output'];
  /** The unique id of this aircraft noise modeling type. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The maximum stage length that an aircraft with this type can fly on departure. */
  maxStageLength: Scalars['Int']['output'];
  /** The type of noise model this aircraft noise modeling type belongs to. */
  noiseModelType?: Maybe<AircraftNoiseModelType>;
  /** Whether the modeling software supports an 'M' stage length, which means the modeling software should set the stage length from the aircraft's maximum take-off weight. */
  supportsMaxMtowStageLength: Scalars['Boolean']['output'];
};

/** Enumerates the sources of data that aircraft to noise modeling type maps can come from. */
export enum NoiseModelingTypeMapSource {
  /** Indicates that the data is part of the System supplied source. */
  System = 'System',
  /** Indicates that the data is a User-supplied override. */
  User = 'User'
}

/** Details of a flight that was recorded at an airport. */
export type Operation = {
  __typename?: 'Operation';
  /** The aircraft identifier (ACID). */
  acid?: Maybe<Scalars['String']['output']>;
  /** The actual aircraft that flew the operation. */
  aircraft?: Maybe<Aircraft>;
  /** The category of the operation's aircraft. */
  aircraftCategory?: Maybe<AircraftCategory>;
  /** The number of aircraft represented by the individual operation record. */
  aircraftCount?: Maybe<Scalars['Int']['output']>;
  /** The id of the Aircraft that flew the flight. */
  aircraftId?: Maybe<Scalars['Int']['output']>;
  /** The type of the operation's aircraft, typically an ICAO code. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The operation's airline, typically an ICAO code. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The local airport that the operation landed at or took off from, as either IATA or ICAO. */
  airportId?: Maybe<Scalars['String']['output']>;
  /** The operation's beacon (SSR) code. */
  beaconCode?: Maybe<Scalars['Int']['output']>;
  /** The operation's callsign. */
  callSign?: Maybe<Scalars['String']['output']>;
  /** An id that can be used to retrieve data that is associated with the operation. */
  correlationId?: Maybe<Scalars['Int']['output']>;
  /** The time of the last track point for the operation. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** @deprecated Deprecated: use FlightNumber instead */
  flightNum?: Maybe<Scalars['String']['output']>;
  /** The operation's flight number. */
  flightNumber?: Maybe<Scalars['String']['output']>;
  /** The unique id of the operation. */
  id: Scalars['Int']['output'];
  /** The id of the aircraft noise modeling route that is associated with this operation. */
  modelingRouteId?: Maybe<Scalars['Int']['output']>;
  /** The type of the Operation, indicating whether it is arriving, departing, or other. */
  operationType?: Maybe<OperationType>;
  /** The category of the flight's operator. */
  operatorCategory?: Maybe<OperatorCategory>;
  /** The name of the path the operation followed when arriving or departing from the airport. */
  pathName?: Maybe<Scalars['String']['output']>;
  /** The radar track points for the operation. */
  points?: Maybe<Array<Maybe<TrackPoint>>>;
  /** The remote airport, as either IATA or ICAO. */
  remoteAirportId?: Maybe<Scalars['String']['output']>;
  /** The name of the runway that the operation landed or took off from at the airport. */
  runwayName?: Maybe<Scalars['String']['output']>;
  /** The time of the first track point for the operation. */
  startTime: Scalars['DateTimeOffset']['output'];
  /** A list of tags associated with the operation. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The tail number of the operation's aircraft. */
  tailNumber?: Maybe<Scalars['String']['output']>;
  /** The time of interest for the flight. */
  time: Scalars['DateTimeOffset']['output'];
};


/** Details of a flight that was recorded at an airport. */
export type OperationTagsArgs = {
  returnOnly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection from an object to a list of objects of type `Operation`. */
export type OperationConnection = {
  __typename?: 'OperationConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<OperationEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<Operation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OperationCorrelation = {
  __typename?: 'OperationCorrelation';
  /** The total number of CCO infringements for the operation. */
  ccoInfringementCount: Scalars['Int']['output'];
  /** The total number of CDO infringements for the operation. */
  cdoInfringementCount: Scalars['Int']['output'];
  /** The total number of Complaints correlated to the operation. */
  complaintCount: Scalars['Int']['output'];
  /** The list of complaints correlated to the operation. */
  complaints?: Maybe<Array<Maybe<ComplaintSummaryType>>>;
  /** The total number of correlated items for the operation. */
  correlationCount: Scalars['Int']['output'];
  /** The correlation id of the operation. */
  correlationId?: Maybe<Scalars['Int']['output']>;
  /** The total number of Corridor infringements for the operation. */
  corridorInfringementCount: Scalars['Int']['output'];
  /** The total number of Curfew infringements for the operation. */
  curfewInfringementCount: Scalars['Int']['output'];
  /** The total number of Exclusion infringements for the operation. */
  exclusionInfringementCount: Scalars['Int']['output'];
  /** The total number of Gate infringements for the operation. */
  gateInfringementCount: Scalars['Int']['output'];
  /** The total number of infringements for the operation. */
  infringementCount: Scalars['Int']['output'];
  /** The list of infringements associated with the operation. */
  infringements?: Maybe<Array<Maybe<InfringementSummary>>>;
  /** The total number of Min Height infringements for the operation. */
  minHeightInfringementCount: Scalars['Int']['output'];
  /** The total number of Noise Events correlated to the operation. */
  noiseEventCount: Scalars['Int']['output'];
  /** The list of noise events correlated to the operation. */
  noiseEvents?: Maybe<Array<Maybe<NoiseEventSummary>>>;
  /** The total number of Noise infringements for the operation. */
  noiseInfringementCount: Scalars['Int']['output'];
  /** The unique id of the operation. */
  operationId: Scalars['Int']['output'];
  /** The weather record associated with the operation. */
  weather?: Maybe<PeriodicWeather>;
};

/** An edge in a connection from an object to another object of type `Operation`. */
export type OperationEdge = {
  __typename?: 'OperationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Operation>;
};

export type OperationFilter = {
  /** An array of aircraft ids that will be used to filter the results. */
  acids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of aircraft categories that will be used to filter the results. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** An array of aircraft types that will be used to filter the results. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of airlines that will be used to filter the results. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of airport ids that will be used to filter the results. */
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Only operations that have none of these supplied tags will be returned. */
  excludeTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** Only operations that have at least one of these supplied tags will be returned. */
  includeTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** An array of operation types that will be used to filter the results. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** An array of operator categories that will be used to filter the results. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** An array of path names that will be used to filter the results. */
  pathNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of remote airport ids that will be used to filter the results. */
  remoteAirportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of runway names that will be used to filter the results. */
  runwayNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The time period used as part of the filter (i.e. daily start and end times). */
  timePeriod?: InputMaybe<InputTimePeriod>;
};

export type OperationInput = {
  /** A value used to set the operation's aircraft category. */
  aircraftCategory?: InputMaybe<AircraftCategory>;
  /** A value used to set the operation's aicraft count. */
  aircraftCount?: InputMaybe<Scalars['Int']['input']>;
  /** A value used to set the operation's aircraft type. */
  aircraftType?: InputMaybe<Scalars['String']['input']>;
  /** A value used to set the operation's airline. */
  airline?: InputMaybe<Scalars['String']['input']>;
  /** A value used to set the operation's airport id. */
  airportId?: InputMaybe<Scalars['String']['input']>;
  /** A value used to set the operation's beacon code. */
  beaconCode?: InputMaybe<Scalars['Int']['input']>;
  /** A value used to set the operation's callsign. */
  callSign?: InputMaybe<Scalars['String']['input']>;
  /** A value used to set the operation's flight number. */
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** A value used to set the operation's operation type. */
  operationType?: InputMaybe<OperationType>;
  /** A value used to set the operation's operator category. */
  operatorCategory?: InputMaybe<OperatorCategory>;
  /** A value used to set the operation's path name. */
  pathName?: InputMaybe<Scalars['String']['input']>;
  /** A value used to set the operation's remote airport id. */
  remoteAirportId?: InputMaybe<Scalars['String']['input']>;
  /** A value used to set the operation's runway name. */
  runwayName?: InputMaybe<Scalars['String']['input']>;
  /** A value used to set the operation's tailnumber. */
  tailNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Provides information related to a Point of Closest Approach between a reference position and an operation. */
export type OperationPca = {
  __typename?: 'OperationPca';
  /** The angle of elevation between the horizontal ground plane and the line of sight to the identified track point, in degrees. */
  elevationAngle: Scalars['Float']['output'];
  /** The horizontal distance measurement (i.e. without altitude) between the reference position and the identified track point, in meters. */
  horizontalDistance: Scalars['Float']['output'];
  /** The operation related to the measurement. */
  operation?: Maybe<Operation>;
  /** The position from which pca measurements were taken. */
  referencePosition?: Maybe<PositionType>;
  /** The slant distance measurement (i.e. from point to point) between the reference position and the identified track point, in meters. */
  slantDistance: Scalars['Float']['output'];
  /** The time of the identified point of closest approach */
  time: Scalars['DateTimeOffset']['output'];
  /** The identified track point.  Note this may be a 'virtual' track point betweeen two track points. */
  trackPoint?: Maybe<TrackPoint>;
  /** The difference in altitude between the reference position and the identified track point, in feet. */
  verticalDistance: Scalars['Float']['output'];
};

export type OperationSummary = {
  __typename?: 'OperationSummary';
  /** The aircraft identifier (ACID). */
  acid: Scalars['String']['output'];
  /** The category of the operation's aircraft. */
  aircraftCategory?: Maybe<AircraftCategory>;
  /** The number of aircraft represented by the individual operation record. */
  aircraftCount?: Maybe<Scalars['Int']['output']>;
  /** The type of the operation's aircraft, typically an ICAO code. */
  aircraftType?: Maybe<Scalars['String']['output']>;
  /** The operation's airline, typically an ICAO code. */
  airline?: Maybe<Scalars['String']['output']>;
  /** The local airport that the operation landed at or took off from, as either IATA or ICAO. */
  airportId?: Maybe<Scalars['String']['output']>;
  /** The beacon (SSR) code of the operation. */
  beaconCode?: Maybe<Scalars['Int']['output']>;
  /** The operation's call sign. */
  callSign?: Maybe<Scalars['String']['output']>;
  /** Details about data that has been correlated to the operation. */
  correlated?: Maybe<OperationCorrelation>;
  /** An id that can be used to retrieve data that is associated with the operation. */
  correlationId?: Maybe<Scalars['Int']['output']>;
  /** The time of the last track point for the operation. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** The operation's flight number. */
  flightNumber?: Maybe<Scalars['String']['output']>;
  /** All intersection points with gates. */
  gateIntersections?: Maybe<Array<Maybe<GateIntersectionInfo>>>;
  /**
   * A GeoJson LineString representation of the track points that can be presented to a map that understands the format.
   * @deprecated Support for exporting GeoJson tracks via the GraphQL API will be removed in a future version; please use the WebServices.MapLayerApi instead.
   */
  geoJson?: Maybe<GeoJsonLineString>;
  /** The unique id of the operation. */
  id: Scalars['Int']['output'];
  /** The type of the Operation, indicating whether it is arriving, departing, or other. */
  operationType?: Maybe<OperationType>;
  /** The category of the flight's operator. */
  operatorCategory?: Maybe<OperatorCategory>;
  /** The route for the operation. */
  pathName?: Maybe<Scalars['String']['output']>;
  /** The point of closest approach between the operation and a supplied position. */
  pca?: Maybe<OperationPca>;
  /** The track points for the operation's track. */
  points?: Maybe<Array<Maybe<TrackPoint>>>;
  /** The track profile for the operation, providing distance (as meters from runway threshold for departures or arrival threshold for arrivals) vs altitude (as feet above MSL). */
  profile?: Maybe<Array<Maybe<TrackProfilePoint>>>;
  /** The remote airport, as either IATA or ICAO. */
  remoteAirportId?: Maybe<Scalars['String']['output']>;
  /** The name of the runway that the operation landed or took off from at the airport. */
  runwayName?: Maybe<Scalars['String']['output']>;
  /** A number indicating how far the operation will fly, and is used in noise modeling software such as INM or AEDT. */
  stageLength?: Maybe<Scalars['Int']['output']>;
  /** The time of the first track point for the operation. */
  startTime: Scalars['DateTimeOffset']['output'];
  /** A list of tags associated with the operation. */
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** The tail number for the operation. */
  tailNumber?: Maybe<Scalars['String']['output']>;
  /** The time of interest for the flight. */
  time: Scalars['DateTimeOffset']['output'];
};


export type OperationSummaryGateIntersectionsArgs = {
  gateIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type OperationSummaryPcaArgs = {
  position: InputPositionType;
};


export type OperationSummaryTagsArgs = {
  returnOnly?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection from an object to a list of objects of type `OperationSummary`. */
export type OperationSummaryConnection = {
  __typename?: 'OperationSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<OperationSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<OperationSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `OperationSummary`. */
export type OperationSummaryEdge = {
  __typename?: 'OperationSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OperationSummary>;
};

export type OperationSummaryFilter = {
  /** An array of aircraft ids that will be used to filter the results. */
  acids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of aircraft categories that will be used to filter the results. */
  aircraftCategories?: InputMaybe<Array<InputMaybe<AircraftCategory>>>;
  /** An array of aircraft types that will be used to filter the results. */
  aircraftTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of airlines that will be used to filter the results. */
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of airport ids that will be used to filter the results. */
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Only operations that have none of these supplied tags will be returned. */
  excludeTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** Filters results based on whether they have any associated CCO infringements. */
  hasCcoInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated CDO infringements. */
  hasCdoInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any correlated complaints. */
  hasComplaints?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they are correlated to any related data at all. */
  hasCorrelations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated Corridor infringements. */
  hasCorridorInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated Curfew infringements. */
  hasCurfewInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated Exclusion Zone infringements. */
  hasExclusionInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated Gate infringements. */
  hasGateInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated infringements (of any type). */
  hasInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated Min Height infringements. */
  hasMinHeightInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any correlated noise events. */
  hasNoiseEvents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters results based on whether they have any associated Noise infringements. */
  hasNoiseInfringements?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only operations that have at least one of these supplied tags will be returned. */
  includeTags?: InputMaybe<Array<InputMaybe<InputTag>>>;
  /** An array of operation ids that will be used to filter the results. */
  limitToIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** An array of operation types that will be used to filter the results. */
  operationTypes?: InputMaybe<Array<InputMaybe<OperationType>>>;
  /** An array of operator categories that will be used to filter the results. */
  operatorCategories?: InputMaybe<Array<InputMaybe<OperatorCategory>>>;
  /** An array of path names that will be used to filter the results. */
  pathNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of remote airport ids that will be used to filter the results. */
  remoteAirportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of runway names that will be used to filter the results. */
  runwayNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** An array of tail numbers that will be used to filter the results. Supports wildcard searching (using the * character) at the start, end, or start and end for specifying partial matches. */
  tailNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The time period used as part of the filter (i.e. daily start and end times). */
  timePeriod?: InputMaybe<InputTimePeriod>;
};

export enum OperationType {
  /** An operation which arrives at one of the customer's airports. */
  Arrival = 'Arrival',
  /** An operation which departs from one of the customer's airports. */
  Departure = 'Departure',
  /** An operation that is associated with one of the customer's airports but that performed a non-specific procedure. */
  Miscellaneous = 'Miscellaneous',
  /** An operation which neither arrives at nor departs from any of a customer's airports. */
  Overflight = 'Overflight',
  /** An operation which 'touches down' on a runway but immediately performs a takeoff as part of the same maneuver. */
  TouchAndGo = 'TouchAndGo'
}

export enum OperatorCategory {
  /** Owned/operated by an air-taxi service. */
  AirTaxi = 'AirTaxi',
  /** An airline owner/operator. */
  Airline = 'Airline',
  /** Owned/operated by a cargo company. */
  Cargo = 'Cargo',
  /** A fractionally owned aircraft that has multiple partial owners. */
  Fractional = 'Fractional',
  /** A small, typically local owner/operator. */
  GeneralAviation = 'GeneralAviation',
  /** Owned/operated by the lifeguard. */
  Lifeguard = 'Lifeguard',
  /** Owned/operated by the military. */
  Military = 'Military',
  /** Does not fit into any of the other categories. */
  Other = 'Other',
  /** An unknown owner/operator. */
  Unknown = 'Unknown'
}

export enum OrderByDirectionEnum {
  /** Sort ascending */
  Asc = 'ASC',
  /** Sort descending */
  Desc = 'DESC'
}

export type OrderByType = {
  direction?: InputMaybe<OrderByDirectionEnum>;
  field: Scalars['String']['input'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Details of a periodic report, including details of how to download the generated file. */
export type PeriodicReport = {
  __typename?: 'PeriodicReport';
  /** The data type of the periodic report. */
  dataType: Scalars['String']['output'];
  /** The end time of the periodic report. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** The number of times the report has generated an error while being updated. */
  errorCount: Scalars['Int']['output'];
  /** The file size of the periodic report, in bytes. */
  fileSize: Scalars['Int']['output'];
  /** The unique id of the periodic report. */
  id: Scalars['Int']['output'];
  /** Indicates whether the periodic report can be downloaded. */
  isAvailable: Scalars['Boolean']['output'];
  /** The last update time of the periodic report. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the periodic report, which is usually based on the template name and also contains the start time of the report. */
  name: Scalars['String']['output'];
  /** The next update time of the periodic report. */
  nextUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** Indicates whether the periodic report is out of date. */
  outOfDate: Scalars['Boolean']['output'];
  /** A resource that can be used to download a report from a remote location. */
  reportFileResource?: Maybe<UriResource>;
  /** The format of the periodic report, such as Excel or Csv. */
  reportFormat: Scalars['String']['output'];
  /** The interval of the periodic report, such as Monthly or Quarterly. */
  reportInterval?: Maybe<ReportInterval>;
  /** The start time of the periodic report. */
  startTime: Scalars['DateTimeOffset']['output'];
  /** The name of the template that was used to generate this report. */
  templateName: Scalars['String']['output'];
  /** The time of the periodic report. */
  time: Scalars['DateTimeOffset']['output'];
};

/** A connection from an object to a list of objects of type `PeriodicReport`. */
export type PeriodicReportConnection = {
  __typename?: 'PeriodicReportConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<PeriodicReportEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<PeriodicReport>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `PeriodicReport`. */
export type PeriodicReportEdge = {
  __typename?: 'PeriodicReportEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PeriodicReport>;
};

export type PeriodicReportFilter = {
  /** Filter reports by one or more data types, such as Operation or NoiseEvent. */
  dataType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter reports by whether the report has an error or not. */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter reports by their availability (whether the report can be downloaded or not). */
  isAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter reports by whether tehy are out of date or not. */
  outOfDate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter reports by one or more report types, such as Excel or CSV. */
  reportFormat?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter reports by the interval they cover, such as Monthly or Quarterly. */
  reportInterval?: InputMaybe<Array<InputMaybe<ReportInterval>>>;
  /** Filter reports by one or more template names. */
  templateNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PeriodicWeather = {
  __typename?: 'PeriodicWeather';
  /** The atmospheric pressure recorded during the periodic weather report, in hectopascals (hPa). */
  atmosphericPressure?: Maybe<Scalars['Float']['output']>;
  /** The altitude of the base of the lowest clouds during the periodic weather report, in feet above MSL. */
  ceiling?: Maybe<Scalars['Float']['output']>;
  /** The cloud cover details for the periodic weather report. */
  cloudCover?: Maybe<Scalars['String']['output']>;
  /** The weather station identifier that recorded the periodic weather report. */
  deviceId: Scalars['Int']['output'];
  /** The duration of the periodic weather report in seconds. */
  duration: Scalars['Float']['output'];
  /** The end time of the periodic weather report. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** The flight rules that aircraft should operate under during the periodic weather report. */
  flightRules?: Maybe<FlightRules>;
  /** The unique id of the periodic weather report. */
  id: Scalars['Int']['output'];
  /** The maximum wind speed that occurred during the periodic weather report, in meters per second. */
  maxWindSpeed?: Maybe<Scalars['Float']['output']>;
  /** The description of the precipitation during the periodic weather report. */
  precipitation?: Maybe<Scalars['String']['output']>;
  /** The amount of rain recorded during the periodic weather report, in millimeters. */
  rainfall?: Maybe<Scalars['Float']['output']>;
  /** The relative humidity during the periodic weather report, expressed as a percentage. */
  relativeHumidity?: Maybe<Scalars['Float']['output']>;
  /** The original message received from the data source, which may contain extra information not available in the other fields. */
  sourceMessage?: Maybe<Scalars['String']['output']>;
  /** The start time of the periodic weather report. */
  startTime: Scalars['DateTimeOffset']['output'];
  /** The temperature during the periodic weather report, in degrees celsius. */
  temperature?: Maybe<Scalars['Float']['output']>;
  /** The time of the periodic weather report. */
  time: Scalars['DateTimeOffset']['output'];
  /** The prevailing visibility during the periodic weather report, in meters. */
  visibility?: Maybe<Scalars['Float']['output']>;
  /**
   * The weather station identifier that recorded the periodic weather report.
   * @deprecated Deprecated: use **DeviceId** instead
   */
  weatherStationId: Scalars['Int']['output'];
  /** The average wind direction that the wind is coming from during the periodic weather report, in degrees from North. */
  windDirection?: Maybe<Scalars['Float']['output']>;
  /** A compass direction indicating the average direction the wind is coming from during the periodic weather report. */
  windDirectionCompass?: Maybe<Scalars['String']['output']>;
  /** The average wind speed recorded during the periodic weather report, in meters per second. */
  windSpeed?: Maybe<Scalars['Float']['output']>;
  /**
   * The wind gust speed that occurred during the periodic weather report, in meters per second.
   * @deprecated Deprecated: use **MaxWindSpeed** instead
   */
  windSpeedGust?: Maybe<Scalars['Float']['output']>;
};

/** Specifies the way in which a emission data is filtered based on the phase to calculate emission columns. */
export enum Phase {
  /** A flight's approach phase of arrival Phases. */
  Approach = 'Approach',
  /** A flight's climb phase of departure Phases. */
  Climb = 'Climb',
  /** A flight's Enroute phase. */
  Enroute = 'Enroute',
  /** A flight's hold phase of arrival Phases. */
  Hold = 'Hold',
  /**  A flight's taxiIn phase of arrival Phases. */
  TmaIn = 'TMAIn',
  /** A flight's tmaOut(which is the final leg outside of the TMA-Terminal Management Area after the climb) phase of departure Phases. */
  TmaOut = 'TMAOut',
  /** A flight's takeoff phase of departure Phases. */
  Takeoff = 'Takeoff',
  /** A flight's TMAIn(the initial entry) phase of arrival Phases. */
  TaxiIn = 'TaxiIn',
  /** A flight's taxiout phase of departure Phases. */
  Taxiout = 'Taxiout'
}

/** The time of each phase at airport and they vary from runway to runway. */
export type PhaseDefault = {
  __typename?: 'PhaseDefault';
  /** The airport for associated with the runway. */
  airport: Scalars['String']['output'];
  /** The approach phase duration in seconds. */
  durationApproach: Scalars['Int']['output'];
  /** The climb phase duration in seconds. */
  durationClimb: Scalars['Int']['output'];
  /** The takeoff phase duration in seconds. */
  durationTakeoff: Scalars['Int']['output'];
  /** The taxiIn phase duration in seconds. */
  durationTaxiIn: Scalars['Int']['output'];
  /** The taxiOut phase duration in seconds. */
  durationTaxiOut: Scalars['Int']['output'];
  /** The id of the default LTO phases time mapping associated with a runway. */
  id: Scalars['Int']['output'];
  /** The runway for which LTO(Landing and Take-off Cycle)  phase time in seconds are recorded. */
  runway: Scalars['String']['output'];
  /** The scenario id, which identifies a unique configuration airquality emission data. */
  scenarioId: Scalars['Int']['output'];
};

/** PhaseDefaultInput of the time of each phase at airport and they vary from runway to runway. */
export type PhaseDefaultInput = {
  /** The airport for associated with the runway. */
  airport?: InputMaybe<Scalars['String']['input']>;
  /** The approach phase duration in seconds. */
  durationApproach?: InputMaybe<Scalars['Int']['input']>;
  /** The climb phase duration in seconds. */
  durationClimb?: InputMaybe<Scalars['Int']['input']>;
  /** The takeoff phase duration in seconds. */
  durationTakeoff?: InputMaybe<Scalars['Int']['input']>;
  /** The taxiIn phase duration in seconds. */
  durationTaxiIn?: InputMaybe<Scalars['Int']['input']>;
  /** The taxiOut phase duration in seconds. */
  durationTaxiOut?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the default LTO phases time mapping associated with a runway. */
  id: Scalars['Int']['input'];
  /** The runway for which LTO(Landing and Take-off Cycle)  phase time in seconds are recorded. */
  runway?: InputMaybe<Scalars['String']['input']>;
  /** The scenario id, which identifies a unique configuration airquality emission data. */
  scenarioId: Scalars['Int']['input'];
};

/** Provide fields to query complainers or update the phone number indicating the type */
export type PhoneNumberInput = {
  /** The phone number, such as 555-1234 */
  number?: InputMaybe<Scalars['String']['input']>;
  /** The associated type of device this number represents */
  type?: InputMaybe<PhoneNumberTypeEnum>;
};

/** A phone number with an associated phone number type, such as Mobile or Home. */
export type PhoneNumberType = {
  __typename?: 'PhoneNumberType';
  /** The phone number, such as 555-1234 */
  number: Scalars['String']['output'];
  /** The associated type of device this number represents */
  type?: Maybe<PhoneNumberTypeEnum>;
};

/** An enumeration specifying the type of number a phone number can be */
export enum PhoneNumberTypeEnum {
  /** The number represents a home phone number */
  Home = 'Home',
  /** The type of number is a Mobile/Cell number */
  Mobile = 'Mobile',
  /** The type of number is unknown */
  NotSet = 'NotSet',
  /** The type of number is known, but is none of the above types */
  Other = 'Other',
  /** The number represents a work phone number */
  Work = 'Work'
}

export type PolygonSelectionZone = SelectionZone & {
  __typename?: 'PolygonSelectionZone';
  /** The polygon's ceiling altitude in feet above MSL */
  ceilingAltitude: Scalars['Float']['output'];
  /** The time the selection zone was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The polygon's floor altitude in feet above MSL */
  floorAltitude: Scalars['Float']['output'];
  /** The name of the group to which the selection zone belongs. */
  groupName: Scalars['String']['output'];
  /** The id of the selection zone. */
  id: Scalars['Int']['output'];
  /** Indicates whether the selection zone is active and will process data. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the selection zone was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the selection zone. */
  name: Scalars['String']['output'];
  /** The points that make up the polygon. */
  points?: Maybe<Array<Maybe<PositionType>>>;
  /** The type of selection zone. */
  selectionZoneType?: Maybe<SelectionZoneType>;
};

/** A position in the world that is expressed in Latitude, Longitude and Altitude. */
export type PositionType = {
  __typename?: 'PositionType';
  /** The altitude of the Position in feet above mean sea level (AMSL). */
  altitude?: Maybe<Scalars['Float']['output']>;
  /** The latitude (i.e. Y axis) of the Position, in decimal degrees. */
  latitude: Scalars['Float']['output'];
  /** The longitude (i.e. X axis) of the Position, in the decimal degrees. */
  longitude: Scalars['Float']['output'];
};

/** An agreement under which a persons private (i.e. personal) data is stored. */
export type PrivacyAgreement = {
  __typename?: 'PrivacyAgreement';
  /** The length of consent granted by this privacy agreement. */
  acceptanceTerm: Scalars['Seconds']['output'];
  /** The privacy agreement detail/body. */
  agreement: Scalars['String']['output'];
  /** The time at which this PrivacyAgreement is no longer the current PrivacyAgreement. Or null if current. */
  expiredTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The unique id of this PrivacyAgreement. */
  id: Scalars['Int']['output'];
  /** The friendly name (i.e. title) to describe/summarize the agreement. */
  name: Scalars['String']['output'];
  /** The time at which this PrivacyAgreement became the current PrivacyAgreement. */
  startTime?: Maybe<Scalars['DateTimeOffset']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get all air quality aircraft mapping summaries, allowing filtering within those records. */
  airQualityAircraftMappingSummariesByTimeRange?: Maybe<AirQualityAircraftMappingSummaryConnection>;
  /** Get AirQuality column collection. */
  airQualitySummaryTableByTimeRange?: Maybe<SummaryTable>;
  aircraft?: Maybe<Aircraft>;
  aircraftByIds?: Maybe<Array<Maybe<Aircraft>>>;
  /** Get all aircraftFlights by time range. */
  aircraftFlightsByTimeRange?: Maybe<Array<Maybe<AircraftFlights>>>;
  /** Get aircraftFuelMappings by scenario ids. */
  aircraftFuelMappingsByScenarioIds?: Maybe<Array<Maybe<AircraftFuelMapping>>>;
  /** Get aircraftMappings by scenario ids. */
  aircraftMappingsByScenarioIds?: Maybe<Array<Maybe<AircraftMapping>>>;
  aircraftNoiseContour?: Maybe<AircraftNoiseContour>;
  /**
   * This is the fourth action in uploading a contour:
   * 1. Call beginAircraftNoiseContourAEDTUpload or beginAircraftNoiseContourINMUpload
   * 2. Upload the contour's file(s) using HTTP PUT to the URLs returned
   * 3. Call completeAircraftNoiseContourAEDTUpload or completeAircraftNoiseContourINMUpload
   * 4. Call this method to get the status of the contour processing and, if finished, the id of the contour that was generated from the files.
   *
   * If there was an error in processing the contour, the return result will indicate that via its status field.
   *
   * Note that this method applies to either AEDT or INM contours.
   */
  aircraftNoiseContourUploadResult?: Maybe<AircraftNoiseContourUploadResult>;
  /** Gets all noise contours, optionally restricting the results by a provided filter. */
  aircraftNoiseContours?: Maybe<Array<Maybe<AircraftNoiseContour>>>;
  aircraftNoiseContoursByIds?: Maybe<Array<Maybe<AircraftNoiseContour>>>;
  aircraftNoiseModelingRoute?: Maybe<AircraftNoiseModelingRoute>;
  /** Get all registered aircraft noise modeling routes. */
  aircraftNoiseModelingRoutes?: Maybe<Array<Maybe<AircraftNoiseModelingRoute>>>;
  aircraftNoiseModelingRoutesByIds?: Maybe<Array<Maybe<AircraftNoiseModelingRoute>>>;
  aircraftNoiseModelingScenario?: Maybe<AircraftNoiseModelingScenario>;
  aircraftNoiseModelingScenarioRecord?: Maybe<AircraftNoiseModelingScenarioRecord>;
  /** Get all aircraft noise modeling scenario record summaries for an already created scenario, allowing filtering within those records. */
  aircraftNoiseModelingScenarioRecordSummaries?: Maybe<AircraftNoiseModelingScenarioRecordSummaryConnection>;
  aircraftNoiseModelingScenarioRecordSummariesByIds?: Maybe<Array<Maybe<AircraftNoiseModelingScenarioRecordSummary>>>;
  aircraftNoiseModelingScenarioRecordSummary?: Maybe<AircraftNoiseModelingScenarioRecordSummary>;
  /** Get records related to an aircraft noise modeling scenario. */
  aircraftNoiseModelingScenarioRecords?: Maybe<AircraftNoiseModelingScenarioRecordConnection>;
  /** Finds all scenarios that have been created for the current user, sorted by createTime in descending order. */
  aircraftNoiseModelingScenariosForCurrentUser?: Maybe<Array<Maybe<AircraftNoiseModelingScenario>>>;
  /** Get all aircraft to noise modeling type summaries within a time range. */
  aircraftToNoiseModelingTypeSummariesByTimeRange?: Maybe<AircraftToNoiseModelingTypeSummaryConnection>;
  /** Get airlineLoadFactor by scenario ids. */
  airlineLoadFactorByScenarioIds?: Maybe<Array<Maybe<AilineLoadFactors>>>;
  /** Get AirlineMappings by scenario ids */
  airlineMappingsByScenarioIds?: Maybe<Array<Maybe<AirlineMapping>>>;
  airport?: Maybe<AirportType>;
  /** Get all airports */
  airports?: Maybe<Array<Maybe<AirportType>>>;
  airportsByIds?: Maybe<Array<Maybe<AirportType>>>;
  auditLogEntrySummariesByIds?: Maybe<Array<Maybe<AuditLogEntrySummary>>>;
  /** Get audit log entries whose Time is within a time range. */
  auditLogEntrySummariesByTimeRange?: Maybe<AuditLogEntrySummaryConnection>;
  auditLogEntrySummary?: Maybe<AuditLogEntrySummary>;
  complainer?: Maybe<Complainer>;
  complainersByIds?: Maybe<Array<Maybe<Complainer>>>;
  /** Get complainers that are most likely to have raised a complaint. */
  complainersByMostLikely?: Maybe<ComplainerConnection>;
  /** Get complainers matching partially all provided parameters ignoring case. */
  complainersByPartialMatch?: Maybe<ComplainerConnection>;
  complaint?: Maybe<Complaint>;
  complaintSummariesByIds?: Maybe<Array<Maybe<ComplaintSummaryType>>>;
  /** Get complaints whose Event Time is within a time range. */
  complaintSummariesByTimeRange?: Maybe<ComplaintSummaryConnection>;
  complaintSummary?: Maybe<ComplaintSummaryType>;
  complaintsByIds?: Maybe<Array<Maybe<Complaint>>>;
  /** Get all complaints whose time is within a time range. */
  complaintsByTimeRange?: Maybe<AircraftComplaintConnection>;
  /** Get continuous noise sample collections whose Start and End Time is within a time range */
  continuousNoiseSamplesByTimeRange?: Maybe<Array<Maybe<ContinuousNoiseSampleCollection>>>;
  corridor?: Maybe<CorridorType>;
  /** Get all corridors */
  corridors?: Maybe<Array<Maybe<CorridorType>>>;
  corridorsByIds?: Maybe<Array<Maybe<CorridorType>>>;
  /**
   * Create a new aircraft noise modeling scenario. Use the return value in the aircraftNoiseModelingScenario query to get the scenario and its status.
   *
   * A scenario can only be created from arrival and departure flights; providing something other than this will result in an error.
   *
   * Analysed flights are filtered to the airports that are licensed for use in modeling.
   *
   */
  createAircraftNoiseModelingScenario?: Maybe<Scalars['String']['output']>;
  /** Create a track density from the results of an Operations query.  Returns an id that can be used to get the results using trackDensity. */
  createTrackDensity?: Maybe<Scalars['String']['output']>;
  /** Get current user's dashboards */
  currentUserDashboards?: Maybe<Array<Maybe<Dashboard>>>;
  /** Gets permissions for the currently logged in user. */
  currentUserPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Gets the dashboard access token to render the report. */
  dashboardAccessToken?: Maybe<DashboardAccessInfo>;
  /** Get all Enroute Aircraft Engine Mappings. */
  enrouteAircraftEngineMappings?: Maybe<Array<Maybe<AircraftEngineMapping>>>;
  /**
   * Exports the records contained in an Aircraft Noise Modeling Contour to a set of files that can be imported into the target noise modeling package.
   *
   * The target noise modeling package will be either AEDT or INM, based on what NoiseModelType is set in the AircraftNoiseModelingScenario when it was created.
   *
   * This call creates a job to do the export in the background, and returns the job of the id.  Call exportResult(id: ID!) with this id
   * to get the current status of the export job.
   */
  exportAircraftNoiseModelingScenario?: Maybe<Scalars['ID']['output']>;
  exportData?: Maybe<Scalars['String']['output']>;
  exportResult?: Maybe<ExportResultType>;
  gate?: Maybe<GateType>;
  /** Get all gates */
  gates?: Maybe<Array<Maybe<GateType>>>;
  gatesByIds?: Maybe<Array<Maybe<GateType>>>;
  /** Takes a partial address and returns potential matches from a geocoding API, including their geographic position. */
  geocodeAddress?: Maybe<Array<Maybe<GeocodedAddress>>>;
  /** Takes a unique address identifier and returns the address detail including their geographic position. */
  geocodeCandidateDetail?: Maybe<GeocodedAddress>;
  /** Takes a position (latitude/longitude) on the globe and returns the addresses that are there. */
  geocodePosition?: Maybe<Array<Maybe<GeocodedAddress>>>;
  gisLayer?: Maybe<GisLayer>;
  /** Gets all GIS Layers registered in the system */
  gisLayers?: Maybe<Array<Maybe<GisLayer>>>;
  gisLayersByIds?: Maybe<Array<Maybe<GisLayer>>>;
  infringement?: Maybe<Infringement>;
  /** Get infringement candidate summaries whose Time is within a time range. */
  infringementCandidateSummariesByTimeRange?: Maybe<InfringementCandidateSummaryConnection>;
  infringementRule?: Maybe<InfringementRule>;
  /** Get all infringement rules */
  infringementRules?: Maybe<Array<Maybe<InfringementRule>>>;
  infringementRulesByIds?: Maybe<Array<Maybe<InfringementRule>>>;
  infringementSummariesByIds?: Maybe<Array<Maybe<InfringementSummary>>>;
  /** Get infringement summaries whose Time is within a time range. */
  infringementSummariesByTimeRange?: Maybe<InfringementSummaryConnection>;
  infringementSummary?: Maybe<InfringementSummary>;
  infringementsByIds?: Maybe<Array<Maybe<Infringement>>>;
  /** Get all LTO(Landing and Take-off Cycle) Aircraft Engine Mappings. */
  ltoAircraftEngineMappings?: Maybe<Array<Maybe<AircraftEngineMapping>>>;
  monitorLocation?: Maybe<MonitorLocation>;
  /** Get all monitor location summaries. */
  monitorLocationSummaries?: Maybe<MonitorLocationSummaryConnection>;
  monitorLocationSummariesByIds?: Maybe<Array<Maybe<MonitorLocationSummary>>>;
  monitorLocationSummary?: Maybe<MonitorLocationSummary>;
  /** Get all monitor locations */
  monitorLocations?: Maybe<Array<Maybe<MonitorLocation>>>;
  /** Get monitor locations that had an active device attached to them within a given time range. */
  monitorLocationsByActiveTimeRange?: Maybe<Array<Maybe<MonitorLocation>>>;
  /** Get monitor locations of AirportIds */
  monitorLocationsByAirportIds?: Maybe<Array<Maybe<MonitorLocation>>>;
  monitorLocationsByIds?: Maybe<Array<Maybe<MonitorLocation>>>;
  noiseDevice?: Maybe<NoiseDevice>;
  noiseDevicesByIds?: Maybe<Array<Maybe<NoiseDevice>>>;
  noiseEventSummariesByIds?: Maybe<Array<Maybe<NoiseEventSummary>>>;
  /** Get noise event summaries whose Time is within a time range. */
  noiseEventSummariesByTimeRange?: Maybe<NoiseEventSummaryConnection>;
  noiseEventSummary?: Maybe<NoiseEventSummary>;
  /** Get all noise modeling aircraft types, optionally filtering them based on their noise model type. */
  noiseModelingAircraftTypes?: Maybe<Array<Maybe<NoiseModelingAircraftType>>>;
  operation?: Maybe<Operation>;
  /** Get operation by passing correlationId */
  operationByCorrelationId?: Maybe<Operation>;
  operationPcaByTimeRange?: Maybe<Array<Maybe<OperationPca>>>;
  operationSummariesByIds?: Maybe<Array<Maybe<OperationSummary>>>;
  /** Get operations summaries whose Time is within a time range. */
  operationSummariesByTimeRange?: Maybe<OperationSummaryConnection>;
  operationSummary?: Maybe<OperationSummary>;
  operationsByIds?: Maybe<Array<Maybe<Operation>>>;
  /** Get operations whose Track Start and Track End Time is within a time range */
  operationsByTimeRange?: Maybe<OperationConnection>;
  periodicReport?: Maybe<PeriodicReport>;
  periodicReportsByIds?: Maybe<Array<Maybe<PeriodicReport>>>;
  /** Get periodic reports whose Time is within a time range. */
  periodicReportsByTimeRange?: Maybe<PeriodicReportConnection>;
  /** Get PhaseDefaults by scenario ids. */
  phaseDefaultsByScenarioIds?: Maybe<Array<Maybe<PhaseDefault>>>;
  privacyAgreement?: Maybe<PrivacyAgreement>;
  privacyAgreementByIds?: Maybe<Array<Maybe<PrivacyAgreement>>>;
  /** Gets the privacy agreement that is currently active. */
  privacyAgreementByIsActive?: Maybe<PrivacyAgreement>;
  /** Get runways of AirportIds  */
  runwaysByAirportIds?: Maybe<Array<Maybe<RunwayType>>>;
  scenario?: Maybe<Scenario>;
  /** Get all Scenarios. */
  scenarios?: Maybe<Array<Maybe<Scenario>>>;
  /** Takes a partial address and returns potential candidates from a geocoding API. */
  searchAddress?: Maybe<Array<Maybe<SearchAddressCandidate>>>;
  selectionZone?: Maybe<SelectionZone>;
  /** Get all selectionZones */
  selectionZones?: Maybe<Array<Maybe<SelectionZone>>>;
  selectionZonesByIds?: Maybe<Array<Maybe<SelectionZone>>>;
  /** Get configuration settings for the current product. */
  settingByDeployedProductId?: Maybe<Scalars['String']['output']>;
  /** Gets the registered spatial features for the airport, optionally filtered and sorted. */
  spatialFeatureSummaries?: Maybe<SpatialFeatureSummaryConnection>;
  /** Gets the track density, including details of the grid's corner points and the statistics relating to operations going through cells. */
  trackDensity?: Maybe<TrackDensityType>;
  /** Get the translations for the currently accessed deployed product for a supplied language. */
  translationsByLanguageTag?: Maybe<Scalars['String']['output']>;
  /** Get links to user help documentation. */
  userHelpLinks?: Maybe<Array<Maybe<UserHelpItem>>>;
};


export type QueryAirQualityAircraftMappingSummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<AirQualityAircraftMappingSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scenarioId: Scalars['ID']['input'];
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryAirQualitySummaryTableByTimeRangeArgs = {
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<AirQualityFilters>;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryAircraftArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAircraftByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAircraftFlightsByTimeRangeArgs = {
  endTime: Scalars['DateTimeOffset']['input'];
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryAircraftFuelMappingsByScenarioIdsArgs = {
  scenarioIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryAircraftMappingsByScenarioIdsArgs = {
  scenarioIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryAircraftNoiseContourArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAircraftNoiseContourUploadResultArgs = {
  jobId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAircraftNoiseContoursArgs = {
  filter?: InputMaybe<AircraftNoiseContourFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
};


export type QueryAircraftNoiseContoursByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAircraftNoiseModelingRouteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAircraftNoiseModelingRoutesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAircraftNoiseModelingScenarioArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAircraftNoiseModelingScenarioRecordArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAircraftNoiseModelingScenarioRecordSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AircraftNoiseModelingScenarioRecordSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scenarioId: Scalars['ID']['input'];
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
};


export type QueryAircraftNoiseModelingScenarioRecordSummariesByIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryAircraftNoiseModelingScenarioRecordSummaryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAircraftNoiseModelingScenarioRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAircraftToNoiseModelingTypeSummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  filter?: InputMaybe<AircraftToNoiseModelingTypeSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};


export type QueryAirlineLoadFactorByScenarioIdsArgs = {
  scenarioIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryAirlineMappingsByScenarioIdsArgs = {
  scenarioIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryAirportArgs = {
  id: Scalars['String']['input'];
};


export type QueryAirportsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryAuditLogEntrySummariesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAuditLogEntrySummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  filter?: InputMaybe<AuditLogEntrySummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};


export type QueryAuditLogEntrySummaryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryComplainerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryComplainersByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryComplainersByMostLikelyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
};


export type QueryComplainersByPartialMatchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partialFullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  returnOnlyParentRecords?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
};


export type QueryComplaintArgs = {
  id: Scalars['Int']['input'];
};


export type QueryComplaintSummariesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryComplaintSummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  filter?: InputMaybe<ComplaintSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};


export type QueryComplaintSummaryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryComplaintsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryComplaintsByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};


export type QueryContinuousNoiseSamplesByTimeRangeArgs = {
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<ContinuousNoiseSampleCollectionFilter>;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryCorridorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCorridorsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCreateAircraftNoiseModelingScenarioArgs = {
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<InputAircraftNoiseModelingScenarioFilter>;
  measurementDayPeriod?: InputMaybe<MeasurementDayPeriodInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noiseModelType: AircraftNoiseModelType;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryCreateTrackDensityArgs = {
  filter?: InputMaybe<InputTrackDensityFilterType>;
  grid?: InputMaybe<InputGrid>;
};


export type QueryCurrentUserDashboardsArgs = {
  mode?: InputMaybe<DashboardMode>;
};


export type QueryDashboardAccessTokenArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExportAircraftNoiseModelingScenarioArgs = {
  adjustments?: InputMaybe<InputAircraftNoiseModelingScenarioExportAdjustments>;
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExportDataArgs = {
  filter: ExportFilterType;
  format: ExportFormat;
  imageData?: InputMaybe<Array<InputMaybe<ImageDataType>>>;
  outputFilename?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportResultArgs = {
  key: Scalars['String']['input'];
};


export type QueryGateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGatesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGeocodeAddressArgs = {
  address: Scalars['String']['input'];
  bounds?: InputMaybe<InputGeographicCircleType>;
};


export type QueryGeocodeCandidateDetailArgs = {
  id: Scalars['String']['input'];
};


export type QueryGeocodePositionArgs = {
  position: InputPositionType;
};


export type QueryGisLayerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGisLayersByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInfringementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInfringementCandidateSummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<InfringementCandidateSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryInfringementRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInfringementRulesArgs = {
  filter?: InputMaybe<InfringementRuleFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
};


export type QueryInfringementRulesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInfringementSummariesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInfringementSummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<InfringementSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryInfringementSummaryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInfringementsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryMonitorLocationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMonitorLocationSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MonitorLocationSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
};


export type QueryMonitorLocationSummariesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryMonitorLocationSummaryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMonitorLocationsArgs = {
  filter?: InputMaybe<NoiseDeviceLocationFilter>;
};


export type QueryMonitorLocationsByActiveTimeRangeArgs = {
  endTime: Scalars['DateTimeOffset']['input'];
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryMonitorLocationsByAirportIdsArgs = {
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMonitorLocationsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNoiseDeviceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoiseDevicesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNoiseEventSummariesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNoiseEventSummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<NoiseEventSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
  timeRangeMode?: InputMaybe<TimeRangeQueryMode>;
};


export type QueryNoiseEventSummaryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoiseModelingAircraftTypesArgs = {
  modelType?: InputMaybe<AircraftNoiseModelType>;
};


export type QueryOperationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOperationByCorrelationIdArgs = {
  correlationId: Scalars['ID']['input'];
};


export type QueryOperationPcaByTimeRangeArgs = {
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<OperationFilter>;
  pcaFilter?: InputMaybe<InputPcaFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryOperationSummariesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOperationSummariesByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<OperationSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  intersectionFilter?: InputMaybe<InputIntersectionFilter>;
  pcaFilter?: InputMaybe<InputPcaFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
  timeRangeMode?: InputMaybe<TimeRangeQueryMode>;
};


export type QueryOperationSummaryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOperationsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOperationsByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<OperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  intersectionFilter?: InputMaybe<InputIntersectionFilter>;
  pcaFilter?: InputMaybe<InputPcaFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
  timeRangeMode?: InputMaybe<TimeRangeQueryMode>;
};


export type QueryPeriodicReportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeriodicReportsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeriodicReportsByTimeRangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['DateTimeOffset']['input'];
  filter?: InputMaybe<PeriodicReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
  startTime: Scalars['DateTimeOffset']['input'];
};


export type QueryPhaseDefaultsByScenarioIdsArgs = {
  scenarioIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryPrivacyAgreementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPrivacyAgreementByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryRunwaysByAirportIdsArgs = {
  airportIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryScenarioArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySearchAddressArgs = {
  address: Scalars['String']['input'];
  bounds?: InputMaybe<InputGeographicCircleType>;
};


export type QuerySelectionZoneArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySelectionZonesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySpatialFeatureSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SpatialFeatureSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>>>;
};


export type QueryTrackDensityArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTranslationsByLanguageTagArgs = {
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a range of floating point numbers bounded by nullable start and end values. */
export type RangeOfFloat = {
  __typename?: 'RangeOfFloat';
  /** The ending vaue of the range. */
  end?: Maybe<Scalars['Float']['output']>;
  /** The starting value of the range. */
  start?: Maybe<Scalars['Float']['output']>;
};

/** Specifies the way in which a emission data is filtered based on the region(domestic or international) to calculate emission columns. */
export enum Region {
  /** Represents flight operation area inside the country */
  Domestic = 'Domestic',
  /** Represents flight operation area outside the country */
  International = 'International'
}

export enum ReportInterval {
  /** Indicates that the report is a customized report. */
  Custom = 'Custom',
  /** Indicates that the report is a daily report. */
  Daily = 'Daily',
  /** Indicates that the report is an hourly report. */
  Hourly = 'Hourly',
  /** Indicates that the report is a monthly report. */
  Monthly = 'Monthly',
  /** A report that has no period, like a permanent list of items. */
  None = 'None',
  /** Indicates that the report is a quarterly report. */
  Quarterly = 'Quarterly',
  /** Indicates that the report is a weekly report (and that Monday is considered the first day of the week). */
  WeeklyMon = 'WeeklyMon',
  /** Indicates that the report is a weekly report (and that Sunday is considered the first day of the week). */
  WeeklySun = 'WeeklySun',
  /** Indicates that the report is a yearly report. */
  Yearly = 'Yearly'
}

/** Specifies methods of responding to a complainer. */
export enum ResponseMethod {
  /** Response via email. */
  Email = 'Email',
  /** Respond by sending a letter to the complainer. */
  Letter = 'Letter',
  /** No specified response method. */
  NotSet = 'NotSet',
  /** The preferred response method is none of the above, and may be recorded elsewhere within the complainer's details. */
  Other = 'Other',
  /** Respond by calling the complainer's first listed phone number. */
  Phone1 = 'Phone1',
  /** Respond by calling the complainer's second listed phone number. */
  Phone2 = 'Phone2',
  /** Respond by calling the complainer's third listed phone number. */
  Phone3 = 'Phone3',
  /** Respond by calling the complainer's fourth listed phone number. */
  Phone4 = 'Phone4'
}

/** Represents each column of summarized data */
export type RowValueCollection = {
  __typename?: 'RowValueCollection';
  /** The name of the column. */
  measure: Scalars['String']['output'];
  /** The percentage of the column's total against the total of all columns. */
  percentage: Scalars['Float']['output'];
  /** The total of all the row values in the column. */
  total: Scalars['Float']['output'];
  /** The row values for the column. */
  values: Array<Scalars['Float']['output']>;
};

export type RunwayType = {
  __typename?: 'RunwayType';
  airportId: Scalars['String']['output'];
  end?: Maybe<PositionType>;
  name: Scalars['String']['output'];
  start?: Maybe<PositionType>;
};

export enum SampleType {
  /** A sound level equivalent to the average sound energy measured over a period of time. */
  Leq = 'LEQ',
  /** A sound level that is recorded using a time weighting. */
  Level = 'Level',
  /** A perceived noise level which accounts for the fact that jet engines are perceived to be noisier than propeller aircraft. */
  Pnl = 'PNL',
  /** A tone-corrected perceived noise level which has been adjusted for the degree of irregularity that may occur among contiguous one-third-octave band sound pressure levels of aircraft noise. */
  Pnlt = 'PNLT',
  /** The type of sample is unknown. */
  Unknown = 'Unknown'
}

/** The Scenario of airquality system that various prameters involved in calculating airline/aircraft emission and related data. */
export type Scenario = {
  __typename?: 'Scenario';
  /** The ICAO code of airport. */
  airportId: Scalars['String']['output'];
  /** Flag indicating whether to apply weather adjustment or not as temperature effects the fuel consumed. */
  applyWeatherAdjustment: Scalars['Boolean']['output'];
  /** Default duration for approach phase, used as default value of approach in seconds on each runway when radar data is not available. */
  defaultDurationApproach: Scalars['Float']['output'];
  /** Default duration for climb phase, used as default value of climb in seconds on each runway when radar data is not available. */
  defaultDurationClimb: Scalars['Float']['output'];
  /** Default duration take off phase, used as default value of takeoff in seconds on each runway when radar data is not available. */
  defaultDurationTakeOff: Scalars['Float']['output'];
  /** Default duration for taxi in phase, used as default value of taxiin in seconds on each runway when radar data is not available. */
  defaultDurationTaxiIn: Scalars['Float']['output'];
  /** Default duration for taxi out, used as default value of taxiout in seconds on each runway when radar data is not available. */
  defaultDurationTaxiOut: Scalars['Float']['output'];
  /** The default load factor, which is used in calculating airquality data for per passenger and per passenger kilometer measures. */
  defaultLoadFactor: Scalars['Float']['output'];
  /** The default optimum TMA(Terminal Management Area) approach distance in kilometers. */
  defaultOptimumTMAApproachDistance: Scalars['Float']['output'];
  /** The CO2 emission factor by piston engine (avgas/aviation spirit). */
  emissionRateAvGas: Scalars['Float']['output'];
  /** The CO2 emission factor by jet and turboprops (jet fuel/aviation turbine fuel). */
  emissionRateJetFuel: Scalars['Float']['output'];
  /** The mode of CO2 emission factor by engine type to be considered. */
  emissionRateMode: Scalars['String']['output'];
  /** The single CO2 emission factor. */
  emissionRateSingle: Scalars['Float']['output'];
  /** CO2 emission factor for unknown engine type. */
  emissionRateUnknown: Scalars['Float']['output'];
  /** end time of the scenario. */
  endTime: Scalars['DateTimeOffset']['output'];
  /** Id of a scenario */
  id: Scalars['Int']['output'];
  /** Represents if a scenario is active or not. */
  isActive: Scalars['Boolean']['output'];
  /** Represents if a scenario is defult or not. */
  isDefault: Scalars['Boolean']['output'];
  /** Represents if a scenario is locked or not. */
  isLocked: Scalars['Boolean']['output'];
  /** Name of the scenario. */
  name: Scalars['String']['output'];
  /** The number of months pending on process/recalculation. */
  outstandingMonthsToProcess: Scalars['Int']['output'];
  /** Start time of the scenario. */
  startTime: Scalars['DateTimeOffset']['output'];
};

/** ScenarioInput of airquality system that various prameters involved in calculating airline/aircraft emission and related data. */
export type ScenarioInput = {
  /** Flag indicating whether to apply weather adjustment or not as temperature effects the fuel consumed. */
  applyWeatherAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default duration for approach phase, used as default value of approach in seconds on each runway when radar data is not available. */
  defaultDurationApproach?: InputMaybe<Scalars['Float']['input']>;
  /** Default duration for climb phase, used as default value of climb in seconds on each runway when radar data is not available. */
  defaultDurationClimb?: InputMaybe<Scalars['Float']['input']>;
  /** Default duration take off phase, used as default value of takeoff in seconds on each runway when radar data is not available. */
  defaultDurationTakeOff?: InputMaybe<Scalars['Float']['input']>;
  /** Default duration for taxi in phase, used as default value of taxiin in seconds on each runway when radar data is not available. */
  defaultDurationTaxiIn?: InputMaybe<Scalars['Float']['input']>;
  /** Default duration for taxi out, used as default value of taxiout in seconds on each runway when radar data is not available. */
  defaultDurationTaxiOut?: InputMaybe<Scalars['Float']['input']>;
  /** Default load factor, which is used in calculating airquality data for per passenger and per passenger kilometer measures. */
  defaultLoadFactor?: InputMaybe<Scalars['Float']['input']>;
  /** The default optimum TMA(Terminal Management Area) approach distance in kilometers. */
  defaultOptimumTMAApproachDistance?: InputMaybe<Scalars['Float']['input']>;
  /** The CO2 emission factor by piston engine (avgas/aviation spirit). */
  emissionRateAvGas?: InputMaybe<Scalars['Float']['input']>;
  /** The CO2 emission factor by jet and turboprops (jet fuel/aviation turbine fuel). */
  emissionRateJetFuel?: InputMaybe<Scalars['Float']['input']>;
  /** The mode of CO2 emission factor by engine type to be considered. */
  emissionRateMode?: InputMaybe<Scalars['String']['input']>;
  /** The single CO2 emission factor. */
  emissionRateSingle?: InputMaybe<Scalars['Float']['input']>;
  /** The CO2 emission factor for unknown engine type. */
  emissionRateUnknown?: InputMaybe<Scalars['Float']['input']>;
  /** End time of the scenario. */
  endTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  /** Id of a scenario */
  id: Scalars['Int']['input'];
  /** Represents if a scenario is active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents if a scenario is defult or not. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Represents if a scenario is locked or not. */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the scenario. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Start time of the scenario. */
  startTime?: InputMaybe<Scalars['DateTimeOffset']['input']>;
};

/** Describes an address candidate returned by an address geocoding service. */
export type SearchAddressCandidate = {
  __typename?: 'SearchAddressCandidate';
  /** The full formatted address of the location. */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** A unique address identifier, used to get the positional information and other details. */
  id?: Maybe<Scalars['String']['output']>;
};

export type SelectionZone = {
  /** The time the selection zone was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the group to which the selection zone belongs. */
  groupName: Scalars['String']['output'];
  /** The id of the selection zone. */
  id: Scalars['Int']['output'];
  /** Indicates whether the selection zone is active and will process data. */
  isActive: Scalars['Boolean']['output'];
  /** The last time the selection zone was updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the selection zone. */
  name: Scalars['String']['output'];
  /** The type of selection zone. */
  selectionZoneType?: Maybe<SelectionZoneType>;
};

export enum SelectionZoneType {
  /** Represents a cone type. */
  Cone = 'Cone',
  /** Represents a cylinder type. */
  Cylinder = 'Cylinder',
  /** Represents a hemisphere type. */
  Hemisphere = 'Hemisphere',
  /** Represents a polygon type. */
  Polygon = 'Polygon'
}

/** Provides fields for updating a single settings record.  Ensure you set the appropriate Value property for the setting that is being updated. */
export type SettingInput = {
  /** Sets the value of a boolean array-based property. */
  boolArrayValue?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  /** Sets the value of a boolean-based property. */
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sets the value of a date/time array-based property. */
  dateTimeArrayValue?: InputMaybe<Array<InputMaybe<Scalars['DateTimeOffset']['input']>>>;
  /** Sets the value of a date/time-based property. */
  dateTimeValue?: InputMaybe<Scalars['DateTimeOffset']['input']>;
  /** Sets the value of a double array-based property. */
  doubleArrayValue?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** Sets the value of a double precision floating point-based property. */
  doubleValue?: InputMaybe<Scalars['Float']['input']>;
  /** Sets the value of an integer array-based property. */
  intArrayValue?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Sets the value of an integer-based property. */
  intValue?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the setting you are changing. */
  parameter: Scalars['String']['input'];
  /** Sets the value of a string array-based property. */
  stringArrayValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sets the value of a string-based property. */
  stringValue?: InputMaybe<Scalars['String']['input']>;
  /** The new value of the setting. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a single spatial feature row for display in a table- or grid-like component. */
export type SpatialFeatureSummary = {
  __typename?: 'SpatialFeatureSummary';
  /** The time that the spatial feature was created. */
  createTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The id of the associated spatial feature. */
  featureId: Scalars['Int']['output'];
  /** The type of the associated spatial feature. */
  featureType?: Maybe<SpatialFeatureType>;
  /** The name of the group to which the spatial feature belongs. */
  groupName: Scalars['String']['output'];
  /** Indicates whether the associated spatial feature is currently active and processing intersections with operations. */
  isActive: Scalars['Boolean']['output'];
  /** The time that the spatial feature was last updated. */
  lastUpdateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
  /** The name of the associated spatial feature. */
  name: Scalars['String']['output'];
  /**
   * The time that the spatial feature was last updated.
   * @deprecated This has been deprecated please use LastUpdateTime instead.
   */
  updateTime?: Maybe<Scalars['DateTimeOffset']['output']>;
};

/** A connection from an object to a list of objects of type `SpatialFeatureSummary`. */
export type SpatialFeatureSummaryConnection = {
  __typename?: 'SpatialFeatureSummaryConnection';
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<SpatialFeatureSummaryEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<SpatialFeatureSummary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `SpatialFeatureSummary`. */
export type SpatialFeatureSummaryEdge = {
  __typename?: 'SpatialFeatureSummaryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SpatialFeatureSummary>;
};

/** Defines properties to filter queried SpatialFeatureSummary objects by. */
export type SpatialFeatureSummaryFilter = {
  /** A list of spatial feature types to retrieve as part of the filter. */
  featureTypes?: InputMaybe<Array<InputMaybe<SpatialFeatureType>>>;
  /** A list of spatial feature group names to retrieve as part of the filter. */
  groupNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter returned spatial features by whether they are active or not. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of spatial feature names to retrieve as part of the filter. */
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum SpatialFeatureType {
  /** A corridor spatial feature type. */
  Corridor = 'Corridor',
  /** A gate spatial feature type. */
  Gate = 'Gate',
  /** A selection zone spatial feature type. */
  SelectionZone = 'SelectionZone'
}

/** Represents data for selected timerange applying filters, columnGrouping and rowGrouping. */
export type SummaryTable = {
  __typename?: 'SummaryTable';
  /** Represents group by to generate the set of columns presented in the data. */
  columnGrouping: Scalars['String']['output'];
  /** Lists the columns with summarized data. */
  columns?: Maybe<Array<Maybe<Column>>>;
  /** Represents to metric to calculate the summarized data */
  measures: Array<Scalars['String']['output']>;
  /** Represents period that each row is summarized over. */
  rowGrouping: Array<Scalars['String']['output']>;
};

/** A label that can be attached to similar data objects to allow them to be grouped together. */
export type Tag = {
  __typename?: 'Tag';
  /** Some tags are used for indicating that work needs to be done on them - for these tags the IsCompleted flag indicates the work is either completed or not completed. */
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the tag. */
  name: Scalars['String']['output'];
  /** The unique id of the definition of the tag registered in the system. */
  tagId: Scalars['Int']['output'];
};

/** Allows data model queries to specify how to apply a query time range when fetching data. */
export enum TimeRangeQueryMode {
  /** Returns records whose end time falls within the start and end of the query time range. */
  EndTime = 'EndTime',
  /** Returns records where their active time (the period between their start and end times) is either entirely contained within, or partially overlaps with, the query time range. */
  InFlight = 'InFlight',
  /** Returns records whose primary time falls within the start and end of the query time range. */
  PrimaryTime = 'PrimaryTime',
  /** Returns records whose start time falls within the start and end of the query time range. */
  StartTime = 'StartTime'
}

export enum TimeWeighting {
  /** An exponential time weighting with a 125 millisecond rise and decay time. */
  FastWeighted = 'FastWeighted',
  /** An exponential time weighting 35 millisecond rise and 1.5 second decay time. */
  ImpulseWeighted = 'ImpulseWeighted',
  /** No time weighting applied. */
  None = 'None',
  /** The maximum instantaneous sound pressure during a measurement period. */
  Peak = 'Peak',
  /** An exponential time weighting with a 1 second rise and decay time. */
  SlowWeighted = 'SlowWeighted',
  /** The type of time weighting is unknown . */
  Unknown = 'Unknown'
}

export type TrackDensityType = {
  __typename?: 'TrackDensityType';
  /** The grid on which the track density is based. */
  grid?: Maybe<Grid>;
  /** The unique id of the track density. */
  id?: Maybe<Scalars['ID']['output']>;
  /** The value of the cell with the maximum count of tracks that have passed through it. */
  maxOperationCellCount: Scalars['Int']['output'];
  /** The status of the generation process; one of InProgress, Completed, Cancelled or Error. */
  status: Scalars['String']['output'];
  /** The total count of operations that have been assessed by the track density. */
  totalOperations: Scalars['Int']['output'];
};

export type TrackPoint = {
  __typename?: 'TrackPoint';
  /** The altitude of the track point in feet above mean sea level (AMSL). */
  alt?: Maybe<Scalars['Float']['output']>;
  /** The latitude of the track point, in decimal degrees. */
  lat: Scalars['Float']['output'];
  /** The longitude of the track point, in the decimal degrees. */
  lon: Scalars['Float']['output'];
  /** The number of seconds since the start of the track. */
  t: Scalars['Float']['output'];
};

export type TrackProfilePoint = {
  __typename?: 'TrackProfilePoint';
  altitude: Scalars['Float']['output'];
  distance: Scalars['Float']['output'];
  timeOffset: Scalars['Float']['output'];
};

export type TrackSegment = {
  __typename?: 'TrackSegment';
  duration: Scalars['Seconds']['output'];
  endDistance: Scalars['Float']['output'];
  endPosition?: Maybe<PositionType>;
  endTime: Scalars['DateTimeOffset']['output'];
  length: Scalars['Float']['output'];
  operationId: Scalars['Int']['output'];
  startDistance: Scalars['Float']['output'];
  startPosition?: Maybe<PositionType>;
  startTime: Scalars['DateTimeOffset']['output'];
};

export type UriResource = {
  __typename?: 'UriResource';
  authenticationScheme?: Maybe<AuthenticationScheme>;
  uri: Scalars['String']['output'];
};

/** A file used to deliver user help. */
export type UserHelpItem = {
  __typename?: 'UserHelpItem';
  /** A link that can be used to access the help item. */
  downloadResource?: Maybe<UriResource>;
  /** The type of file that the help item is, such as a PDF or MP4, and always in upper case. */
  fileType: Scalars['String']['output'];
  /** The time the help item was last modified. */
  lastModified: Scalars['DateTimeOffset']['output'];
  /** The friendly name of the help item that could, for example, be displayed to the user of an application. */
  name: Scalars['String']['output'];
  /** The path or folder name of the help item, such as an application may use for collating similar topics. */
  path: Scalars['String']['output'];
};

export type VectorLayerType = GisLayer & {
  __typename?: 'VectorLayerType';
  fillColor?: Maybe<Color>;
  /** The format of the GIS Layer, such as KML, GeoJson, PBF. */
  format: Scalars['String']['output'];
  /** The id of the GIS Layer. */
  id: Scalars['Int']['output'];
  lineColor?: Maybe<Color>;
  lineWidth?: Maybe<Scalars['Float']['output']>;
  /** The maximum zoom level at which the GIS layer should be made visible; a null value indicates there is no maximum zoom level. */
  maxZoomLevel?: Maybe<Scalars['Boolean']['output']>;
  /** The minimum zoom level at which the GIS layer should be made visible; a null value indicates there is no minimum zoom level. */
  minZoomLevel?: Maybe<Scalars['Boolean']['output']>;
  /** The display name of the GIS Layer. */
  name: Scalars['String']['output'];
  /** Indicates whether the GIS Layer is visible (turned on) or not. */
  visible: Scalars['Boolean']['output'];
};

export type GetComplainerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetComplainerQuery = { __typename?: 'Query', complainer?: { __typename?: 'Complainer', id: number, title?: string | null, firstName?: string | null, email?: string | null, middleName?: string | null, lastName?: string | null, comments?: string | null, preferredResponseMethod?: ResponseMethod | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumberType', number: string } | null> | null, address?: { __typename?: 'AddressType', country?: string | null, city?: string | null, postcode?: string | null, state?: string | null, streetAddress?: string | null, streetAddress2?: string | null, position?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null } | null } | null };

export type ComplaintSummariesByTimeRangeQueryVariables = Exact<{
  startTime: Scalars['DateTimeOffset']['input'];
  endTime: Scalars['DateTimeOffset']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ComplaintSummaryFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>> | InputMaybe<OrderByType>>;
}>;


export type ComplaintSummariesByTimeRangeQuery = { __typename?: 'Query', complaintSummariesByTimeRange?: { __typename?: 'ComplaintSummaryConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, items?: Array<{ __typename?: 'ComplaintSummaryType', id: number, time: any, status: string, acid?: string | null, runwayName?: string | null, aircraftCategory?: AircraftCategory | null, aircraftType?: string | null, airline?: string | null, complainerName?: string | null, complainerId: number, operatorCategory?: OperatorCategory | null, contactMethod?: ContactMethod | null, complainerPostcode?: string | null, disturbanceTypes?: Array<string | null> | null, operationId?: number | null, complainerPosition?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null, complainer?: { __typename?: 'Complainer', email?: string | null, preferredResponseMethod?: ResponseMethod | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumberType', number: string } | null> | null, address?: { __typename?: 'AddressType', streetAddress?: string | null, streetAddress2?: string | null, city?: string | null, country?: string | null, state?: string | null, postcode?: string | null } | null } | null } | null> | null } | null };

export type GetGateIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGateIdsQuery = { __typename?: 'Query', gates?: Array<{ __typename?: 'GateType', id: number, name: string } | null> | null };

export type GetGateGeometryQueryVariables = Exact<{
  gateIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetGateGeometryQuery = { __typename?: 'Query', gatesByIds?: Array<{ __typename?: 'GateType', id: number, name: string, geometry?: { __typename?: 'GateGeometryType', ceilingAltitude: number, floorAltitude: number, rightPosition?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null, leftPosition?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null, anchorPosition?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null } | null } | null> | null };

export type GetInfringementsQueryVariables = Exact<{
  startTime: Scalars['DateTimeOffset']['input'];
  endTime: Scalars['DateTimeOffset']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InfringementSummaryFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>> | InputMaybe<OrderByType>>;
  includeOperationTags: Scalars['Boolean']['input'];
}>;


export type GetInfringementsQuery = { __typename?: 'Query', infringementSummariesByTimeRange?: { __typename?: 'InfringementSummaryConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, items?: Array<{ __typename?: 'InfringementSummary', id: number, operationId: number, infringementType?: InfringementType | null, ruleId: number, ruleName: string, status?: string | null, aircraftType?: string | null, aircraftCategory?: AircraftCategory | null, acid: string, time: any, airportId?: string | null, severity: string, operationType?: OperationType | null, position?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null, detail?: { __typename?: 'CcoInfringement', id: number } | { __typename?: 'CdoInfringement', id: number } | { __typename?: 'CorridorInfringement', corridorId: number, id: number } | { __typename?: 'CurfewInfringement', id: number } | { __typename?: 'ExclusionInfringement', selectionZoneId: number, id: number } | { __typename?: 'GateInfringement', gateId: number, gateDirection?: GateDirection | null, speed?: number | null, reason?: GateInfringementReason | null, id: number } | { __typename?: 'MinHeightInfringement', id: number } | { __typename?: 'NoiseInfringement', noiseEventIds?: Array<number | null> | null, id: number } | null, operationTags?: Array<{ __typename?: 'Tag', tagId: number, name: string, isCompleted?: boolean | null } | null> | null } | null> | null } | null };

export type GetInfringementCandidatesQueryVariables = Exact<{
  startTime: Scalars['DateTimeOffset']['input'];
  endTime: Scalars['DateTimeOffset']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<InfringementCandidateSummaryFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>> | InputMaybe<OrderByType>>;
}>;


export type GetInfringementCandidatesQuery = { __typename?: 'Query', infringementCandidateSummariesByTimeRange?: { __typename?: 'InfringementCandidateSummaryConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, items?: Array<{ __typename?: 'InfringementCandidateSummary', operationId: number, infringementType?: InfringementType | null, ruleId: number, ruleName: string, status?: string | null, aircraftType?: string | null, aircraftCategory?: AircraftCategory | null, acid: string, isInfringement: boolean, time: any, airportId?: string | null, severity?: string | null, operationType?: OperationType | null, infringementId?: number | null, detail?: { __typename?: 'CcoInfringement', id: number } | { __typename?: 'CdoInfringement', id: number } | { __typename?: 'CorridorInfringement', corridorId: number, id: number } | { __typename?: 'CurfewInfringement', id: number } | { __typename?: 'ExclusionInfringement', selectionZoneId: number, id: number } | { __typename?: 'GateInfringement', gateId: number, gateDirection?: GateDirection | null, speed?: number | null, reason?: GateInfringementReason | null, id: number } | { __typename?: 'MinHeightInfringement', id: number } | { __typename?: 'NoiseInfringement', noiseEventIds?: Array<number | null> | null, id: number } | null, position?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null, rule?: { __typename?: 'CcoInfringementRule' } | { __typename?: 'CdoInfringementRule' } | { __typename?: 'CorridorInfringementRule', corridorId: number } | { __typename?: 'CurfewInfringementRule' } | { __typename?: 'ExclusionInfringementRule' } | { __typename?: 'GateInfringementRule' } | { __typename?: 'MinHeightInfringementRule' } | { __typename?: 'NoiseInfringementRule' } | null } | null> | null } | null };

export type GetNoiseEventsQueryVariables = Exact<{
  startTime: Scalars['DateTimeOffset']['input'];
  endTime: Scalars['DateTimeOffset']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<NoiseEventSummaryFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>> | InputMaybe<OrderByType>>;
}>;


export type GetNoiseEventsQuery = { __typename?: 'Query', noiseEventSummariesByTimeRange?: { __typename?: 'NoiseEventSummaryConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, items?: Array<{ __typename?: 'NoiseEventSummary', acid?: string | null, aircraftCategory?: AircraftCategory | null, aircraftType?: string | null, classification?: NoiseEventClass | null, duration: number, endTime: any, epnl?: number | null, id: number, locationId: number, locationName: string, maxLevel: number, operationType?: OperationType | null, operationId?: number | null, sel: number, startTime: any, threshold: number, time: any, audio?: { __typename?: 'NoiseEventAudio', id: number, startTime: any, endTime: any, resourceUri?: { __typename?: 'UriResource', uri: string } | null } | null, samples?: { __typename?: 'NoiseEventSampleCollection', samples?: Array<number | null> | null } | null, tags?: Array<{ __typename?: 'Tag', name: string, isCompleted?: boolean | null } | null> | null } | null> | null } | null };

export type GetOperationsQueryVariables = Exact<{
  startTime: Scalars['DateTimeOffset']['input'];
  endTime: Scalars['DateTimeOffset']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OperationSummaryFilter>;
  sort?: InputMaybe<Array<InputMaybe<OrderByType>> | InputMaybe<OrderByType>>;
  position: InputPositionType;
  includePca: Scalars['Boolean']['input'];
  intersectionFilter?: InputMaybe<InputIntersectionFilter>;
  gateIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  hasGateIds: Scalars['Boolean']['input'];
}>;


export type GetOperationsQuery = { __typename?: 'Query', operationSummariesByTimeRange?: { __typename?: 'OperationSummaryConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, items?: Array<{ __typename?: 'OperationSummary', id: number, acid: string, operationType?: OperationType | null, operatorCategory?: OperatorCategory | null, aircraftCategory?: AircraftCategory | null, aircraftType?: string | null, aircraftCount?: number | null, airportId?: string | null, endTime: any, remoteAirportId?: string | null, runwayName?: string | null, startTime: any, time: any, pca?: { __typename?: 'OperationPca', elevationAngle: number, horizontalDistance: number, slantDistance: number, time: any, verticalDistance: number, trackPoint?: { __typename?: 'TrackPoint', alt?: number | null, lat: number, lon: number, t: number } | null } | null, correlated?: { __typename?: 'OperationCorrelation', infringements?: Array<{ __typename?: 'InfringementSummary', infringementType?: InfringementType | null, id: number, time: any } | null> | null, noiseEvents?: Array<{ __typename?: 'NoiseEventSummary', id: number, time: any } | null> | null, complaints?: Array<{ __typename?: 'ComplaintSummaryType', id: number, time: any } | null> | null } | null, gateIntersections?: Array<{ __typename?: 'GateIntersectionInfo', time?: any | null, direction?: GateDirection | null, deviationX: number, deviationY: number, velocity: number, position?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null, gate?: { __typename?: 'GateType', id: number, name: string, geometry?: { __typename?: 'GateGeometryType', ceilingAltitude: number, floorAltitude: number, leftPosition?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null, rightPosition?: { __typename?: 'PositionType', altitude?: number | null, latitude: number, longitude: number } | null } | null } | null } | null> | null } | null> | null } | null };


export const GetComplainerDocument = gql`
    query GetComplainer($id: Int!) {
  complainer(id: $id) {
    id
    title
    firstName
    email
    middleName
    lastName
    comments
    preferredResponseMethod
    phoneNumbers {
      number
    }
    address {
      country
      city
      postcode
      state
      streetAddress
      streetAddress2
      position {
        altitude
        latitude
        longitude
      }
    }
  }
}
    `;
export type GetComplainerQueryResult = ApolloReactCommon.QueryResult<GetComplainerQuery, GetComplainerQueryVariables>;
export const ComplaintSummariesByTimeRangeDocument = gql`
    query complaintSummariesByTimeRange($startTime: DateTimeOffset!, $endTime: DateTimeOffset!, $first: Int, $filter: ComplaintSummaryFilter, $sort: [OrderByType]) {
  complaintSummariesByTimeRange(
    startTime: $startTime
    endTime: $endTime
    first: $first
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    items {
      id
      time
      status
      acid
      runwayName
      aircraftCategory
      aircraftType
      airline
      complainerName
      complainerId
      operatorCategory
      contactMethod
      complainerPosition {
        altitude
        latitude
        longitude
      }
      complainerPostcode
      disturbanceTypes
      operationId
      complainer {
        email
        preferredResponseMethod
        phoneNumbers {
          number
        }
        address {
          streetAddress
          streetAddress2
          city
          country
          state
          postcode
        }
      }
    }
  }
}
    `;
export type ComplaintSummariesByTimeRangeQueryResult = ApolloReactCommon.QueryResult<ComplaintSummariesByTimeRangeQuery, ComplaintSummariesByTimeRangeQueryVariables>;
export const GetGateIdsDocument = gql`
    query getGateIds {
  gates {
    id
    name
  }
}
    `;
export type GetGateIdsQueryResult = ApolloReactCommon.QueryResult<GetGateIdsQuery, GetGateIdsQueryVariables>;
export const GetGateGeometryDocument = gql`
    query getGateGeometry($gateIds: [Int!]!) {
  gatesByIds(ids: $gateIds) {
    id
    name
    geometry {
      ceilingAltitude
      floorAltitude
      rightPosition {
        altitude
        latitude
        longitude
      }
      leftPosition {
        altitude
        latitude
        longitude
      }
      anchorPosition {
        altitude
        latitude
        longitude
      }
    }
  }
}
    `;
export type GetGateGeometryQueryResult = ApolloReactCommon.QueryResult<GetGateGeometryQuery, GetGateGeometryQueryVariables>;
export const GetInfringementsDocument = gql`
    query getInfringements($startTime: DateTimeOffset!, $endTime: DateTimeOffset!, $first: Int, $after: String, $filter: InfringementSummaryFilter, $sort: [OrderByType], $includeOperationTags: Boolean!) {
  infringementSummariesByTimeRange(
    startTime: $startTime
    endTime: $endTime
    first: $first
    after: $after
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    items {
      id
      operationId
      infringementType
      ruleId
      ruleName
      status
      aircraftType
      aircraftCategory
      acid
      time
      airportId
      position {
        altitude
        latitude
        longitude
      }
      severity
      operationType
      detail {
        id
        ... on CorridorInfringement {
          corridorId
        }
        ... on ExclusionInfringement {
          selectionZoneId
        }
        ... on GateInfringement {
          gateId
          gateDirection
          speed
          reason
        }
        ... on NoiseInfringement {
          noiseEventIds
        }
      }
      operationTags(returnOnly: ["Vector"]) @include(if: $includeOperationTags) {
        tagId
        name
        isCompleted
      }
    }
  }
}
    `;
export type GetInfringementsQueryResult = ApolloReactCommon.QueryResult<GetInfringementsQuery, GetInfringementsQueryVariables>;
export const GetInfringementCandidatesDocument = gql`
    query getInfringementCandidates($startTime: DateTimeOffset!, $endTime: DateTimeOffset!, $first: Int, $filter: InfringementCandidateSummaryFilter, $sort: [OrderByType]) {
  infringementCandidateSummariesByTimeRange(
    startTime: $startTime
    endTime: $endTime
    first: $first
    sort: $sort
    filter: $filter
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    items {
      operationId
      infringementType
      ruleId
      ruleName
      status
      aircraftType
      aircraftCategory
      acid
      detail {
        id
        ... on CorridorInfringement {
          corridorId
        }
        ... on ExclusionInfringement {
          selectionZoneId
        }
        ... on GateInfringement {
          gateId
          gateDirection
          speed
          reason
        }
        ... on NoiseInfringement {
          noiseEventIds
        }
      }
      isInfringement
      time
      airportId
      position {
        altitude
        latitude
        longitude
      }
      severity
      operationType
      infringementId
      rule {
        ... on CorridorInfringementRule {
          corridorId
        }
      }
    }
  }
}
    `;
export type GetInfringementCandidatesQueryResult = ApolloReactCommon.QueryResult<GetInfringementCandidatesQuery, GetInfringementCandidatesQueryVariables>;
export const GetNoiseEventsDocument = gql`
    query GetNoiseEvents($startTime: DateTimeOffset!, $endTime: DateTimeOffset!, $first: Int, $filter: NoiseEventSummaryFilter, $sort: [OrderByType]) {
  noiseEventSummariesByTimeRange(
    startTime: $startTime
    endTime: $endTime
    first: $first
    filter: $filter
    sort: $sort
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    items {
      acid
      aircraftCategory
      aircraftType
      audio {
        id
        startTime
        endTime
        resourceUri {
          uri
        }
      }
      classification
      duration
      endTime
      epnl
      id
      locationId
      locationName
      maxLevel
      operationType
      operationId
      samples {
        samples
      }
      sel
      startTime
      threshold
      time
      tags {
        name
        isCompleted
      }
    }
  }
}
    `;
export type GetNoiseEventsQueryResult = ApolloReactCommon.QueryResult<GetNoiseEventsQuery, GetNoiseEventsQueryVariables>;
export const GetOperationsDocument = gql`
    query getOperations($startTime: DateTimeOffset!, $endTime: DateTimeOffset!, $first: Int, $filter: OperationSummaryFilter, $sort: [OrderByType], $position: InputPositionType!, $includePca: Boolean!, $intersectionFilter: InputIntersectionFilter, $gateIds: [Int]!, $hasGateIds: Boolean!) {
  operationSummariesByTimeRange(
    startTime: $startTime
    endTime: $endTime
    first: $first
    sort: $sort
    filter: $filter
    intersectionFilter: $intersectionFilter
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    items {
      id
      acid
      operationType
      operatorCategory
      aircraftCategory
      aircraftType
      aircraftCount
      airportId
      endTime
      remoteAirportId
      runwayName
      startTime
      time
      pca(position: $position) @include(if: $includePca) {
        elevationAngle
        horizontalDistance
        slantDistance
        time
        trackPoint {
          alt
          lat
          lon
          t
        }
        verticalDistance
      }
      correlated {
        infringements {
          infringementType
          id
          time
        }
        noiseEvents {
          id
          time
        }
        complaints {
          id
          time
        }
      }
      gateIntersections(gateIds: $gateIds) @include(if: $hasGateIds) {
        time
        direction
        position {
          altitude
          latitude
          longitude
        }
        gate {
          id
          name
          geometry {
            ceilingAltitude
            floorAltitude
            leftPosition {
              altitude
              latitude
              longitude
            }
            rightPosition {
              altitude
              latitude
              longitude
            }
          }
        }
        deviationX
        deviationY
        velocity
      }
    }
  }
}
    `;
export type GetOperationsQueryResult = ApolloReactCommon.QueryResult<GetOperationsQuery, GetOperationsQueryVariables>;